/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		9: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({}[chunkId]||chunkId) + ".chunk.min.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	__webpack_require__.p = typeof window !== 'undefined' && window.__STATICS_BASE_URL__ || __webpack_require__.p;
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 91);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Wix = __webpack_require__(14);

var _require = __webpack_require__(16),
    addTimeout = _require.addTimeout,
    createSafeCall = _require.createSafeCall;

var WixSdk = exports.WixSdk = function () {
  var errorLogger = function errorLogger(ex) {
    if (global.console && typeof global.console.error === 'function') {
      console.error(ex);
    }
  };

  if (!Wix) {
    errorLogger(new Error('Wix Sdk is missing'));
    return null;
  }

  var safeCall = createSafeCall(function (ex) {
    errorLogger(ex);
  });

  var WixSdk = {
    valid: false,
    config: {
      setErrorLogger: function setErrorLogger(handler) {
        errorLogger = handler;
      }
    },
    Activities: {
      Type: Wix.Activities.Type,
      Error: Wix.Activities.Error,
      postActivity: function postActivity(activity) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Activities.postActivity(activity, resolve, reject);
        }));
      },
      getActivities: function getActivities(query) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Activities.getActivities(resolve, reject, query);
        }));
      },
      getActivityById: function getActivityById(id) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Activities.getActivityById(id, resolve, reject);
        }));
      },
      getUserSessionToken: function getUserSessionToken() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Activities.getUserSessionToken(resolve);
        }));
      }
    },
    Analytics: {
      PixelType: Wix.Analytics.PixelType,
      PixelEventType: Wix.Analytics.PixelEventType,
      registerCampaignPixel: Wix.Analytics.registerCampaignPixel,
      reportCampaignEvent: Wix.Analytics.reportCampaignEvent
    },
    Billing: {
      Cycle: Wix.Billing.Cycle,
      openBillingPageForProduct: function openBillingPageForProduct(vendorProductId, cycle) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Billing.openBillingPageForProduct(vendorProductId, cycle, reject);
        }));
      },
      getBillingPageForProduct: function getBillingPageForProduct(vendorProductId, cycle) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Billing.getBillingPageForProduct(vendorProductId, cycle, resolve, reject);
        }));
      },
      getBillingPackages: function getBillingPackages(vendorProductIds) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Billing.getBillingPackages(vendorProductIds, resolve, reject);
        }));
      },
      getProducts: function getProducts(options) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Billing.getProducts(options, resolve, reject);
        }));
      }
    },
    Contacts: {
      getContacts: function getContacts(options) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Contacts.getContacts(options, resolve, reject);
        }));
      },
      getContactById: function getContactById(id) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Contacts.getContactById(id, resolve, reject);
        }));
      },
      reconcileContact: function reconcileContact(contactInfo) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Contacts.reconcileContact(contactInfo, resolve, reject);
        }));
      }
    },
    Dashboard: {
      PremiumIntent: Wix.Dashboard.PremiumIntent,
      setHeight: Wix.Dashboard.setHeight,
      openMediaDialog: function openMediaDialog(mediaType, multipleSelection, onCancel) {
        return new Promise(function (resolve) {
          Wix.Dashboard.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
        });
      },

      openBillingPage: Wix.Dashboard.openBillingPage,
      openModal: function openModal(url, width, height) {
        return new Promise(function (resolve) {
          Wix.Dashboard.openModal(url, width, height, resolve);
        });
      },

      closeWindow: Wix.Dashboard.closeWindow,
      scrollTo: Wix.Dashboard.scrollTo,
      getEditorUrl: function getEditorUrl() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Dashboard.getEditorUrl(resolve);
        }));
      },

      pushState: Wix.Dashboard.pushState,
      resizeWindow: Wix.Dashboard.resizeWindow,
      revalidateSession: function revalidateSession() {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Dashboard.revalidateSession(resolve, reject);
        }));
      },
      getProducts: function getProducts() {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Dashboard.getProducts(resolve, reject);
        }));
      },
      getSiteViewUrl: function getSiteViewUrl(options) {
        return addTimeout(new Promise(function (resolve) {
          Wix.Dashboard.getSiteViewUrl(options, resolve);
        }));
      },

      appEngaged: Wix.Dashboard.appEngaged
    },
    Error: Wix.Error,
    Events: Wix.Events,
    Features: {
      Types: Wix.Features.Types,
      isSupported: function isSupported(featureName) {
        return addTimeout(new Promise(function (resolve) {
          Wix.Features.isSupported(featureName, resolve);
        }));
      }
    },
    Media: {
      AudioType: Wix.Media.AudioType,
      getImageUrl: Wix.Media.getImageUrl,
      getResizedImageUrl: Wix.Media.getResizedImageUrl,
      getAudioUrl: Wix.Media.getAudioUrl,
      getDocumentUrl: Wix.Media.getDocumentUrl,
      getSwfUrl: Wix.Media.getSwfUrl,
      getPreviewSecureMusicUrl: Wix.Media.getPreviewSecureMusicUrl
    },
    PubSub: {
      unsubscribe: Wix.PubSub.unsubscribe,
      subscribe: Wix.PubSub.subscribe,
      publish: Wix.PubSub.publish
    },
    Preview: {
      openSettingsDialog: Wix.Preview.openSettingsDialog
    },
    Settings: {
      MediaType: Wix.Settings.MediaType,
      PremiumIntent: Wix.Settings.PremiumIntent,
      getColorByreference: Wix.Settings.getColorByreference,
      setBooleanParam: Wix.Settings.setBooleanParam,
      setColorParam: Wix.Settings.setColorParam,
      setNumberParam: Wix.Settings.setNumberParam,
      getSiteColors: function getSiteColors() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getSiteColors(resolve);
        }));
      },

      getStyleColorByKey: Wix.Settings.getStyleColorByKey,
      getWindowPlacement: function getWindowPlacement(compId) {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getWindowPlacement(compId, resolve);
        }));
      },
      getDashboardAppUrl: function getDashboardAppUrl() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getDashboardAppUrl(resolve);
        }));
      },
      getSiteInfo: function getSiteInfo() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getSiteInfo(resolve);
        }));
      },
      getSitePages: function getSitePages(options) {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getSitePages(options, resolve);
        }));
      },
      getSiteMap: function getSiteMap() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getSiteMap(resolve);
        }));
      },
      getStyleParams: function getStyleParams() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getStyleParams(resolve);
        }));
      },

      openBillingPage: Wix.Settings.openBillingPage,
      appEngaged: Wix.Settings.appEngaged,
      openMediaDialog: function openMediaDialog(mediaType, multipleSelection, onCancel) {
        return new Promise(function (resolve) {
          Wix.Settings.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
        });
      },

      openSiteMembersSettingsDialog: Wix.Settings.openSiteMembersSettingsDialog,
      refreshApp: Wix.Settings.refreshApp,
      refreshAppByCompIds: Wix.Settings.refreshAppByCompIds,
      setWindowPlacement: Wix.Settings.setWindowPlacement,
      triggerSettingsUpdatedEvent: Wix.Settings.triggerSettingsUpdatedEvent,
      openModal: function openModal(url, width, height, title, bareUI) {
        return new Promise(function (resolve) {
          Wix.Settings.openModal(url, width, height, title, resolve, bareUI);
        });
      },

      closeWindow: Wix.Settings.closeWindow,
      addComponent: function addComponent(options) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Settings.addComponent(options, resolve, reject);
        }));
      },
      resizeComponent: function resizeComponent(options) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Settings.resizeComponent(options, resolve, reject);
        }));
      },
      setExternalId: function setExternalId(guid) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Settings.setExternalId(guid, resolve, reject);
        }));
      },
      revalidateSession: function revalidateSession() {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Settings.revalidateSession(resolve, reject);
        }));
      },
      getCurrentPageAnchors: function getCurrentPageAnchors() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getCurrentPageAnchors(resolve);
        }));
      },
      setFullWidth: function setFullWidth(shouldBeFullWidth, options) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Settings.setFullWidth(shouldBeFullWidth, options, resolve, reject);
        }));
      },
      isFullWidth: function isFullWidth() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.isFullWidth(resolve);
        }));
      },

      openReviewInfo: Wix.Settings.openReviewInfo,
      getStateUrl: function getStateUrl(sectionId, state) {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getStateUrl(sectionId, state, resolve);
        }));
      },
      isComponentInstalled: function isComponentInstalled(componentId) {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.isComponentInstalled(componentId, resolve);
        }));
      },
      openLinkPanel: function openLinkPanel(options, onCacnel) {
        return new Promise(function (resolve) {
          Wix.Settings.openLinkPanel(options, resolve, onCacnel);
        });
      }
    },
    Styles: {
      getStyleParams: function getStyleParams() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Styles.getStyleParams(resolve);
        }));
      },
      setStyleParams: function setStyleParams(styleObjArr) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Styles.setStyleParams(styleObjArr, resolve, reject);
        }));
      },
      setFontParam: function setFontParam(key, value) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Styles.setFontParam(key, value, resolve, reject);
        }));
      },
      getEditorFonts: function getEditorFonts() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Styles.getEditorFonts(resolve);
        }));
      },
      getSiteTextPresets: function getSiteTextPresets() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Styles.getSiteTextPresets(resolve);
        }));
      },
      getFontsSpriteUrl: function getFontsSpriteUrl() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Styles.getFontsSpriteUrl(resolve);
        }));
      },

      getStyleFontByKey: Wix.Styles.getStyleFontByKey,
      getStyleFontByReference: Wix.Styles.getStyleFontByReference,
      getSiteColors: function getSiteColors() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Styles.getSiteColors(resolve);
        }));
      },

      getStyleColorByKey: Wix.Styles.getStyleColorByKey,
      getColorByreference: Wix.Styles.getColorByreference,
      setColorParam: function setColorParam(key, value) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Styles.setColorParam(key, value, resolve, reject);
        }));
      },
      setNumberParam: function setNumberParam(key, value) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Styles.setNumberParam(key, value, resolve, reject);
        }));
      },
      setBooleanParam: function setBooleanParam(key, value) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Styles.setBooleanParam(key, value, resolve, reject);
        }));
      },
      openColorPicker: function openColorPicker(params) {
        return new Promise(function (resolve) {
          Wix.Styles.openColorPicker(params, resolve);
        });
      },
      openFontPicker: function openFontPicker(params) {
        return new Promise(function (resolve) {
          Wix.Styles.openFontPicker(params, resolve);
        });
      },

      setUILIBParamValue: Wix.Styles.setUILIBParamValue,
      getStyleId: function getStyleId() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Styles.getStyleId(resolve);
        }));
      },
      getStyleParamsByStyleId: function getStyleParamsByStyleId(styleId) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Styles.getStyleParamsByStyleId(styleId, resolve, reject);
        }));
      }
    },
    Theme: Wix.Theme,
    Utils: {
      getViewMode: safeCall(Wix.Utils.getViewMode),
      toWixDate: safeCall(Wix.Utils.toWixDate),
      getCompId: safeCall(Wix.Utils.getCompId),
      getOrigCompId: safeCall(Wix.Utils.getOrigCompId),
      getWidth: safeCall(Wix.Utils.getWidth),
      getLocale: safeCall(Wix.Utils.getLocale),
      getCacheKiller: safeCall(Wix.Utils.getCacheKiller),
      getTarget: safeCall(Wix.Utils.getTarget),
      getSectionUrl: function getSectionUrl(sectionIdentifier) {
        return addTimeout(new Promise(function (resolve) {
          Wix.Utils.getSectionUrl(sectionIdentifier, resolve);
        }));
      },

      getInstanceId: safeCall(Wix.Utils.getInstanceId),
      getSignDate: safeCall(Wix.Utils.getSignDate),
      getUid: safeCall(Wix.Utils.getUid),
      getPermissions: safeCall(Wix.Utils.getPermissions),
      getIpAndPort: safeCall(Wix.Utils.getIpAndPort),
      getDemoMode: safeCall(Wix.Utils.getDemoMode),
      getDeviceType: safeCall(Wix.Utils.getDeviceType),
      getInstanceValue: safeCall(Wix.Utils.getInstanceValue),
      navigateToSection: safeCall(Wix.Utils.navigateToSection),
      getSiteOwnerId: safeCall(Wix.Utils.getSiteOwnerId),
      Media: {
        AudioType: Wix.Utils.Media.AudioType,
        getImageUrl: Wix.Utils.Media.getImageUrl,
        getResizedImageUrl: Wix.Utils.Media.getResizedImageUrl,
        getAudioUrl: Wix.Utils.Media.getAudioUrl,
        getDocumentUrl: Wix.Utils.Media.getDocumentUrl,
        getSwfUrl: Wix.Utils.Media.getSwfUrl,
        getPreviewSecureMusicUrl: Wix.Utils.Media.getPreviewSecureMusicUrl
      }
    },
    Data: {
      SCOPE: Wix.Data.SCOPE,
      Public: {
        set: function set(key, value, options) {
          return addTimeout(new Promise(function (resolve, reject) {
            Wix.Data.Public.set(key, value, options, resolve, reject);
          }));
        },
        get: function get(key, value, options) {
          return addTimeout(new Promise(function (resolve, reject) {
            Wix.Data.Public.get(key, options, resolve, reject);
          }));
        },
        remove: function remove(key, value, options) {
          return addTimeout(new Promise(function (resolve, reject) {
            Wix.Data.Public.remove(key, options, resolve, reject);
          }));
        }
      }
    },
    Performance: {
      applicationLoaded: Wix.Performance.applicationLoaded,
      applicationLoadingStep: Wix.Performance.applicationLoadingStep
    },
    WindowOrigin: Wix.WindowOrigin,
    WindowPlacement: Wix.WindowPlacement,
    openModal: function openModal(url, width, height, theme) {
      return new Promise(function (resolve) {
        Wix.openModal(url, width, height, resolve, theme);
      });
    },
    openPopup: function openPopup(url, width, height, position, theme) {
      return new Promise(function (resolve) {
        Wix.openPopup(url, width, height, position, resolve, theme);
      });
    },

    setHeight: Wix.setHeight,
    closeWindow: Wix.closeWindow,
    scrollTo: Wix.scrollTo,
    scrollBy: Wix.scrollBy,
    getSiteInfo: function getSiteInfo() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getSiteInfo(resolve);
      }));
    },
    getSitePages: function getSitePages(options) {
      return addTimeout(new Promise(function (resolve) {
        Wix.getSitePages(options, resolve);
      }));
    },
    getSiteMap: function getSiteMap() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getSiteMap(resolve);
      }));
    },
    getBoundingRectAndOffsets: function getBoundingRectAndOffsets() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getBoundingRectAndOffsets(resolve);
      }));
    },

    removeEventListener: Wix.removeEventListener,
    addEventListener: Wix.addEventListener,
    resizeWindow: Wix.resizeWindow,
    requestLogin: function requestLogin(options, onCancel) {
      return new Promise(function (resolve) {
        Wix.requestLogin(options, resolve, onCancel);
      });
    },
    logOutCurrentMember: function logOutCurrentMember(options) {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.logOutCurrentMember(options, reject);
      }));
    },
    currentMember: function currentMember() {
      return addTimeout(new Promise(function (resolve) {
        Wix.currentMember(resolve);
      }));
    },
    navigateTo: function navigateTo(linkData) {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.navigateTo(linkData, reject);
      }));
    },
    navigateToPage: function navigateToPage(pageId, options) {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.navigateToPage(pageId, options, reject);
      }));
    },
    getCurrentPageId: function getCurrentPageId() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getCurrentPageId(resolve);
      }));
    },

    pushState: Wix.pushState,
    reportHeightChange: Wix.reportHeightChange,
    getStyleParams: function getStyleParams() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getStyleParams(resolve);
      }));
    },
    getExternalId: function getExternalId() {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.getExternalId(resolve, reject);
      }));
    },
    navigateToComponent: function navigateToComponent(compId, options) {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.navigateToComponent(compId, options, reject);
      }));
    },
    resizeComponent: function resizeComponent(options) {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.resizeComponent(options, resolve, reject);
      }));
    },
    revalidateSession: function revalidateSession() {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.revalidateSession(resolve, reject);
      }));
    },
    getCurrentPageAnchors: function getCurrentPageAnchors() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getCurrentPageAnchors(resolve);
      }));
    },
    navigateToAnchor: function navigateToAnchor(anchorId) {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.navigateToAnchor(anchorId, reject);
      }));
    },
    getComponentInfo: function getComponentInfo() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getComponentInfo(resolve);
      }));
    },

    replaceSectionState: Wix.replaceSectionState,
    setPageMetadata: Wix.setPageMetadata,
    getStateUrl: function getStateUrl(sectionId, state) {
      return addTimeout(new Promise(function (resolve) {
        Wix.getStateUrl(sectionId, state, resolve);
      }));
    },
    getAdsOnPage: function getAdsOnPage() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getAdsOnPage(resolve);
      }));
    }
  };

  if (Wix.SuperApps) {
    WixSdk = _extends({}, WixSdk, {
      SuperApps: {
        Settings: {
          MediaType: Wix.SuperApps.Settings.MediaType,
          openBillingPage: Wix.SuperApps.Settings.openBillingPage,
          getInstalledInstance: function getInstalledInstance(appDefinitionId) {
            return addTimeout(new Promise(function (resolve, reject) {
              Wix.SuperApps.Settings.getInstalledInstance(appDefinitionId, resolve, reject);
            }));
          },
          openMediaDialog: function openMediaDialog(mediaType, multipleSelection, onCancel) {
            return new Promise(function (resolve) {
              Wix.SuperApps.Settings.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
            });
          },
          openModal: function openModal(url, width, height, title, bareUI, options) {
            return new Promise(function (resolve) {
              Wix.SuperApps.Settings.openModal(url, width, height, title, resolve, bareUI, options);
            });
          },

          setHelpArticle: Wix.SuperApps.Settings.setHelpArticle
        },
        Dashboard: {
          showHeader: Wix.SuperApps.Dashboard.showHeader,
          hideHeader: Wix.SuperApps.Dashboard.hideHeader,
          setHelpArticle: Wix.SuperApps.Dashboard.setHelpArticle,
          getProducts: function getProducts(options) {
            return addTimeout(new Promise(function (resolve, reject) {
              Wix.SuperApps.Dashboard.getProducts(options, resolve, reject);
            }));
          },
          openMediaDialog: function openMediaDialog(mediaType, multipleSelection, onCancel) {
            return new Promise(function (resolve) {
              Wix.SuperApps.Dashboard.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
            });
          }
        },
        getInstalledInstance: function getInstalledInstance(appDefinitionId) {
          return addTimeout(new Promise(function (resolve, reject) {
            Wix.SuperApps.getInstalledInstance(appDefinitionId, resolve, reject);
          }));
        },

        OnBoarding: {
          Settings: {
            getStyleByCompId: function getStyleByCompId(compId) {
              return addTimeout(new Promise(function (resolve) {
                Wix.SuperApps.OnBoarding.Settings.getStyleByCompId(compId, resolve);
              }));
            }
          }
        },
        Billing: {
          getProducts: function getProducts(options) {
            return addTimeout(new Promise(function (resolve, reject) {
              Wix.SuperApps.Billing.getProducts(options, resolve, reject);
            }));
          }
        },
        getCtToken: function getCtToken() {
          return addTimeout(new Promise(function (resolve) {
            Wix.SuperApps.getCtToken(resolve);
          }));
        }
      },
      getInstalledInstance: function getInstalledInstance(appDefinitionId) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.getInstalledInstance(appDefinitionId, resolve, reject);
        }));
      },

      OnBoarding: {
        Settings: {
          getStyleByCompId: function getStyleByCompId(compId) {
            return addTimeout(new Promise(function (resolve) {
              Wix.OnBoarding.Settings.getStyleByCompId(compId, resolve);
            }));
          }
        }
      },
      getCtToken: function getCtToken() {
        return addTimeout(new Promise(function (resolve) {
          Wix.getCtToken(resolve);
        }));
      }
    });
  }
  return WixSdk;
}();
//# sourceMappingURL=wix-sdk-wrapper.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(4);
var cls = __webpack_require__(21);
var defaultSettings = __webpack_require__(67);
var dom = __webpack_require__(9);
var EventManager = __webpack_require__(64);
var guid = __webpack_require__(65);

var instances = {};

function Instance(element) {
  var i = this;

  i.settings = _.clone(defaultSettings);
  i.containerWidth = null;
  i.containerHeight = null;
  i.contentWidth = null;
  i.contentHeight = null;

  i.isRtl = dom.css(element, 'direction') === "rtl";
  i.isNegativeScroll = (function () {
    var originalScrollLeft = element.scrollLeft;
    var result = null;
    element.scrollLeft = -1;
    result = element.scrollLeft < 0;
    element.scrollLeft = originalScrollLeft;
    return result;
  })();
  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
  i.event = new EventManager();
  i.ownerDocument = element.ownerDocument || document;

  function focus() {
    cls.add(element, 'ps-focus');
  }

  function blur() {
    cls.remove(element, 'ps-focus');
  }

  i.scrollbarXRail = dom.appendTo(dom.e('div', 'ps-scrollbar-x-rail'), element);
  i.scrollbarX = dom.appendTo(dom.e('div', 'ps-scrollbar-x'), i.scrollbarXRail);
  i.scrollbarX.setAttribute('tabindex', 0);
  i.event.bind(i.scrollbarX, 'focus', focus);
  i.event.bind(i.scrollbarX, 'blur', blur);
  i.scrollbarXActive = null;
  i.scrollbarXWidth = null;
  i.scrollbarXLeft = null;
  i.scrollbarXBottom = _.toInt(dom.css(i.scrollbarXRail, 'bottom'));
  i.isScrollbarXUsingBottom = i.scrollbarXBottom === i.scrollbarXBottom; // !isNaN
  i.scrollbarXTop = i.isScrollbarXUsingBottom ? null : _.toInt(dom.css(i.scrollbarXRail, 'top'));
  i.railBorderXWidth = _.toInt(dom.css(i.scrollbarXRail, 'borderLeftWidth')) + _.toInt(dom.css(i.scrollbarXRail, 'borderRightWidth'));
  // Set rail to display:block to calculate margins
  dom.css(i.scrollbarXRail, 'display', 'block');
  i.railXMarginWidth = _.toInt(dom.css(i.scrollbarXRail, 'marginLeft')) + _.toInt(dom.css(i.scrollbarXRail, 'marginRight'));
  dom.css(i.scrollbarXRail, 'display', '');
  i.railXWidth = null;
  i.railXRatio = null;

  i.scrollbarYRail = dom.appendTo(dom.e('div', 'ps-scrollbar-y-rail'), element);
  i.scrollbarY = dom.appendTo(dom.e('div', 'ps-scrollbar-y'), i.scrollbarYRail);
  i.scrollbarY.setAttribute('tabindex', 0);
  i.event.bind(i.scrollbarY, 'focus', focus);
  i.event.bind(i.scrollbarY, 'blur', blur);
  i.scrollbarYActive = null;
  i.scrollbarYHeight = null;
  i.scrollbarYTop = null;
  i.scrollbarYRight = _.toInt(dom.css(i.scrollbarYRail, 'right'));
  i.isScrollbarYUsingRight = i.scrollbarYRight === i.scrollbarYRight; // !isNaN
  i.scrollbarYLeft = i.isScrollbarYUsingRight ? null : _.toInt(dom.css(i.scrollbarYRail, 'left'));
  i.scrollbarYOuterWidth = i.isRtl ? _.outerWidth(i.scrollbarY) : null;
  i.railBorderYWidth = _.toInt(dom.css(i.scrollbarYRail, 'borderTopWidth')) + _.toInt(dom.css(i.scrollbarYRail, 'borderBottomWidth'));
  dom.css(i.scrollbarYRail, 'display', 'block');
  i.railYMarginHeight = _.toInt(dom.css(i.scrollbarYRail, 'marginTop')) + _.toInt(dom.css(i.scrollbarYRail, 'marginBottom'));
  dom.css(i.scrollbarYRail, 'display', '');
  i.railYHeight = null;
  i.railYRatio = null;
}

function getId(element) {
  return element.getAttribute('data-ps-id');
}

function setId(element, id) {
  element.setAttribute('data-ps-id', id);
}

function removeId(element) {
  element.removeAttribute('data-ps-id');
}

exports.add = function (element) {
  var newId = guid();
  setId(element, newId);
  instances[newId] = new Instance(element);
  return instances[newId];
};

exports.remove = function (element) {
  delete instances[getId(element)];
  removeId(element);
};

exports.get = function (element) {
  return instances[getId(element)];
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var CircularJSON = __webpack_require__(22);
var bi_1 = __webpack_require__(12);
var send_event_1 = __webpack_require__(10);
var functions_1 = __webpack_require__(3);
function addNewRelicAttributes() {
    if (typeof newrelic === 'undefined') {
        return;
    }
    var wixParams = send_event_1.getWixParams();
    newrelic.setCustomAttribute('uid', wixParams.userId);
    newrelic.setCustomAttribute('componentId', wixParams.compId);
    newrelic.setCustomAttribute('instanceId', wixParams.instanceId);
    newrelic.setCustomAttribute('isOwner', wixParams.isOwner);
    newrelic.setCustomAttribute('biToken', wixParams.biToken);
}
exports.addNewRelicAttributes = addNewRelicAttributes;
function getNewRelicAttrs() {
    var wixParams = send_event_1.getWixParams();
    return {
        uid: wixParams.userId,
        componentId: wixParams.compId,
        instanceId: wixParams.instanceId,
        isOwner: wixParams.isOwner,
        biToken: wixParams.biToken,
    };
}
function logError(errorDescription, arg0) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (!errorDescription) {
        console.error('Invalid argument to log error');
        logErrorToNewRelic('Invalid argument to log error');
        return;
    }
    console.error.apply(console, ['Wix Music Error: ', errorDescription.name || errorDescription, arg0 && arg0.reason || arg0].concat(args)); //eslint-disable-line no-console
    if (errorDescription.name && errorDescription.id) {
        bi_1.reportBiError(errorDescription, arg0);
    }
    else {
        bi_1.reportBiError({ id: 1999, name: 'unhandled-error' });
    }
    logErrorToNewRelic(errorDescription, arg0);
}
exports.logError = logError;
var playerStartedFired = false;
function logPlayerStarted() {
    if (typeof newrelic === 'undefined' || playerStartedFired) {
        return;
    }
    newrelic.addPageAction('player-started');
    newrelic.finished();
    playerStartedFired = true;
}
exports.logPlayerStarted = logPlayerStarted;
function logMetricToNewRelic(eventName, args) {
    if (typeof newrelic === 'undefined') {
        return;
    }
    newrelic.addPageAction(eventName, args);
    newrelic.addToTrace(__assign({ eventName: eventName }, args));
}
exports.logMetricToNewRelic = logMetricToNewRelic;
function serialiseReason(reason) {
    if (!reason) {
        return reason;
    }
    if (reason instanceof Error) {
        return {
            name: reason.name,
            message: reason.message,
            stack: reason.stack
        };
    }
    if (reason instanceof Event) {
        return {
            type: reason.type,
            className: reason.constructor && reason.constructor.name
        };
    }
    return {
        'typeof': typeof reason,
        className: reason.constructor && reason.constructor.name
    };
}
function logErrorToNewRelic(description, opts) {
    if (opts === void 0) { opts = {}; }
    if (typeof newrelic === 'undefined') {
        return;
    }
    var options = __assign({ type: 'custom', message: description }, getNewRelicAttrs(), opts, { reason: serialiseReason(opts.reason), reasonText: functions_1.safe(CircularJSON.stringify)(opts.reason) });
    if (description.name && description.id) {
        options = __assign({}, options, { type: 'bi', message: description.name, biId: description.id, biName: description.name });
        if (description.severity) {
            options.biSeverity = description.severity;
        }
    }
    if (opts.reason instanceof Error) {
        options = __assign({}, options, { errorName: opts.reason.name, errorMessage: opts.reason.message });
    }
    newrelic.addPageAction('error', options);
    newrelic.noticeError(getError(description, options));
}
function getError(description, options) {
    try {
        if (description.error) {
            description.error();
        }
        else {
            throw new Error(options.message);
        }
    }
    catch (ex) {
        return ex;
    }
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        var later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}
exports.debounce = debounce;
function noop() {
    // do nothing
}
exports.noop = noop;
function safe(fn, defaultValue) {
    if (defaultValue === void 0) { defaultValue = undefined; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (ex) {
            return defaultValue;
        }
    };
}
exports.safe = safe;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cls = __webpack_require__(21);
var dom = __webpack_require__(9);

var toInt = exports.toInt = function (x) {
  return parseInt(x, 10) || 0;
};

var clone = exports.clone = function (obj) {
  if (!obj) {
    return null;
  } else if (obj.constructor === Array) {
    return obj.map(clone);
  } else if (typeof obj === 'object') {
    var result = {};
    for (var key in obj) {
      result[key] = clone(obj[key]);
    }
    return result;
  } else {
    return obj;
  }
};

exports.extend = function (original, source) {
  var result = clone(original);
  for (var key in source) {
    result[key] = clone(source[key]);
  }
  return result;
};

exports.isEditable = function (el) {
  return dom.matches(el, "input,[contenteditable]") ||
         dom.matches(el, "select,[contenteditable]") ||
         dom.matches(el, "textarea,[contenteditable]") ||
         dom.matches(el, "button,[contenteditable]");
};

exports.removePsClasses = function (element) {
  var clsList = cls.list(element);
  for (var i = 0; i < clsList.length; i++) {
    var className = clsList[i];
    if (className.indexOf('ps-') === 0) {
      cls.remove(element, className);
    }
  }
};

exports.outerWidth = function (element) {
  return toInt(dom.css(element, 'width')) +
         toInt(dom.css(element, 'paddingLeft')) +
         toInt(dom.css(element, 'paddingRight')) +
         toInt(dom.css(element, 'borderLeftWidth')) +
         toInt(dom.css(element, 'borderRightWidth'));
};

exports.startScrolling = function (element, axis) {
  cls.add(element, 'ps-in-scrolling');
  if (typeof axis !== 'undefined') {
    cls.add(element, 'ps-' + axis);
  } else {
    cls.add(element, 'ps-x');
    cls.add(element, 'ps-y');
  }
};

exports.stopScrolling = function (element, axis) {
  cls.remove(element, 'ps-in-scrolling');
  if (typeof axis !== 'undefined') {
    cls.remove(element, 'ps-' + axis);
  } else {
    cls.remove(element, 'ps-x');
    cls.remove(element, 'ps-y');
  }
};

exports.env = {
  isWebKit: 'WebkitAppearance' in document.documentElement.style,
  supportsTouch: (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch),
  supportsIePointer: window.navigator.msMaxTouchPoints !== null
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(4);
var cls = __webpack_require__(21);
var dom = __webpack_require__(9);
var instances = __webpack_require__(1);
var updateScroll = __webpack_require__(7);

function getThumbSize(i, thumbSize) {
  if (i.settings.minScrollbarLength) {
    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
  }
  if (i.settings.maxScrollbarLength) {
    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
  }
  return thumbSize;
}

function updateCss(element, i) {
  var xRailOffset = {width: i.railXWidth};
  if (i.isRtl) {
    xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
  } else {
    xRailOffset.left = element.scrollLeft;
  }
  if (i.isScrollbarXUsingBottom) {
    xRailOffset.bottom = i.scrollbarXBottom - element.scrollTop;
  } else {
    xRailOffset.top = i.scrollbarXTop + element.scrollTop;
  }
  dom.css(i.scrollbarXRail, xRailOffset);

  var yRailOffset = {top: element.scrollTop, height: i.railYHeight};
  if (i.isScrollbarYUsingRight) {
    if (i.isRtl) {
      yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    }
  } else {
    if (i.isRtl) {
      yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    }
  }
  dom.css(i.scrollbarYRail, yRailOffset);

  dom.css(i.scrollbarX, {left: i.scrollbarXLeft, width: i.scrollbarXWidth - i.railBorderXWidth});
  dom.css(i.scrollbarY, {top: i.scrollbarYTop, height: i.scrollbarYHeight - i.railBorderYWidth});
}

module.exports = function (element) {
  var i = instances.get(element);

  i.containerWidth = element.clientWidth;
  i.containerHeight = element.clientHeight;
  i.contentWidth = element.scrollWidth;
  i.contentHeight = element.scrollHeight;

  var existingRails;
  if (!element.contains(i.scrollbarXRail)) {
    existingRails = dom.queryChildren(element, '.ps-scrollbar-x-rail');
    if (existingRails.length > 0) {
      existingRails.forEach(function (rail) {
        dom.remove(rail);
      });
    }
    dom.appendTo(i.scrollbarXRail, element);
  }
  if (!element.contains(i.scrollbarYRail)) {
    existingRails = dom.queryChildren(element, '.ps-scrollbar-y-rail');
    if (existingRails.length > 0) {
      existingRails.forEach(function (rail) {
        dom.remove(rail);
      });
    }
    dom.appendTo(i.scrollbarYRail, element);
  }

  if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
    i.scrollbarXActive = true;
    i.railXWidth = i.containerWidth - i.railXMarginWidth;
    i.railXRatio = i.containerWidth / i.railXWidth;
    i.scrollbarXWidth = getThumbSize(i, _.toInt(i.railXWidth * i.containerWidth / i.contentWidth));
    i.scrollbarXLeft = _.toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
  } else {
    i.scrollbarXActive = false;
  }

  if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
    i.scrollbarYActive = true;
    i.railYHeight = i.containerHeight - i.railYMarginHeight;
    i.railYRatio = i.containerHeight / i.railYHeight;
    i.scrollbarYHeight = getThumbSize(i, _.toInt(i.railYHeight * i.containerHeight / i.contentHeight));
    i.scrollbarYTop = _.toInt(element.scrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
  } else {
    i.scrollbarYActive = false;
  }

  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
  }
  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
  }

  updateCss(element, i);

  if (i.scrollbarXActive) {
    cls.add(element, 'ps-active-x');
  } else {
    cls.remove(element, 'ps-active-x');
    i.scrollbarXWidth = 0;
    i.scrollbarXLeft = 0;
    updateScroll(element, 'left', 0);
  }
  if (i.scrollbarYActive) {
    cls.add(element, 'ps-active-y');
  } else {
    cls.remove(element, 'ps-active-y');
    i.scrollbarYHeight = 0;
    i.scrollbarYTop = 0;
    updateScroll(element, 'top', 0);
  }
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BI_ERRORS = {
    tpa: {
        wix: {
            siteInfo: {
                get: {
                    id: 1501,
                    name: 'tpa.wix.siteInfo.get',
                    error: function () {
                        throw new Error(this.name);
                    }
                }
            },
            activities: {
                getUserSessionToken: {
                    id: 1501,
                    name: 'tpa.wix.activities.getUserSessionToken',
                    error: function () {
                        throw new Error(this.name);
                    }
                }
            },
        }
    },
    widget: {
        unhandled: {
            rejection: {
                id: 1501,
                name: 'widget.unhandled.rejection',
                error: function () {
                    throw new Error(this.name);
                }
            }
        },
        statistic: {
            activity: {
                send: {
                    id: 1501,
                    name: 'widget.statistic.activity.send',
                    error: function () {
                        throw new Error(this.name);
                    }
                }
            },
            counters: {
                emptyCtToken: {
                    id: 1502,
                    name: 'widget.statistic.counters.emptyCtToken',
                    severity: 30,
                    error: function () {
                        throw new Error(this.name);
                    }
                },
                send: { id: 1005, name: 'widget.statistic.counters.send' }
            }
        },
        content: {
            scripts: {
                wix: {
                    id: 1502,
                    name: 'widget.content.scripts.wix',
                    error: function () {
                        throw new Error(this.name);
                    }
                },
                player: {
                    id: 1503,
                    name: 'widget.content.scripts.player',
                    error: function () {
                        throw new Error(this.name);
                    }
                },
                coreJs: {
                    id: 1503,
                    name: 'widget.content.scripts.coreJs',
                    error: function () {
                        throw new Error(this.name);
                    }
                }
            }
        },
        init: {
            initial: {
                id: 1504,
                name: 'widget.init.initial',
                error: function () {
                    throw new Error(this.name);
                }
            },
            reinit: {
                id: 1505,
                name: 'widget.init.reinit',
                error: function () {
                    throw new Error(this.name);
                }
            },
            statisticSubscribe: {
                id: 1506,
                name: 'widget.init.statisticSubscribe',
                error: function () {
                    throw new Error(this.name);
                }
            }
        }
    }
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var instances = __webpack_require__(1);

var lastTop;
var lastLeft;

var createDOMEvent = function (name) {
  var event = document.createEvent("Event");
  event.initEvent(name, true, true);
  return event;
};

module.exports = function (element, axis, value) {
  if (typeof element === 'undefined') {
    throw 'You must provide an element to the update-scroll function';
  }

  if (typeof axis === 'undefined') {
    throw 'You must provide an axis to the update-scroll function';
  }

  if (typeof value === 'undefined') {
    throw 'You must provide a value to the update-scroll function';
  }

  if (axis === 'top' && value <= 0) {
    element.scrollTop = value = 0; // don't allow negative scroll
    element.dispatchEvent(createDOMEvent('ps-y-reach-start'));
  }

  if (axis === 'left' && value <= 0) {
    element.scrollLeft = value = 0; // don't allow negative scroll
    element.dispatchEvent(createDOMEvent('ps-x-reach-start'));
  }

  var i = instances.get(element);

  if (axis === 'top' && value >= i.contentHeight - i.containerHeight) {
    // don't allow scroll past container
    value = i.contentHeight - i.containerHeight;
    if (value - element.scrollTop <= 1) {
      // mitigates rounding errors on non-subpixel scroll values
      value = element.scrollTop;
    } else {
      element.scrollTop = value;
    }
    element.dispatchEvent(createDOMEvent('ps-y-reach-end'));
  }

  if (axis === 'left' && value >= i.contentWidth - i.containerWidth) {
    // don't allow scroll past container
    value = i.contentWidth - i.containerWidth;
    if (value - element.scrollLeft <= 1) {
      // mitigates rounding errors on non-subpixel scroll values
      value = element.scrollLeft;
    } else {
      element.scrollLeft = value;
    }
    element.dispatchEvent(createDOMEvent('ps-x-reach-end'));
  }

  if (!lastTop) {
    lastTop = element.scrollTop;
  }

  if (!lastLeft) {
    lastLeft = element.scrollLeft;
  }

  if (axis === 'top' && value < lastTop) {
    element.dispatchEvent(createDOMEvent('ps-scroll-up'));
  }

  if (axis === 'top' && value > lastTop) {
    element.dispatchEvent(createDOMEvent('ps-scroll-down'));
  }

  if (axis === 'left' && value < lastLeft) {
    element.dispatchEvent(createDOMEvent('ps-scroll-left'));
  }

  if (axis === 'left' && value > lastLeft) {
    element.dispatchEvent(createDOMEvent('ps-scroll-right'));
  }

  if (axis === 'top') {
    element.scrollTop = lastTop = value;
    element.dispatchEvent(createDOMEvent('ps-scroll-y'));
  }

  if (axis === 'left') {
    element.scrollLeft = lastLeft = value;
    element.dispatchEvent(createDOMEvent('ps-scroll-x'));
  }

};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createParam = createParam;
function createParam() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object.keys(obj).map(function (key) {
    var value = obj[key];
    if (value === undefined) {
      return undefined;
    }
    return key + '=' + encodeURIComponent(value);
  }).filter(Boolean).join('&');
}
//# sourceMappingURL=url.js.map


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DOM = {};

DOM.e = function (tagName, className) {
  var element = document.createElement(tagName);
  element.className = className;
  return element;
};

DOM.appendTo = function (child, parent) {
  parent.appendChild(child);
  return child;
};

function cssGet(element, styleName) {
  return window.getComputedStyle(element)[styleName];
}

function cssSet(element, styleName, styleValue) {
  if (typeof styleValue === 'number') {
    styleValue = styleValue.toString() + 'px';
  }
  element.style[styleName] = styleValue;
  return element;
}

function cssMultiSet(element, obj) {
  for (var key in obj) {
    var val = obj[key];
    if (typeof val === 'number') {
      val = val.toString() + 'px';
    }
    element.style[key] = val;
  }
  return element;
}

DOM.css = function (element, styleNameOrObject, styleValue) {
  if (typeof styleNameOrObject === 'object') {
    // multiple set with object
    return cssMultiSet(element, styleNameOrObject);
  } else {
    if (typeof styleValue === 'undefined') {
      return cssGet(element, styleNameOrObject);
    } else {
      return cssSet(element, styleNameOrObject, styleValue);
    }
  }
};

DOM.matches = function (element, query) {
  if (typeof element.matches !== 'undefined') {
    return element.matches(query);
  } else {
    if (typeof element.matchesSelector !== 'undefined') {
      return element.matchesSelector(query);
    } else if (typeof element.webkitMatchesSelector !== 'undefined') {
      return element.webkitMatchesSelector(query);
    } else if (typeof element.mozMatchesSelector !== 'undefined') {
      return element.mozMatchesSelector(query);
    } else if (typeof element.msMatchesSelector !== 'undefined') {
      return element.msMatchesSelector(query);
    }
  }
};

DOM.remove = function (element) {
  if (typeof element.remove !== 'undefined') {
    element.remove();
  } else {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
};

DOM.queryChildren = function (element, selector) {
  return Array.prototype.filter.call(element.childNodes, function (child) {
    return DOM.matches(child, selector);
  });
};

module.exports = DOM;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* global WMP */
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_sdk_wrapper_1 = __webpack_require__(0);
var activities_1 = __webpack_require__(26);
var bi_1 = __webpack_require__(12);
var counters_1 = __webpack_require__(27);
function getWixParams() {
    var getters = {
        compId: function () { return js_sdk_wrapper_1.WixSdk.Utils.getCompId(); },
        userId: function () { return js_sdk_wrapper_1.WixSdk.Utils.getUid(); },
        visitorId: function () { return WMP.wixUtils.getVisitorId(); },
        instanceId: function () { return WMP.wixUtils.getInstanceId(); },
        biToken: function () { return WMP.wixUtils.getBiToken(); },
        siteOwnerId: function () { return js_sdk_wrapper_1.WixSdk.Utils.getSiteOwnerId(); },
        isOwner: function () { return js_sdk_wrapper_1.WixSdk.Utils.getUid() === js_sdk_wrapper_1.WixSdk.Utils.getSiteOwnerId(); }
    };
    return Object.keys(getters).reduce(function (_options, key) {
        try {
            _options[key] = getters[key]();
        }
        catch (ex) {
            console.warn("Cannot get param " + key, ex); // eslint-disable-line no-console
        }
        return _options;
    }, {});
}
exports.getWixParams = getWixParams;
function logPlayerEvents(eventEmitter, options) {
    options = __assign({}, options, getWixParams());
    var loggers = [
        activities_1.logToActivities,
        bi_1.logToBi,
        counters_1.logToCounters,
    ];
    loggers.forEach(function (logger) {
        try {
            logger(eventEmitter, options);
        }
        catch (ex) {
            console.error('Cannot initialize logger', ex); // eslint-disable-line no-console
        }
    });
}
exports.logPlayerEvents = logPlayerEvents;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function subscribeToEmitter(eventEmitter, events, listener) {
    Object.keys(events).forEach(function (eventName) {
        eventEmitter.on(eventName, function (args) {
            listener(eventName, events[eventName], args);
        });
    });
}
exports.subscribeToEmitter = subscribeToEmitter;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_sdk_wrapper_1 = __webpack_require__(0);
var functions_1 = __webpack_require__(3);
var send_event_1 = __webpack_require__(10);
var subscribe_to_emitter_1 = __webpack_require__(11);
function reportBiError(errorDescription, _a) {
    if (_a === void 0) { _a = {}; }
    var reason = _a.reason, errorParams = __rest(_a, ["reason"]);
    var _b = send_event_1.getWixParams(), visitorId = _b.visitorId, biToken = _b.biToken, instanceId = _b.instanceId;
    var params = __assign({}, errorParams, { src: 9, evid: 10, cat: 1, iss: 1, errc: errorDescription.id, errn: errorDescription.name, sev: errorDescription.severity, app_id: instanceId, msid: biToken, cid: visitorId });
    sendEvents('trg', params);
}
exports.reportBiError = reportBiError;
function sendEvents(adapter, params) {
    params = __assign({ _: Number(new Date()) }, params);
    var paramsStr = Object.keys(params)
        .filter(function (key) {
        return params[key] !== undefined;
    })
        .map(function (key) {
        var value = encodeURIComponent(params[key]);
        return key + "=" + value;
    })
        .join('&');
    var url = "//frog.wix.com/" + adapter + "?" + paramsStr;
    var img = new Image();
    // IF core js was not loaded
    var PromisePolyfilled = typeof Promise === 'undefined' ? PromiseStub : Promise;
    return new PromisePolyfilled(function (resolve, reject) {
        img.onload = resolve;
        img.onerror = reject;
        img.src = url;
    });
}
var playerStartedFired = false;
function logToBi(statisticsEvents, _a) {
    var isOwner = _a.isOwner, biToken = _a.biToken, instanceId = _a.instanceId, compId = _a.compId, visitorId = _a.visitorId;
    var events = {
        playerStarted: {
            id: 189,
            name: 'player.pageOpened',
            params: function (_a) {
                var album = _a.album, loading_time = _a.loading_time;
                return { albumID: album.id, loading_time: loading_time };
            }
        },
        trackPlayStart: {
            id: 190,
            name: 'player.track.played',
            params: baseTrackData
        },
        trackSkipped: {
            id: 191,
            name: 'player.track.skipped',
            params: baseTrackData
        },
        trackPlayCompleted: {
            id: 192,
            name: 'player.track.completed',
            params: baseTrackData
        },
        trackPurchaseClicked: {
            id: 194,
            name: 'player.track.purchase.clicked',
            params: function (args) { return (__assign({}, baseTrackData(args), { price: (args.track.trackPrice * 10000).toFixed(0), currency: args.album.currency })); }
        },
        trackShareClicked: {
            id: 202,
            name: 'player.track.shared',
            params: function (args) { return (__assign({}, baseTrackData(args), { socialNetwork: args.network })); }
        },
        albumPlayCompleted: {
            id: 196,
            name: 'player.album.playComplete',
            params: baseAlbumData
        },
        albumPurchaseClicked: {
            id: 198,
            name: 'player.album.purchase.clicked',
            params: function (args) { return (__assign({}, baseAlbumData(args), { price: (args.album.albumPrice * 10000).toFixed(0), currency: args.album.currency })); }
        },
        albumShareClicked: {
            id: 200,
            name: 'player.album.shared',
            params: function (args) { return (__assign({}, baseAlbumData(args), { socialNetwork: args.network })); }
        },
        playerAudioFailed: {
            id: 205,
            name: 'player.audio.failed',
            params: baseTrackData
        },
        trackPlayAttempt: {
            id: 207,
            name: 'player.track.play.attempt',
            params: baseTrackData
        },
        viewTrackPage: {
            id: 208,
            name: 'player.track.viewTrackPage.clicked',
            params: function (args) { return (__assign({}, baseTrackData(args), { isOwner: isOwner })); }
        }
    };
    subscribe_to_emitter_1.subscribeToEmitter(statisticsEvents, events, send);
    function send(eventName, eventDescription, eventArgs) {
        var viewMode = js_sdk_wrapper_1.WixSdk.Utils.getViewMode();
        var isFirstPlayerStartEvent = eventName === 'playerStarted' && !playerStartedFired;
        if (!isFirstPlayerStartEvent && (viewMode === 'editor' || viewMode === 'preview')) {
            return;
        }
        if (isFirstPlayerStartEvent) {
            playerStartedFired = true;
        }
        var params = __assign({ src: 9, evid: eventDescription.id, visitorId: visitorId, sid: biToken, playerInstanceID: instanceId, compId: compId,
            isOwner: isOwner }, (eventDescription.params || functions_1.noop)(eventArgs));
        sendEvents('music-ugc', params);
    }
    function baseAlbumData(_a) {
        var album = _a.album;
        return {
            albumID: album.id
        };
    }
    function baseTrackData(_a) {
        var album = _a.album, track = _a.track;
        return __assign({}, baseAlbumData({ album: album }), { trackID: track.id, trackIdxInAlbum: album.tracks.indexOf(track) });
    }
}
exports.logToBi = logToBi;
function sendPlayerStartedEvent() {
    var _a = send_event_1.getWixParams(), compId = _a.compId, visitorId = _a.visitorId, instanceId = _a.instanceId, biToken = _a.biToken, isOwner = _a.isOwner;
    var params = {
        src: 9,
        evid: 189,
        visitorId: visitorId,
        sid: biToken,
        playerInstanceID: instanceId,
        compId: compId,
        isOwner: isOwner,
        albumID: WMP.wixUtils.getRandomGuid4(),
        loading_time: window.performance && window.performance.now ? window.performance.now() : null
    };
    sendEvents('music-ugc', params);
}
exports.sendPlayerStartedEvent = sendPlayerStartedEvent;
var PromiseStub = (function () {
    function PromiseStub(resolver) {
        resolver(function () {
        }, function () {
        });
    }
    return PromiseStub;
}());


/***/ }),
/* 13 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = window.Wix;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTimeout = addTimeout;
exports.createSafeCall = createSafeCall;
function addTimeout(promise) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === undefined ? 60 * 1000 : _ref$timeout,
      _ref$message = _ref.message,
      message = _ref$message === undefined ? 'Timeout: Wix Js Sdk' : _ref$message;

  var error = void 0;
  try {
    throw new Error(message); // to capture stack trace for IE
  } catch (ex) {
    error = ex;
  }

  var timerId = void 0;
  var timeoutPromise = new Promise(function (resolve, reject) {
    timerId = setTimeout(reject, timeout, error);
  });
  var clear = function clear() {
    return clearTimeout(timerId);
  };
  promise.then(clear, clear);
  return Promise.race([promise, timeoutPromise]);
}

function createSafeCall(onError) {
  return function (fn) {
    return function () {
      try {
        return fn.apply(this, arguments);
      } catch (ex) {
        onError(ex);
        return null;
      }
    };
  };
}
//# sourceMappingURL=utils.js.map


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var js_sdk_wrapper_1 = __webpack_require__(0);
var strings_1 = __webpack_require__(28);
var url_1 = __webpack_require__(8);
exports.createParam = url_1.createParam;
function getHostname(url) {
    return url.split(/\/+/)[1];
}
exports.getHostname = getHostname;
function getParam(param) {
    return decodeURIComponent((location.search.match(new RegExp('[&?]' + param + '=([^&]*)')) || ['', ''])[1]);
}
exports.getParam = getParam;
function getUrlPrefixes() {
    return {
        audio: js_sdk_wrapper_1.WixSdk.Utils.Media.getAudioUrl('', js_sdk_wrapper_1.WixSdk.Utils.Media.AudioType.PREVIEW).replace(/https?:/, '')
            .replace('static.wixstatic.com', 'music.wixstatic.com'),
        image: '//' + getHostname(js_sdk_wrapper_1.WixSdk.Media.getResizedImageUrl('')) + '/'
    };
}
exports.getUrlPrefixes = getUrlPrefixes;
function getHostAndPath(withProtocol) {
    var protocol = withProtocol ? location.protocol : '';
    var host = location.host;
    var pathName = location.pathname.replace(/[^/]+$/, '');
    return protocol + '//' + host + pathName;
}
exports.getHostAndPath = getHostAndPath;
function getWixMusicQueryParams(queryString) {
    return queryString ? queryString.split('?').pop()
        .split('&')
        .filter(function (queryParam) {
        return queryParam.indexOf('wix-music-') === 0;
    })
        .reduce(function (queryParams, param) {
        var keyValue = param.split('=');
        var key = strings_1.dashToSnakeCase(keyValue[0].replace(/^wix-music-/i, ''));
        queryParams[key] = keyValue[1];
        return queryParams;
    }, {}) : {};
}
exports.getWixMusicQueryParams = getWixMusicQueryParams;
function getSharedTrackId(siteInfo) {
    if (!siteInfo && !siteInfo.url) {
        return;
    }
    var wixMusicQueryParams = getWixMusicQueryParams(siteInfo.url);
    if (wixMusicQueryParams.compId === js_sdk_wrapper_1.WixSdk.Utils.getCompId() && wixMusicQueryParams.trackId) {
        return wixMusicQueryParams.trackId;
    }
}
exports.getSharedTrackId = getSharedTrackId;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TRACK_PAGE_DIMENSIONS = {
    WIDTH: 775,
    HEIGHT: 630
};
exports.DEFAULT_VERTICAL_WIDTH = 350;
exports.LAYOUTS_VERTICAL = 0;
exports.LAYOUTS_HORIZONTAL = 1;
exports.LAYOUTS_LIST = 2;
exports.LAYOUT_DEFAULTS = (_a = {},
    _a[exports.LAYOUTS_VERTICAL] = {
        defaultNumberTracksShown: 3
    },
    _a[exports.LAYOUTS_HORIZONTAL] = {
        defaultNumberTracksShown: 3
    },
    _a[exports.LAYOUTS_LIST] = {
        defaultWidth: 680,
        defaultNumberTracksShown: 4
    },
    _a);
exports.DEMO_ALBUM_ID = 'a6b72e_03a8f97fc6ed4f819fce2a1c8086211b';
exports.NO_ALBUM_ID = '00000000-0000-0000-0000-000000000000';
var _a;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTimeout = addTimeout;
function addTimeout(promise, _ref) {
  var time = _ref.time,
      reason = _ref.reason;

  return new Promise(function (resolve, reject) {
    var timerId = setTimeout(reject, time, reason);
    var cancel = function cancel() {
      return clearTimeout(timerId);
    };
    promise.then(cancel, cancel);
    promise.then(resolve, reject);
  });
}
//# sourceMappingURL=promise.js.map


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.sendRequest = sendRequest;

var _promise = __webpack_require__(19);

var _url = __webpack_require__(8);

// if you change anything here, please also update copy in wix-music-widget src/scripts/utils/send-request.js
function sendRequest(options) {
  options = _extends({
    method: 'GET',
    type: 'json',
    withCredentials: false
  }, options);

  if (!options.url) {
    throw new TypeError('url is not specified');
  }

  if (options.type === 'json') {
    options = withJsonDefaults(options);
  }

  var _options = options,
      method = _options.method,
      url = _options.url,
      data = _options.data,
      params = _options.params,
      headers = _options.headers;

  var parametrizedUrl = createParametrizeUrl(url, params);

  var requestPromise = new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();

    request.addEventListener('load', function () {
      var response = { status: request.status, text: request.responseText };
      try {
        response.data = parseResponseBody(request);
      } catch (reason) {
        reject(reason);
      }
      if (request.status < 200 || request.status > 299) {
        reject(response);
        return;
      }
      resolve(response);
    });

    function onError(status, text) {
      return function () {
        reject({ status: status, text: text });
      };
    }

    request.addEventListener('error', onError(-100, 'error'));
    request.addEventListener('abort', onError(-200, 'aborted'));

    request.open(method, parametrizedUrl, true);
    request.withCredentials = options.withCredentials;
    Object.keys(headers).forEach(function (header) {
      request.setRequestHeader(header, headers[header]);
    });
    request.send(data);
  });
  if (options.timeout) {
    return (0, _promise.addTimeout)(requestPromise, { time: options.timeout, reason: 'RequestTimeout' });
  }
  return requestPromise;
}

function withJsonDefaults(options) {
  function getHeaders() {
    var headers = {
      Accept: 'application/json'
    };
    if (options.method === 'POST') {
      headers['Content-Type'] = 'application/json; charset=utf-8';
    }
    return _extends({}, headers, options.headers);
  }

  function getData() {
    var data = options.data;
    return data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? JSON.stringify(data) : data;
  }

  return _extends({}, options, {
    headers: getHeaders(),
    data: getData()
  });
}

function createParametrizeUrl(url, params) {
  if (!params || !Object.keys(params).length) {
    return url;
  }

  if (url.indexOf('?') !== -1) {
    throw new TypeError('Adding param to urls with params is not supported');
  }
  var stringifiedParams = (0, _url.createParam)(params);
  return url + '?' + stringifiedParams;
}

function parseResponseBody(request) {
  var contentType = request.getResponseHeader('Content-Type');
  if (contentType && contentType.indexOf('application/json') === 0) {
    try {
      return JSON.parse(request.responseText);
    } catch (ex) {
      throw new Error('Cannot parse response body');
    }
  }
  return request.responseText;
}
//# sourceMappingURL=send-request.js.map


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function oldAdd(element, className) {
  var classes = element.className.split(' ');
  if (classes.indexOf(className) < 0) {
    classes.push(className);
  }
  element.className = classes.join(' ');
}

function oldRemove(element, className) {
  var classes = element.className.split(' ');
  var idx = classes.indexOf(className);
  if (idx >= 0) {
    classes.splice(idx, 1);
  }
  element.className = classes.join(' ');
}

exports.add = function (element, className) {
  if (element.classList) {
    element.classList.add(className);
  } else {
    oldAdd(element, className);
  }
};

exports.remove = function (element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else {
    oldRemove(element, className);
  }
};

exports.list = function (element) {
  if (element.classList) {
    return Array.prototype.slice.apply(element.classList);
  } else {
    return element.className.split(' ');
  }
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

/*!
Copyright (C) 2013 by WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
var
  // should be a not so common char
  // possibly one JSON does not encode
  // possibly one encodeURIComponent does not encode
  // right now this char is '~' but this might change in the future
  specialChar = '~',
  safeSpecialChar = '\\x' + (
    '0' + specialChar.charCodeAt(0).toString(16)
  ).slice(-2),
  escapedSafeSpecialChar = '\\' + safeSpecialChar,
  specialCharRG = new RegExp(safeSpecialChar, 'g'),
  safeSpecialCharRG = new RegExp(escapedSafeSpecialChar, 'g'),

  safeStartWithSpecialCharRG = new RegExp('(?:^|([^\\\\]))' + escapedSafeSpecialChar),

  indexOf = [].indexOf || function(v){
    for(var i=this.length;i--&&this[i]!==v;);
    return i;
  },
  $String = String  // there's no way to drop warnings in JSHint
                    // about new String ... well, I need that here!
                    // faked, and happy linter!
;

function generateReplacer(value, replacer, resolve) {
  var
    path = [],
    all  = [value],
    seen = [value],
    mapp = [resolve ? specialChar : '[Circular]'],
    last = value,
    lvl  = 1,
    i
  ;
  return function(key, value) {
    // the replacer has rights to decide
    // if a new object should be returned
    // or if there's some key to drop
    // let's call it here rather than "too late"
    if (replacer) value = replacer.call(this, key, value);

    // did you know ? Safari passes keys as integers for arrays
    // which means if (key) when key === 0 won't pass the check
    if (key !== '') {
      if (last !== this) {
        i = lvl - indexOf.call(all, this) - 1;
        lvl -= i;
        all.splice(lvl, all.length);
        path.splice(lvl - 1, path.length);
        last = this;
      }
      // console.log(lvl, key, path);
      if (typeof value === 'object' && value) {
    	// if object isn't referring to parent object, add to the
        // object path stack. Otherwise it is already there.
        if (indexOf.call(all, value) < 0) {
          all.push(last = value);
        }
        lvl = all.length;
        i = indexOf.call(seen, value);
        if (i < 0) {
          i = seen.push(value) - 1;
          if (resolve) {
            // key cannot contain specialChar but could be not a string
            path.push(('' + key).replace(specialCharRG, safeSpecialChar));
            mapp[i] = specialChar + path.join(specialChar);
          } else {
            mapp[i] = mapp[0];
          }
        } else {
          value = mapp[i];
        }
      } else {
        if (typeof value === 'string' && resolve) {
          // ensure no special char involved on deserialization
          // in this case only first char is important
          // no need to replace all value (better performance)
          value = value .replace(safeSpecialChar, escapedSafeSpecialChar)
                        .replace(specialChar, safeSpecialChar);
        }
      }
    }
    return value;
  };
}

function retrieveFromPath(current, keys) {
  for(var i = 0, length = keys.length; i < length; current = current[
    // keys should be normalized back here
    keys[i++].replace(safeSpecialCharRG, specialChar)
  ]);
  return current;
}

function generateReviver(reviver) {
  return function(key, value) {
    var isString = typeof value === 'string';
    if (isString && value.charAt(0) === specialChar) {
      return new $String(value.slice(1));
    }
    if (key === '') value = regenerate(value, value, {});
    // again, only one needed, do not use the RegExp for this replacement
    // only keys need the RegExp
    if (isString) value = value .replace(safeStartWithSpecialCharRG, '$1' + specialChar)
                                .replace(escapedSafeSpecialChar, safeSpecialChar);
    return reviver ? reviver.call(this, key, value) : value;
  };
}

function regenerateArray(root, current, retrieve) {
  for (var i = 0, length = current.length; i < length; i++) {
    current[i] = regenerate(root, current[i], retrieve);
  }
  return current;
}

function regenerateObject(root, current, retrieve) {
  for (var key in current) {
    if (current.hasOwnProperty(key)) {
      current[key] = regenerate(root, current[key], retrieve);
    }
  }
  return current;
}

function regenerate(root, current, retrieve) {
  return current instanceof Array ?
    // fast Array reconstruction
    regenerateArray(root, current, retrieve) :
    (
      current instanceof $String ?
        (
          // root is an empty string
          current.length ?
            (
              retrieve.hasOwnProperty(current) ?
                retrieve[current] :
                retrieve[current] = retrieveFromPath(
                  root, current.split(specialChar)
                )
            ) :
            root
        ) :
        (
          current instanceof Object ?
            // dedicated Object parser
            regenerateObject(root, current, retrieve) :
            // value as it is
            current
        )
    )
  ;
}

function stringifyRecursion(value, replacer, space, doNotResolve) {
  return JSON.stringify(value, generateReplacer(value, replacer, !doNotResolve), space);
}

function parseRecursion(text, reviver) {
  return JSON.parse(text, generateReviver(reviver));
}
this.stringify = stringifyRecursion;
this.parse = parseRecursion;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(33);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_RESULT__;;(function (global, factory) { // eslint-disable-line
	"use strict"
	/* eslint-disable no-undef */
	var m = factory(global)
	if (typeof module === "object" && module != null && module.exports) {
		module.exports = m
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return m }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	} else {
		global.m = m
	}
	/* eslint-enable no-undef */
})(typeof window !== "undefined" ? window : this, function (global, undefined) { // eslint-disable-line
	"use strict"

	m.version = function () {
		return "v0.2.5"
	}

	var hasOwn = {}.hasOwnProperty
	var type = {}.toString

	function isFunction(object) {
		return typeof object === "function"
	}

	function isObject(object) {
		return type.call(object) === "[object Object]"
	}

	function isString(object) {
		return type.call(object) === "[object String]"
	}

	var isArray = Array.isArray || function (object) {
		return type.call(object) === "[object Array]"
	}

	function noop() {}

	var voidElements = {
		AREA: 1,
		BASE: 1,
		BR: 1,
		COL: 1,
		COMMAND: 1,
		EMBED: 1,
		HR: 1,
		IMG: 1,
		INPUT: 1,
		KEYGEN: 1,
		LINK: 1,
		META: 1,
		PARAM: 1,
		SOURCE: 1,
		TRACK: 1,
		WBR: 1
	}

	// caching commonly used variables
	var $document, $location, $requestAnimationFrame, $cancelAnimationFrame

	// self invoking function needed because of the way mocks work
	function initialize(mock) {
		$document = mock.document
		$location = mock.location
		$cancelAnimationFrame = mock.cancelAnimationFrame || mock.clearTimeout
		$requestAnimationFrame = mock.requestAnimationFrame || mock.setTimeout
	}

	// testing API
	m.deps = function (mock) {
		initialize(global = mock || window)
		return global
	}

	m.deps(global)

	/**
	 * @typedef {String} Tag
	 * A string that looks like -> div.classname#id[param=one][param2=two]
	 * Which describes a DOM node
	 */

	function parseTagAttrs(cell, tag) {
		var classes = []
		var parser = /(?:(^|#|\.)([^#\.\[\]]+))|(\[.+?\])/g
		var match

		while ((match = parser.exec(tag))) {
			if (match[1] === "" && match[2]) {
				cell.tag = match[2]
			} else if (match[1] === "#") {
				cell.attrs.id = match[2]
			} else if (match[1] === ".") {
				classes.push(match[2])
			} else if (match[3][0] === "[") {
				var pair = /\[(.+?)(?:=("|'|)(.*?)\2)?\]/.exec(match[3])
				cell.attrs[pair[1]] = pair[3] || ""
			}
		}

		return classes
	}

	function getVirtualChildren(args, hasAttrs) {
		var children = hasAttrs ? args.slice(1) : args

		if (children.length === 1 && isArray(children[0])) {
			return children[0]
		} else {
			return children
		}
	}

	function assignAttrs(target, attrs, classes) {
		var classAttr = "class" in attrs ? "class" : "className"

		for (var attrName in attrs) {
			if (hasOwn.call(attrs, attrName)) {
				if (attrName === classAttr &&
						attrs[attrName] != null &&
						attrs[attrName] !== "") {
					classes.push(attrs[attrName])
					// create key in correct iteration order
					target[attrName] = ""
				} else {
					target[attrName] = attrs[attrName]
				}
			}
		}

		if (classes.length) target[classAttr] = classes.join(" ")
	}

	/**
	 *
	 * @param {Tag} The DOM node tag
	 * @param {Object=[]} optional key-value pairs to be mapped to DOM attrs
	 * @param {...mNode=[]} Zero or more Mithril child nodes. Can be an array,
	 *                      or splat (optional)
	 */
	function m(tag, pairs) {
		var args = []

		for (var i = 1, length = arguments.length; i < length; i++) {
			args[i - 1] = arguments[i]
		}

		if (isObject(tag)) return parameterize(tag, args)

		if (!isString(tag)) {
			throw new Error("selector in m(selector, attrs, children) should " +
				"be a string")
		}

		var hasAttrs = pairs != null && isObject(pairs) &&
			!("tag" in pairs || "view" in pairs || "subtree" in pairs)

		var attrs = hasAttrs ? pairs : {}
		var cell = {
			tag: "div",
			attrs: {},
			children: getVirtualChildren(args, hasAttrs)
		}

		assignAttrs(cell.attrs, attrs, parseTagAttrs(cell, tag))
		return cell
	}

	function forEach(list, f) {
		for (var i = 0; i < list.length && !f(list[i], i++);) {
			// function called in condition
		}
	}

	function forKeys(list, f) {
		forEach(list, function (attrs, i) {
			return (attrs = attrs && attrs.attrs) &&
				attrs.key != null &&
				f(attrs, i)
		})
	}
	// This function was causing deopts in Chrome.
	function dataToString(data) {
		// data.toString() might throw or return null if data is the return
		// value of Console.log in some versions of Firefox (behavior depends on
		// version)
		try {
			if (data != null && data.toString() != null) return data
		} catch (e) {
			// silently ignore errors
		}
		return ""
	}

	// This function was causing deopts in Chrome.
	function injectTextNode(parentElement, first, index, data) {
		try {
			insertNode(parentElement, first, index)
			first.nodeValue = data
		} catch (e) {
			// IE erroneously throws error when appending an empty text node
			// after a null
		}
	}

	function flatten(list) {
		// recursively flatten array
		for (var i = 0; i < list.length; i++) {
			if (isArray(list[i])) {
				list = list.concat.apply([], list)
				// check current index again and flatten until there are no more
				// nested arrays at that index
				i--
			}
		}
		return list
	}

	function insertNode(parentElement, node, index) {
		parentElement.insertBefore(node,
			parentElement.childNodes[index] || null)
	}

	var DELETION = 1
	var INSERTION = 2
	var MOVE = 3

	function handleKeysDiffer(data, existing, cached, parentElement) {
		forKeys(data, function (key, i) {
			existing[key = key.key] = existing[key] ? {
				action: MOVE,
				index: i,
				from: existing[key].index,
				element: cached.nodes[existing[key].index] ||
					$document.createElement("div")
			} : {action: INSERTION, index: i}
		})

		var actions = []
		for (var prop in existing) {
			if (hasOwn.call(existing, prop)) {
				actions.push(existing[prop])
			}
		}

		var changes = actions.sort(sortChanges)
		var newCached = new Array(cached.length)

		newCached.nodes = cached.nodes.slice()

		forEach(changes, function (change) {
			var index = change.index
			if (change.action === DELETION) {
				clear(cached[index].nodes, cached[index])
				newCached.splice(index, 1)
			}
			if (change.action === INSERTION) {
				var dummy = $document.createElement("div")
				dummy.key = data[index].attrs.key
				insertNode(parentElement, dummy, index)
				newCached.splice(index, 0, {
					attrs: {key: data[index].attrs.key},
					nodes: [dummy]
				})
				newCached.nodes[index] = dummy
			}

			if (change.action === MOVE) {
				var changeElement = change.element
				var maybeChanged = parentElement.childNodes[index]
				if (maybeChanged !== changeElement && changeElement !== null) {
					parentElement.insertBefore(changeElement,
						maybeChanged || null)
				}
				newCached[index] = cached[change.from]
				newCached.nodes[index] = changeElement
			}
		})

		return newCached
	}

	function diffKeys(data, cached, existing, parentElement) {
		var keysDiffer = data.length !== cached.length

		if (!keysDiffer) {
			forKeys(data, function (attrs, i) {
				var cachedCell = cached[i]
				return keysDiffer = cachedCell &&
					cachedCell.attrs &&
					cachedCell.attrs.key !== attrs.key
			})
		}

		if (keysDiffer) {
			return handleKeysDiffer(data, existing, cached, parentElement)
		} else {
			return cached
		}
	}

	function diffArray(data, cached, nodes) {
		// diff the array itself

		// update the list of DOM nodes by collecting the nodes from each item
		forEach(data, function (_, i) {
			if (cached[i] != null) nodes.push.apply(nodes, cached[i].nodes)
		})
		// remove items from the end of the array if the new array is shorter
		// than the old one. if errors ever happen here, the issue is most
		// likely a bug in the construction of the `cached` data structure
		// somewhere earlier in the program
		forEach(cached.nodes, function (node, i) {
			if (node.parentNode != null && nodes.indexOf(node) < 0) {
				clear([node], [cached[i]])
			}
		})

		if (data.length < cached.length) cached.length = data.length
		cached.nodes = nodes
	}

	function buildArrayKeys(data) {
		var guid = 0
		forKeys(data, function () {
			forEach(data, function (attrs) {
				if ((attrs = attrs && attrs.attrs) && attrs.key == null) {
					attrs.key = "__mithril__" + guid++
				}
			})
			return 1
		})
	}

	function isDifferentEnough(data, cached, dataAttrKeys) {
		if (data.tag !== cached.tag) return true

		if (dataAttrKeys.sort().join() !==
				Object.keys(cached.attrs).sort().join()) {
			return true
		}

		if (data.attrs.id !== cached.attrs.id) {
			return true
		}

		if (data.attrs.key !== cached.attrs.key) {
			return true
		}

		if (m.redraw.strategy() === "all") {
			return !cached.configContext || cached.configContext.retain !== true
		}

		if (m.redraw.strategy() === "diff") {
			return cached.configContext && cached.configContext.retain === false
		}

		return false
	}

	function maybeRecreateObject(data, cached, dataAttrKeys) {
		// if an element is different enough from the one in cache, recreate it
		if (isDifferentEnough(data, cached, dataAttrKeys)) {
			if (cached.nodes.length) clear(cached.nodes)

			if (cached.configContext &&
					isFunction(cached.configContext.onunload)) {
				cached.configContext.onunload()
			}

			if (cached.controllers) {
				forEach(cached.controllers, function (controller) {
					if (controller.onunload) {
						controller.onunload({preventDefault: noop})
					}
				})
			}
		}
	}

	function getObjectNamespace(data, namespace) {
		if (data.attrs.xmlns) return data.attrs.xmlns
		if (data.tag === "svg") return "http://www.w3.org/2000/svg"
		if (data.tag === "math") return "http://www.w3.org/1998/Math/MathML"
		return namespace
	}

	var pendingRequests = 0
	m.startComputation = function () { pendingRequests++ }
	m.endComputation = function () {
		if (pendingRequests > 1) {
			pendingRequests--
		} else {
			pendingRequests = 0
			m.redraw()
		}
	}

	function unloadCachedControllers(cached, views, controllers) {
		if (controllers.length) {
			cached.views = views
			cached.controllers = controllers
			forEach(controllers, function (controller) {
				if (controller.onunload && controller.onunload.$old) {
					controller.onunload = controller.onunload.$old
				}

				if (pendingRequests && controller.onunload) {
					var onunload = controller.onunload
					controller.onunload = noop
					controller.onunload.$old = onunload
				}
			})
		}
	}

	function scheduleConfigsToBeCalled(configs, data, node, isNew, cached) {
		// schedule configs to be called. They are called after `build` finishes
		// running
		if (isFunction(data.attrs.config)) {
			var context = cached.configContext = cached.configContext || {}

			// bind
			configs.push(function () {
				return data.attrs.config.call(data, node, !isNew, context,
					cached)
			})
		}
	}

	function buildUpdatedNode(
		cached,
		data,
		editable,
		hasKeys,
		namespace,
		views,
		configs,
		controllers
	) {
		var node = cached.nodes[0]

		if (hasKeys) {
			setAttributes(node, data.tag, data.attrs, cached.attrs, namespace)
		}

		cached.children = build(
			node,
			data.tag,
			undefined,
			undefined,
			data.children,
			cached.children,
			false,
			0,
			data.attrs.contenteditable ? node : editable,
			namespace,
			configs
		)

		cached.nodes.intact = true

		if (controllers.length) {
			cached.views = views
			cached.controllers = controllers
		}

		return node
	}

	function handleNonexistentNodes(data, parentElement, index) {
		var nodes
		if (data.$trusted) {
			nodes = injectHTML(parentElement, index, data)
		} else {
			nodes = [$document.createTextNode(data)]
			if (!(parentElement.nodeName in voidElements)) {
				insertNode(parentElement, nodes[0], index)
			}
		}

		var cached

		if (typeof data === "string" ||
				typeof data === "number" ||
				typeof data === "boolean") {
			cached = new data.constructor(data)
		} else {
			cached = data
		}

		cached.nodes = nodes
		return cached
	}

	function reattachNodes(
		data,
		cached,
		parentElement,
		editable,
		index,
		parentTag
	) {
		var nodes = cached.nodes
		if (!editable || editable !== $document.activeElement) {
			if (data.$trusted) {
				clear(nodes, cached)
				nodes = injectHTML(parentElement, index, data)
			} else if (parentTag === "textarea") {
				// <textarea> uses `value` instead of `nodeValue`.
				parentElement.value = data
			} else if (editable) {
				// contenteditable nodes use `innerHTML` instead of `nodeValue`.
				editable.innerHTML = data
			} else {
				// was a trusted string
				if (nodes[0].nodeType === 1 || nodes.length > 1 ||
						(nodes[0].nodeValue.trim &&
							!nodes[0].nodeValue.trim())) {
					clear(cached.nodes, cached)
					nodes = [$document.createTextNode(data)]
				}

				injectTextNode(parentElement, nodes[0], index, data)
			}
		}
		cached = new data.constructor(data)
		cached.nodes = nodes
		return cached
	}

	function handleTextNode(
		cached,
		data,
		index,
		parentElement,
		shouldReattach,
		editable,
		parentTag
	) {
		if (!cached.nodes.length) {
			return handleNonexistentNodes(data, parentElement, index)
		} else if (cached.valueOf() !== data.valueOf() || shouldReattach) {
			return reattachNodes(data, cached, parentElement, editable, index,
				parentTag)
		} else {
			return (cached.nodes.intact = true, cached)
		}
	}

	function getSubArrayCount(item) {
		if (item.$trusted) {
			// fix offset of next element if item was a trusted string w/ more
			// than one html element
			// the first clause in the regexp matches elements
			// the second clause (after the pipe) matches text nodes
			var match = item.match(/<[^\/]|\>\s*[^<]/g)
			if (match != null) return match.length
		} else if (isArray(item)) {
			return item.length
		}
		return 1
	}

	function buildArray(
		data,
		cached,
		parentElement,
		index,
		parentTag,
		shouldReattach,
		editable,
		namespace,
		configs
	) {
		data = flatten(data)
		var nodes = []
		var intact = cached.length === data.length
		var subArrayCount = 0

		// keys algorithm: sort elements without recreating them if keys are
		// present
		//
		// 1) create a map of all existing keys, and mark all for deletion
		// 2) add new keys to map and mark them for addition
		// 3) if key exists in new list, change action from deletion to a move
		// 4) for each key, handle its corresponding action as marked in
		//    previous steps

		var existing = {}
		var shouldMaintainIdentities = false

		forKeys(cached, function (attrs, i) {
			shouldMaintainIdentities = true
			existing[cached[i].attrs.key] = {action: DELETION, index: i}
		})

		buildArrayKeys(data)
		if (shouldMaintainIdentities) {
			cached = diffKeys(data, cached, existing, parentElement)
		}
		// end key algorithm

		var cacheCount = 0
		// faster explicitly written
		for (var i = 0, len = data.length; i < len; i++) {
			// diff each item in the array
			var item = build(
				parentElement,
				parentTag,
				cached,
				index,
				data[i],
				cached[cacheCount],
				shouldReattach,
				index + subArrayCount || subArrayCount,
				editable,
				namespace,
				configs)

			if (item !== undefined) {
				intact = intact && item.nodes.intact
				subArrayCount += getSubArrayCount(item)
				cached[cacheCount++] = item
			}
		}

		if (!intact) diffArray(data, cached, nodes)
		return cached
	}

	function makeCache(data, cached, index, parentIndex, parentCache) {
		if (cached != null) {
			if (type.call(cached) === type.call(data)) return cached

			if (parentCache && parentCache.nodes) {
				var offset = index - parentIndex
				var end = offset + (isArray(data) ? data : cached.nodes).length
				clear(
					parentCache.nodes.slice(offset, end),
					parentCache.slice(offset, end))
			} else if (cached.nodes) {
				clear(cached.nodes, cached)
			}
		}

		cached = new data.constructor()
		// if constructor creates a virtual dom element, use a blank object as
		// the base cached node instead of copying the virtual el (#277)
		if (cached.tag) cached = {}
		cached.nodes = []
		return cached
	}

	function constructNode(data, namespace) {
		if (data.attrs.is) {
			if (namespace == null) {
				return $document.createElement(data.tag, data.attrs.is)
			} else {
				return $document.createElementNS(namespace, data.tag,
					data.attrs.is)
			}
		} else if (namespace == null) {
			return $document.createElement(data.tag)
		} else {
			return $document.createElementNS(namespace, data.tag)
		}
	}

	function constructAttrs(data, node, namespace, hasKeys) {
		if (hasKeys) {
			return setAttributes(node, data.tag, data.attrs, {}, namespace)
		} else {
			return data.attrs
		}
	}

	function constructChildren(
		data,
		node,
		cached,
		editable,
		namespace,
		configs
	) {
		if (data.children != null && data.children.length > 0) {
			return build(
				node,
				data.tag,
				undefined,
				undefined,
				data.children,
				cached.children,
				true,
				0,
				data.attrs.contenteditable ? node : editable,
				namespace,
				configs)
		} else {
			return data.children
		}
	}

	function reconstructCached(
		data,
		attrs,
		children,
		node,
		namespace,
		views,
		controllers
	) {
		var cached = {
			tag: data.tag,
			attrs: attrs,
			children: children,
			nodes: [node]
		}

		unloadCachedControllers(cached, views, controllers)

		if (cached.children && !cached.children.nodes) {
			cached.children.nodes = []
		}

		// edge case: setting value on <select> doesn't work before children
		// exist, so set it again after children have been created
		if (data.tag === "select" && "value" in data.attrs) {
			setAttributes(node, data.tag, {value: data.attrs.value}, {},
				namespace)
		}

		return cached
	}

	function getController(views, view, cachedControllers, controller) {
		var controllerIndex

		if (m.redraw.strategy() === "diff" && views) {
			controllerIndex = views.indexOf(view)
		} else {
			controllerIndex = -1
		}

		if (controllerIndex > -1) {
			return cachedControllers[controllerIndex]
		} else if (isFunction(controller)) {
			return new controller()
		} else {
			return {}
		}
	}

	var unloaders = []

	function updateLists(views, controllers, view, controller) {
		if (controller.onunload != null &&
				unloaders.map(function (u) { return u.handler })
					.indexOf(controller.onunload) < 0) {
			unloaders.push({
				controller: controller,
				handler: controller.onunload
			})
		}

		views.push(view)
		controllers.push(controller)
	}

	var forcing = false
	function checkView(
		data,
		view,
		cached,
		cachedControllers,
		controllers,
		views
	) {
		var controller = getController(
			cached.views,
			view,
			cachedControllers,
			data.controller)

		var key = data && data.attrs && data.attrs.key

		if (pendingRequests === 0 ||
				forcing ||
				cachedControllers &&
					cachedControllers.indexOf(controller) > -1) {
			data = data.view(controller)
		} else {
			data = {tag: "placeholder"}
		}

		if (data.subtree === "retain") return data
		data.attrs = data.attrs || {}
		data.attrs.key = key
		updateLists(views, controllers, view, controller)
		return data
	}

	function markViews(data, cached, views, controllers) {
		var cachedControllers = cached && cached.controllers

		while (data.view != null) {
			data = checkView(
				data,
				data.view.$original || data.view,
				cached,
				cachedControllers,
				controllers,
				views)
		}

		return data
	}

	function buildObject( // eslint-disable-line max-statements
		data,
		cached,
		editable,
		parentElement,
		index,
		shouldReattach,
		namespace,
		configs
	) {
		var views = []
		var controllers = []

		data = markViews(data, cached, views, controllers)

		if (data.subtree === "retain") return cached

		if (!data.tag && controllers.length) {
			throw new Error("Component template must return a virtual " +
				"element, not an array, string, etc.")
		}

		data.attrs = data.attrs || {}
		cached.attrs = cached.attrs || {}

		var dataAttrKeys = Object.keys(data.attrs)
		var hasKeys = dataAttrKeys.length > ("key" in data.attrs ? 1 : 0)

		maybeRecreateObject(data, cached, dataAttrKeys)

		if (!isString(data.tag)) return

		var isNew = cached.nodes.length === 0

		namespace = getObjectNamespace(data, namespace)

		var node
		if (isNew) {
			node = constructNode(data, namespace)
			// set attributes first, then create children
			var attrs = constructAttrs(data, node, namespace, hasKeys)

			// add the node to its parent before attaching children to it
			insertNode(parentElement, node, index)

			var children = constructChildren(data, node, cached, editable,
				namespace, configs)

			cached = reconstructCached(
				data,
				attrs,
				children,
				node,
				namespace,
				views,
				controllers)
		} else {
			node = buildUpdatedNode(
				cached,
				data,
				editable,
				hasKeys,
				namespace,
				views,
				configs,
				controllers)
		}

		if (!isNew && shouldReattach === true && node != null) {
			insertNode(parentElement, node, index)
		}

		// The configs are called after `build` finishes running
		scheduleConfigsToBeCalled(configs, data, node, isNew, cached)

		return cached
	}

	function build(
		parentElement,
		parentTag,
		parentCache,
		parentIndex,
		data,
		cached,
		shouldReattach,
		index,
		editable,
		namespace,
		configs
	) {
		/*
		 * `build` is a recursive function that manages creation/diffing/removal
		 * of DOM elements based on comparison between `data` and `cached` the
		 * diff algorithm can be summarized as this:
		 *
		 * 1 - compare `data` and `cached`
		 * 2 - if they are different, copy `data` to `cached` and update the DOM
		 *     based on what the difference is
		 * 3 - recursively apply this algorithm for every array and for the
		 *     children of every virtual element
		 *
		 * The `cached` data structure is essentially the same as the previous
		 * redraw's `data` data structure, with a few additions:
		 * - `cached` always has a property called `nodes`, which is a list of
		 *    DOM elements that correspond to the data represented by the
		 *    respective virtual element
		 * - in order to support attaching `nodes` as a property of `cached`,
		 *    `cached` is *always* a non-primitive object, i.e. if the data was
		 *    a string, then cached is a String instance. If data was `null` or
		 *    `undefined`, cached is `new String("")`
		 * - `cached also has a `configContext` property, which is the state
		 *    storage object exposed by config(element, isInitialized, context)
		 * - when `cached` is an Object, it represents a virtual element; when
		 *    it's an Array, it represents a list of elements; when it's a
		 *    String, Number or Boolean, it represents a text node
		 *
		 * `parentElement` is a DOM element used for W3C DOM API calls
		 * `parentTag` is only used for handling a corner case for textarea
		 * values
		 * `parentCache` is used to remove nodes in some multi-node cases
		 * `parentIndex` and `index` are used to figure out the offset of nodes.
		 * They're artifacts from before arrays started being flattened and are
		 * likely refactorable
		 * `data` and `cached` are, respectively, the new and old nodes being
		 * diffed
		 * `shouldReattach` is a flag indicating whether a parent node was
		 * recreated (if so, and if this node is reused, then this node must
		 * reattach itself to the new parent)
		 * `editable` is a flag that indicates whether an ancestor is
		 * contenteditable
		 * `namespace` indicates the closest HTML namespace as it cascades down
		 * from an ancestor
		 * `configs` is a list of config functions to run after the topmost
		 * `build` call finishes running
		 *
		 * there's logic that relies on the assumption that null and undefined
		 * data are equivalent to empty strings
		 * - this prevents lifecycle surprises from procedural helpers that mix
		 *   implicit and explicit return statements (e.g.
		 *   function foo() {if (cond) return m("div")}
		 * - it simplifies diffing code
		 */
		data = dataToString(data)
		if (data.subtree === "retain") return cached
		cached = makeCache(data, cached, index, parentIndex, parentCache)

		if (isArray(data)) {
			return buildArray(
				data,
				cached,
				parentElement,
				index,
				parentTag,
				shouldReattach,
				editable,
				namespace,
				configs)
		} else if (data != null && isObject(data)) {
			return buildObject(
				data,
				cached,
				editable,
				parentElement,
				index,
				shouldReattach,
				namespace,
				configs)
		} else if (!isFunction(data)) {
			return handleTextNode(
				cached,
				data,
				index,
				parentElement,
				shouldReattach,
				editable,
				parentTag)
		} else {
			return cached
		}
	}

	function sortChanges(a, b) {
		return a.action - b.action || a.index - b.index
	}

	function copyStyleAttrs(node, dataAttr, cachedAttr) {
		for (var rule in dataAttr) {
			if (hasOwn.call(dataAttr, rule)) {
				if (cachedAttr == null || cachedAttr[rule] !== dataAttr[rule]) {
					node.style[rule] = dataAttr[rule]
				}
			}
		}

		for (rule in cachedAttr) {
			if (hasOwn.call(cachedAttr, rule)) {
				if (!hasOwn.call(dataAttr, rule)) node.style[rule] = ""
			}
		}
	}

	var shouldUseSetAttribute = {
		list: 1,
		style: 1,
		form: 1,
		type: 1,
		width: 1,
		height: 1
	}

	function setSingleAttr(
		node,
		attrName,
		dataAttr,
		cachedAttr,
		tag,
		namespace
	) {
		if (attrName === "config" || attrName === "key") {
			// `config` isn't a real attribute, so ignore it
			return true
		} else if (isFunction(dataAttr) && attrName.slice(0, 2) === "on") {
			// hook event handlers to the auto-redrawing system
			node[attrName] = autoredraw(dataAttr, node)
		} else if (attrName === "style" && dataAttr != null &&
				isObject(dataAttr)) {
			// handle `style: {...}`
			copyStyleAttrs(node, dataAttr, cachedAttr)
		} else if (namespace != null) {
			// handle SVG
			if (attrName === "href") {
				node.setAttributeNS("http://www.w3.org/1999/xlink",
					"href", dataAttr)
			} else {
				node.setAttribute(
					attrName === "className" ? "class" : attrName,
					dataAttr)
			}
		} else if (attrName in node && !shouldUseSetAttribute[attrName]) {
			// handle cases that are properties (but ignore cases where we
			// should use setAttribute instead)
			//
			// - list and form are typically used as strings, but are DOM
			//   element references in js
			//
			// - when using CSS selectors (e.g. `m("[style='']")`), style is
			//   used as a string, but it's an object in js
			//
			// #348 don't set the value if not needed - otherwise, cursor
			// placement breaks in Chrome
			try {
				if (tag !== "input" || node[attrName] !== dataAttr) {
					node[attrName] = dataAttr
				}
			} catch (e) {
				node.setAttribute(attrName, dataAttr)
			}
		}
		else node.setAttribute(attrName, dataAttr)
	}

	function trySetAttr(
		node,
		attrName,
		dataAttr,
		cachedAttr,
		cachedAttrs,
		tag,
		namespace
	) {
		if (!(attrName in cachedAttrs) || (cachedAttr !== dataAttr) || ($document.activeElement === node)) {
			cachedAttrs[attrName] = dataAttr
			try {
				return setSingleAttr(
					node,
					attrName,
					dataAttr,
					cachedAttr,
					tag,
					namespace)
			} catch (e) {
				// swallow IE's invalid argument errors to mimic HTML's
				// fallback-to-doing-nothing-on-invalid-attributes behavior
				if (e.message.indexOf("Invalid argument") < 0) throw e
			}
		} else if (attrName === "value" && tag === "input" &&
				node.value !== dataAttr) {
			// #348 dataAttr may not be a string, so use loose comparison
			node.value = dataAttr
		}
	}

	function setAttributes(node, tag, dataAttrs, cachedAttrs, namespace) {
		for (var attrName in dataAttrs) {
			if (hasOwn.call(dataAttrs, attrName)) {
				if (trySetAttr(
						node,
						attrName,
						dataAttrs[attrName],
						cachedAttrs[attrName],
						cachedAttrs,
						tag,
						namespace)) {
					continue
				}
			}
		}
		return cachedAttrs
	}

	function clear(nodes, cached) {
		for (var i = nodes.length - 1; i > -1; i--) {
			if (nodes[i] && nodes[i].parentNode) {
				try {
					nodes[i].parentNode.removeChild(nodes[i])
				} catch (e) {
					/* eslint-disable max-len */
					// ignore if this fails due to order of events (see
					// http://stackoverflow.com/questions/21926083/failed-to-execute-removechild-on-node)
					/* eslint-enable max-len */
				}
				cached = [].concat(cached)
				if (cached[i]) unload(cached[i])
			}
		}
		// release memory if nodes is an array. This check should fail if nodes
		// is a NodeList (see loop above)
		if (nodes.length) {
			nodes.length = 0
		}
	}

	function unload(cached) {
		if (cached.configContext && isFunction(cached.configContext.onunload)) {
			cached.configContext.onunload()
			cached.configContext.onunload = null
		}
		if (cached.controllers) {
			forEach(cached.controllers, function (controller) {
				if (isFunction(controller.onunload)) {
					controller.onunload({preventDefault: noop})
				}
			})
		}
		if (cached.children) {
			if (isArray(cached.children)) forEach(cached.children, unload)
			else if (cached.children.tag) unload(cached.children)
		}
	}

	function appendTextFragment(parentElement, data) {
		try {
			parentElement.appendChild(
				$document.createRange().createContextualFragment(data))
		} catch (e) {
			parentElement.insertAdjacentHTML("beforeend", data)
			replaceScriptNodes(parentElement)
		}
	}

	// Replace script tags inside given DOM element with executable ones.
	// Will also check children recursively and replace any found script
	// tags in same manner.
	function replaceScriptNodes(node) {
		if (node.tagName === "SCRIPT") {
			node.parentNode.replaceChild(buildExecutableNode(node), node)
		} else {
			var children = node.childNodes
			if (children && children.length) {
				for (var i = 0; i < children.length; i++) {
					replaceScriptNodes(children[i])
				}
			}
		}

		return node
	}

	// Replace script element with one whose contents are executable.
	function buildExecutableNode(node){
		var scriptEl = document.createElement("script")
		var attrs = node.attributes

		for (var i = 0; i < attrs.length; i++) {
			scriptEl.setAttribute(attrs[i].name, attrs[i].value)
		}

		scriptEl.text = node.innerHTML
		return scriptEl
	}

	function injectHTML(parentElement, index, data) {
		var nextSibling = parentElement.childNodes[index]
		if (nextSibling) {
			var isElement = nextSibling.nodeType !== 1
			var placeholder = $document.createElement("span")
			if (isElement) {
				parentElement.insertBefore(placeholder, nextSibling || null)
				placeholder.insertAdjacentHTML("beforebegin", data)
				parentElement.removeChild(placeholder)
			} else {
				nextSibling.insertAdjacentHTML("beforebegin", data)
			}
		} else {
			appendTextFragment(parentElement, data)
		}

		var nodes = []

		while (parentElement.childNodes[index] !== nextSibling) {
			nodes.push(parentElement.childNodes[index])
			index++
		}

		return nodes
	}

	function autoredraw(callback, object) {
		return function (e) {
			e = e || event
			m.redraw.strategy("diff")
			m.startComputation()
			try {
				return callback.call(object, e)
			} finally {
				endFirstComputation()
			}
		}
	}

	var html
	var documentNode = {
		appendChild: function (node) {
			if (html === undefined) html = $document.createElement("html")
			if ($document.documentElement &&
					$document.documentElement !== node) {
				$document.replaceChild(node, $document.documentElement)
			} else {
				$document.appendChild(node)
			}

			this.childNodes = $document.childNodes
		},

		insertBefore: function (node) {
			this.appendChild(node)
		},

		childNodes: []
	}

	var nodeCache = []
	var cellCache = {}

	m.render = function (root, cell, forceRecreation) {
		if (!root) {
			throw new Error("Ensure the DOM element being passed to " +
				"m.route/m.mount/m.render is not undefined.")
		}
		var configs = []
		var id = getCellCacheKey(root)
		var isDocumentRoot = root === $document
		var node

		if (isDocumentRoot || root === $document.documentElement) {
			node = documentNode
		} else {
			node = root
		}

		if (isDocumentRoot && cell.tag !== "html") {
			cell = {tag: "html", attrs: {}, children: cell}
		}

		if (cellCache[id] === undefined) clear(node.childNodes)
		if (forceRecreation === true) reset(root)

		cellCache[id] = build(
			node,
			null,
			undefined,
			undefined,
			cell,
			cellCache[id],
			false,
			0,
			null,
			undefined,
			configs)

		forEach(configs, function (config) { config() })
	}

	function getCellCacheKey(element) {
		var index = nodeCache.indexOf(element)
		return index < 0 ? nodeCache.push(element) - 1 : index
	}

	m.trust = function (value) {
		value = new String(value) // eslint-disable-line no-new-wrappers
		value.$trusted = true
		return value
	}

	function gettersetter(store) {
		function prop() {
			if (arguments.length) store = arguments[0]
			return store
		}

		prop.toJSON = function () {
			return store
		}

		return prop
	}

	m.prop = function (store) {
		if ((store != null && (isObject(store) || isFunction(store)) || ((typeof Promise !== "undefined") && (store instanceof Promise))) &&
				isFunction(store.then)) {
			return propify(store)
		}

		return gettersetter(store)
	}

	var roots = []
	var components = []
	var controllers = []
	var lastRedrawId = null
	var lastRedrawCallTime = 0
	var computePreRedrawHook = null
	var computePostRedrawHook = null
	var topComponent
	var FRAME_BUDGET = 16 // 60 frames per second = 1 call per 16 ms

	function parameterize(component, args) {
		function controller() {
			/* eslint-disable no-invalid-this */
			return (component.controller || noop).apply(this, args) || this
			/* eslint-enable no-invalid-this */
		}

		if (component.controller) {
			controller.prototype = component.controller.prototype
		}

		function view(ctrl) {
			var currentArgs = [ctrl].concat(args)
			for (var i = 1; i < arguments.length; i++) {
				currentArgs.push(arguments[i])
			}

			return component.view.apply(component, currentArgs)
		}

		view.$original = component.view
		var output = {controller: controller, view: view}
		if (args[0] && args[0].key != null) output.attrs = {key: args[0].key}
		return output
	}

	m.component = function (component) {
		var args = new Array(arguments.length - 1)

		for (var i = 1; i < arguments.length; i++) {
			args[i - 1] = arguments[i]
		}

		return parameterize(component, args)
	}

	function checkPrevented(component, root, index, isPrevented) {
		if (!isPrevented) {
			m.redraw.strategy("all")
			m.startComputation()
			roots[index] = root
			var currentComponent

			if (component) {
				currentComponent = topComponent = component
			} else {
				currentComponent = topComponent = component = {controller: noop}
			}

			var controller = new (component.controller || noop)()

			// controllers may call m.mount recursively (via m.route redirects,
			// for example)
			// this conditional ensures only the last recursive m.mount call is
			// applied
			if (currentComponent === topComponent) {
				controllers[index] = controller
				components[index] = component
			}
			endFirstComputation()
			if (component === null) {
				removeRootElement(root, index)
			}
			return controllers[index]
		} else if (component == null) {
			removeRootElement(root, index)
		}
	}

	m.mount = m.module = function (root, component) {
		if (!root) {
			throw new Error("Please ensure the DOM element exists before " +
				"rendering a template into it.")
		}

		var index = roots.indexOf(root)
		if (index < 0) index = roots.length

		var isPrevented = false
		var event = {
			preventDefault: function () {
				isPrevented = true
				computePreRedrawHook = computePostRedrawHook = null
			}
		}

		forEach(unloaders, function (unloader) {
			unloader.handler.call(unloader.controller, event)
			unloader.controller.onunload = null
		})

		if (isPrevented) {
			forEach(unloaders, function (unloader) {
				unloader.controller.onunload = unloader.handler
			})
		} else {
			unloaders = []
		}

		if (controllers[index] && isFunction(controllers[index].onunload)) {
			controllers[index].onunload(event)
		}

		return checkPrevented(component, root, index, isPrevented)
	}

	function removeRootElement(root, index) {
		roots.splice(index, 1)
		controllers.splice(index, 1)
		components.splice(index, 1)
		reset(root)
		nodeCache.splice(getCellCacheKey(root), 1)
	}

	var redrawing = false
	m.redraw = function (force) {
		if (redrawing) return
		redrawing = true
		if (force) forcing = true

		try {
			// lastRedrawId is a positive number if a second redraw is requested
			// before the next animation frame
			// lastRedrawId is null if it's the first redraw and not an event
			// handler
			if (lastRedrawId && !force) {
				// when setTimeout: only reschedule redraw if time between now
				// and previous redraw is bigger than a frame, otherwise keep
				// currently scheduled timeout
				// when rAF: always reschedule redraw
				if ($requestAnimationFrame === global.requestAnimationFrame ||
						new Date() - lastRedrawCallTime > FRAME_BUDGET) {
					if (lastRedrawId > 0) $cancelAnimationFrame(lastRedrawId)
					lastRedrawId = $requestAnimationFrame(redraw, FRAME_BUDGET)
				}
			} else {
				redraw()
				lastRedrawId = $requestAnimationFrame(function () {
					lastRedrawId = null
				}, FRAME_BUDGET)
			}
		} finally {
			redrawing = forcing = false
		}
	}

	m.redraw.strategy = m.prop()
	function redraw() {
		if (computePreRedrawHook) {
			computePreRedrawHook()
			computePreRedrawHook = null
		}
		forEach(roots, function (root, i) {
			var component = components[i]
			if (controllers[i]) {
				var args = [controllers[i]]
				m.render(root,
					component.view ? component.view(controllers[i], args) : "")
			}
		})
		// after rendering within a routed context, we need to scroll back to
		// the top, and fetch the document title for history.pushState
		if (computePostRedrawHook) {
			computePostRedrawHook()
			computePostRedrawHook = null
		}
		lastRedrawId = null
		lastRedrawCallTime = new Date()
		m.redraw.strategy("diff")
	}

	function endFirstComputation() {
		if (m.redraw.strategy() === "none") {
			pendingRequests--
			m.redraw.strategy("diff")
		} else {
			m.endComputation()
		}
	}

	m.withAttr = function (prop, withAttrCallback, callbackThis) {
		return function (e) {
			e = e || window.event
			/* eslint-disable no-invalid-this */
			var currentTarget = e.currentTarget || this
			var _this = callbackThis || this
			/* eslint-enable no-invalid-this */
			var target = prop in currentTarget ?
				currentTarget[prop] :
				currentTarget.getAttribute(prop)
			withAttrCallback.call(_this, target)
		}
	}

	// routing
	var modes = {pathname: "", hash: "#", search: "?"}
	var redirect = noop
	var isDefaultRoute = false
	var routeParams, currentRoute

	m.route = function (root, arg1, arg2, vdom) { // eslint-disable-line
		// m.route()
		if (arguments.length === 0) return currentRoute
		// m.route(el, defaultRoute, routes)
		if (arguments.length === 3 && isString(arg1)) {
			redirect = function (source) {
				var path = currentRoute = normalizeRoute(source)
				if (!routeByValue(root, arg2, path)) {
					if (isDefaultRoute) {
						throw new Error("Ensure the default route matches " +
							"one of the routes defined in m.route")
					}

					isDefaultRoute = true
					m.route(arg1, true)
					isDefaultRoute = false
				}
			}

			var listener = m.route.mode === "hash" ?
				"onhashchange" :
				"onpopstate"

			global[listener] = function () {
				var path = $location[m.route.mode]
				if (m.route.mode === "pathname") path += $location.search
				if (currentRoute !== normalizeRoute(path)) redirect(path)
			}

			computePreRedrawHook = setScroll
			global[listener]()

			return
		}

		// config: m.route
		if (root.addEventListener || root.attachEvent) {
			var base = m.route.mode !== "pathname" ? $location.pathname : ""
			root.href = base + modes[m.route.mode] + vdom.attrs.href
			if (root.addEventListener) {
				root.removeEventListener("click", routeUnobtrusive)
				root.addEventListener("click", routeUnobtrusive)
			} else {
				root.detachEvent("onclick", routeUnobtrusive)
				root.attachEvent("onclick", routeUnobtrusive)
			}

			return
		}
		// m.route(route, params, shouldReplaceHistoryEntry)
		if (isString(root)) {
			var oldRoute = currentRoute
			currentRoute = root

			var args = arg1 || {}
			var queryIndex = currentRoute.indexOf("?")
			var params

			if (queryIndex > -1) {
				params = parseQueryString(currentRoute.slice(queryIndex + 1))
			} else {
				params = {}
			}

			for (var i in args) {
				if (hasOwn.call(args, i)) {
					params[i] = args[i]
				}
			}

			var querystring = buildQueryString(params)
			var currentPath

			if (queryIndex > -1) {
				currentPath = currentRoute.slice(0, queryIndex)
			} else {
				currentPath = currentRoute
			}

			if (querystring) {
				currentRoute = currentPath +
					(currentPath.indexOf("?") === -1 ? "?" : "&") +
					querystring
			}

			var replaceHistory =
				(arguments.length === 3 ? arg2 : arg1) === true ||
				oldRoute === root

			if (global.history.pushState) {
				var method = replaceHistory ? "replaceState" : "pushState"
				computePreRedrawHook = setScroll
				computePostRedrawHook = function () {
					try {
						global.history[method](null, $document.title,
							modes[m.route.mode] + currentRoute)
					} catch (err) {
						// In the event of a pushState or replaceState failure,
						// fallback to a standard redirect. This is specifically
						// to address a Safari security error when attempting to
						// call pushState more than 100 times.
						$location[m.route.mode] = currentRoute
					}
				}
				redirect(modes[m.route.mode] + currentRoute)
			} else {
				$location[m.route.mode] = currentRoute
				redirect(modes[m.route.mode] + currentRoute)
			}
		}
	}

	m.route.param = function (key) {
		if (!routeParams) {
			throw new Error("You must call m.route(element, defaultRoute, " +
				"routes) before calling m.route.param()")
		}

		if (!key) {
			return routeParams
		}

		return routeParams[key]
	}

	m.route.mode = "search"

	function normalizeRoute(route) {
		return route.slice(modes[m.route.mode].length)
	}

	function routeByValue(root, router, path) {
		routeParams = {}

		var queryStart = path.indexOf("?")
		if (queryStart !== -1) {
			routeParams = parseQueryString(
				path.substr(queryStart + 1, path.length))
			path = path.substr(0, queryStart)
		}

		// Get all routes and check if there's
		// an exact match for the current path
		var keys = Object.keys(router)
		var index = keys.indexOf(path)

		if (index !== -1){
			m.mount(root, router[keys [index]])
			return true
		}

		for (var route in router) {
			if (hasOwn.call(router, route)) {
				if (route === path) {
					m.mount(root, router[route])
					return true
				}

				var matcher = new RegExp("^" + route
					.replace(/:[^\/]+?\.{3}/g, "(.*?)")
					.replace(/:[^\/]+/g, "([^\\/]+)") + "\/?$")

				if (matcher.test(path)) {
					/* eslint-disable no-loop-func */
					path.replace(matcher, function () {
						var keys = route.match(/:[^\/]+/g) || []
						var values = [].slice.call(arguments, 1, -2)
						forEach(keys, function (key, i) {
							routeParams[key.replace(/:|\./g, "")] =
								decodeURIComponent(values[i])
						})
						m.mount(root, router[route])
					})
					/* eslint-enable no-loop-func */
					return true
				}
			}
		}
	}

	function routeUnobtrusive(e) {
		e = e || event
		if (e.ctrlKey || e.metaKey || e.shiftKey || e.which === 2) return

		if (e.preventDefault) {
			e.preventDefault()
		} else {
			e.returnValue = false
		}

		var currentTarget = e.currentTarget || e.srcElement
		var args

		if (m.route.mode === "pathname" && currentTarget.search) {
			args = parseQueryString(currentTarget.search.slice(1))
		} else {
			args = {}
		}

		while (currentTarget && !/a/i.test(currentTarget.nodeName)) {
			currentTarget = currentTarget.parentNode
		}

		// clear pendingRequests because we want an immediate route change
		pendingRequests = 0
		m.route(currentTarget[m.route.mode]
			.slice(modes[m.route.mode].length), args)
	}

	function setScroll() {
		if (m.route.mode !== "hash" && $location.hash) {
			$location.hash = $location.hash
		} else {
			global.scrollTo(0, 0)
		}
	}

	function buildQueryString(object, prefix) {
		var duplicates = {}
		var str = []

		for (var prop in object) {
			if (hasOwn.call(object, prop)) {
				var key = prefix ? prefix + "[" + prop + "]" : prop
				var value = object[prop]

				if (value === null) {
					str.push(encodeURIComponent(key))
				} else if (isObject(value)) {
					str.push(buildQueryString(value, key))
				} else if (isArray(value)) {
					var keys = []
					duplicates[key] = duplicates[key] || {}
					/* eslint-disable no-loop-func */
					forEach(value, function (item) {
						/* eslint-enable no-loop-func */
						if (!duplicates[key][item]) {
							duplicates[key][item] = true
							keys.push(encodeURIComponent(key) + "=" +
								encodeURIComponent(item))
						}
					})
					str.push(keys.join("&"))
				} else if (value !== undefined) {
					str.push(encodeURIComponent(key) + "=" +
						encodeURIComponent(value))
				}
			}
		}

		return str.join("&")
	}

	function parseQueryString(str) {
		if (str === "" || str == null) return {}
		if (str.charAt(0) === "?") str = str.slice(1)

		var pairs = str.split("&")
		var params = {}

		forEach(pairs, function (string) {
			var pair = string.split("=")
			var key = decodeURIComponent(pair[0])
			var value = pair.length === 2 ? decodeURIComponent(pair[1]) : null
			if (params[key] != null) {
				if (!isArray(params[key])) params[key] = [params[key]]
				params[key].push(value)
			}
			else params[key] = value
		})

		return params
	}

	m.route.buildQueryString = buildQueryString
	m.route.parseQueryString = parseQueryString

	function reset(root) {
		var cacheKey = getCellCacheKey(root)
		clear(root.childNodes, cellCache[cacheKey])
		cellCache[cacheKey] = undefined
	}

	m.deferred = function () {
		var deferred = new Deferred()
		deferred.promise = propify(deferred.promise)
		return deferred
	}

	function propify(promise, initialValue) {
		var prop = m.prop(initialValue)
		promise.then(prop)
		prop.then = function (resolve, reject) {
			return propify(promise.then(resolve, reject), initialValue)
		}

		prop.catch = prop.then.bind(null, null)
		return prop
	}
	// Promiz.mithril.js | Zolmeister | MIT
	// a modified version of Promiz.js, which does not conform to Promises/A+
	// for two reasons:
	//
	// 1) `then` callbacks are called synchronously (because setTimeout is too
	//    slow, and the setImmediate polyfill is too big
	//
	// 2) throwing subclasses of Error cause the error to be bubbled up instead
	//    of triggering rejection (because the spec does not account for the
	//    important use case of default browser error handling, i.e. message w/
	//    line number)

	var RESOLVING = 1
	var REJECTING = 2
	var RESOLVED = 3
	var REJECTED = 4

	function Deferred(onSuccess, onFailure) {
		var self = this
		var state = 0
		var promiseValue = 0
		var next = []

		self.promise = {}

		self.resolve = function (value) {
			if (!state) {
				promiseValue = value
				state = RESOLVING

				fire()
			}

			return self
		}

		self.reject = function (value) {
			if (!state) {
				promiseValue = value
				state = REJECTING

				fire()
			}

			return self
		}

		self.promise.then = function (onSuccess, onFailure) {
			var deferred = new Deferred(onSuccess, onFailure)

			if (state === RESOLVED) {
				deferred.resolve(promiseValue)
			} else if (state === REJECTED) {
				deferred.reject(promiseValue)
			} else {
				next.push(deferred)
			}

			return deferred.promise
		}

		function finish(type) {
			state = type || REJECTED
			next.map(function (deferred) {
				if (state === RESOLVED) {
					deferred.resolve(promiseValue)
				} else {
					deferred.reject(promiseValue)
				}
			})
		}

		function thennable(then, success, failure, notThennable) {
			if (((promiseValue != null && isObject(promiseValue)) ||
					isFunction(promiseValue)) && isFunction(then)) {
				try {
					// count protects against abuse calls from spec checker
					var count = 0
					then.call(promiseValue, function (value) {
						if (count++) return
						promiseValue = value
						success()
					}, function (value) {
						if (count++) return
						promiseValue = value
						failure()
					})
				} catch (e) {
					m.deferred.onerror(e)
					promiseValue = e
					failure()
				}
			} else {
				notThennable()
			}
		}

		function fire() {
			// check if it's a thenable
			var then
			try {
				then = promiseValue && promiseValue.then
			} catch (e) {
				m.deferred.onerror(e)
				promiseValue = e
				state = REJECTING
				return fire()
			}

			if (state === REJECTING) {
				m.deferred.onerror(promiseValue)
			}

			thennable(then, function () {
				state = RESOLVING
				fire()
			}, function () {
				state = REJECTING
				fire()
			}, function () {
				try {
					if (state === RESOLVING && isFunction(onSuccess)) {
						promiseValue = onSuccess(promiseValue)
					} else if (state === REJECTING && isFunction(onFailure)) {
						promiseValue = onFailure(promiseValue)
						state = RESOLVING
					}
				} catch (e) {
					m.deferred.onerror(e)
					promiseValue = e
					return finish()
				}

				if (promiseValue === self) {
					promiseValue = TypeError()
					finish()
				} else {
					thennable(then, function () {
						finish(RESOLVED)
					}, finish, function () {
						finish(state === RESOLVING && RESOLVED)
					})
				}
			})
		}
	}

	m.deferred.onerror = function (e) {
		if (type.call(e) === "[object Error]" &&
				!/ Error/.test(e.constructor.toString())) {
			pendingRequests = 0
			throw e
		}
	}

	m.sync = function (args) {
		var deferred = m.deferred()
		var outstanding = args.length
		var results = []
		var method = "resolve"

		function synchronizer(pos, resolved) {
			return function (value) {
				results[pos] = value
				if (!resolved) method = "reject"
				if (--outstanding === 0) {
					deferred.promise(results)
					deferred[method](results)
				}
				return value
			}
		}

		if (args.length > 0) {
			forEach(args, function (arg, i) {
				arg.then(synchronizer(i, true), synchronizer(i, false))
			})
		} else {
			deferred.resolve([])
		}

		return deferred.promise
	}

	function identity(value) { return value }

	function handleJsonp(options) {
		var callbackKey = options.callbackName || "mithril_callback_" +
			new Date().getTime() + "_" +
			(Math.round(Math.random() * 1e16)).toString(36)

		var script = $document.createElement("script")

		global[callbackKey] = function (resp) {
			script.parentNode.removeChild(script)
			options.onload({
				type: "load",
				target: {
					responseText: resp
				}
			})
			global[callbackKey] = undefined
		}

		script.onerror = function () {
			script.parentNode.removeChild(script)

			options.onerror({
				type: "error",
				target: {
					status: 500,
					responseText: JSON.stringify({
						error: "Error making jsonp request"
					})
				}
			})
			global[callbackKey] = undefined

			return false
		}

		script.onload = function () {
			return false
		}

		script.src = options.url +
			(options.url.indexOf("?") > 0 ? "&" : "?") +
			(options.callbackKey ? options.callbackKey : "callback") +
			"=" + callbackKey +
			"&" + buildQueryString(options.data || {})

		$document.body.appendChild(script)
	}

	function createXhr(options) {
		var xhr = new global.XMLHttpRequest()
		xhr.open(options.method, options.url, true, options.user,
			options.password)

		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4) {
				if (xhr.status >= 200 && xhr.status < 300) {
					options.onload({type: "load", target: xhr})
				} else {
					options.onerror({type: "error", target: xhr})
				}
			}
		}

		if (options.serialize === JSON.stringify &&
				options.data &&
				options.method !== "GET") {
			xhr.setRequestHeader("Content-Type",
				"application/json; charset=utf-8")
		}

		if (options.deserialize === JSON.parse) {
			xhr.setRequestHeader("Accept", "application/json, text/*")
		}

		if (isFunction(options.config)) {
			var maybeXhr = options.config(xhr, options)
			if (maybeXhr != null) xhr = maybeXhr
		}

		var data = options.method === "GET" || !options.data ? "" : options.data

		if (data && !isString(data) && data.constructor !== global.FormData) {
			throw new Error("Request data should be either be a string or " +
				"FormData. Check the `serialize` option in `m.request`")
		}

		xhr.send(data)
		return xhr
	}

	function ajax(options) {
		if (options.dataType && options.dataType.toLowerCase() === "jsonp") {
			return handleJsonp(options)
		} else {
			return createXhr(options)
		}
	}

	function bindData(options, data, serialize) {
		if (options.method === "GET" && options.dataType !== "jsonp") {
			var prefix = options.url.indexOf("?") < 0 ? "?" : "&"
			var querystring = buildQueryString(data)
			options.url += (querystring ? prefix + querystring : "")
		} else {
			options.data = serialize(data)
		}
	}

	function parameterizeUrl(url, data) {
		if (data) {
			url = url.replace(/:[a-z]\w+/gi, function (token){
				var key = token.slice(1)
				var value = data[key] || token
				delete data[key]
				return value
			})
		}
		return url
	}

	m.request = function (options) {
		if (options.background !== true) m.startComputation()
		var deferred = new Deferred()
		var isJSONP = options.dataType &&
			options.dataType.toLowerCase() === "jsonp"

		var serialize, deserialize, extract

		if (isJSONP) {
			serialize = options.serialize =
			deserialize = options.deserialize = identity

			extract = function (jsonp) { return jsonp.responseText }
		} else {
			serialize = options.serialize = options.serialize || JSON.stringify

			deserialize = options.deserialize =
				options.deserialize || JSON.parse
			extract = options.extract || function (xhr) {
				if (xhr.responseText.length || deserialize !== JSON.parse) {
					return xhr.responseText
				} else {
					return null
				}
			}
		}

		options.method = (options.method || "GET").toUpperCase()
		options.url = parameterizeUrl(options.url, options.data)
		bindData(options, options.data, serialize)
		options.onload = options.onerror = function (ev) {
			try {
				ev = ev || event
				var response = deserialize(extract(ev.target, options))
				if (ev.type === "load") {
					if (options.unwrapSuccess) {
						response = options.unwrapSuccess(response, ev.target)
					}

					if (isArray(response) && options.type) {
						forEach(response, function (res, i) {
							response[i] = new options.type(res)
						})
					} else if (options.type) {
						response = new options.type(response)
					}

					deferred.resolve(response)
				} else {
					if (options.unwrapError) {
						response = options.unwrapError(response, ev.target)
					}

					deferred.reject(response)
				}
			} catch (e) {
				deferred.reject(e)
				m.deferred.onerror(e)
			} finally {
				if (options.background !== true) m.endComputation()
			}
		}

		ajax(options)
		deferred.promise = propify(deferred.promise, options.initialValue)
		return deferred.promise
	}

	return m
}); // eslint-disable-line

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)(module)))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_sdk_wrapper_1 = __webpack_require__(0);
var logging_1 = __webpack_require__(2);
var functions_1 = __webpack_require__(3);
var subscribe_to_emitter_1 = __webpack_require__(11);
var errors_1 = __webpack_require__(6);
function logToActivities(statisticsEventsEmitter) {
    var events = {
        trackPlayStart: {
            endpoint: js_sdk_wrapper_1.WixSdk.Activities.Type.TRACK_PLAY,
            params: getTrackParams
        },
        trackSkipped: {
            endpoint: js_sdk_wrapper_1.WixSdk.Activities.Type.TRACK_SKIP,
            params: getTrackParams
        },
        trackPlayCompleted: {
            endpoint: js_sdk_wrapper_1.WixSdk.Activities.Type.TRACK_PLAYED,
            params: getTrackParams
        },
        trackShareClicked: {
            endpoint: js_sdk_wrapper_1.WixSdk.Activities.Type.TRACK_SHARE,
            params: function (args) { return (__assign({}, getTrackParams(args), { sharedTo: args.network.toUpperCase() })); }
        },
        albumPlayCompleted: {
            endpoint: js_sdk_wrapper_1.WixSdk.Activities.Type.ALBUM_PLAYED,
            params: getAlbumParams
        },
        albumShareClicked: {
            endpoint: js_sdk_wrapper_1.WixSdk.Activities.Type.ALBUM_SHARE,
            params: function (args) { return (__assign({}, getAlbumParams(args), { sharedTo: args.network.toUpperCase() })); }
        }
    };
    subscribe_to_emitter_1.subscribeToEmitter(statisticsEventsEmitter, events, send);
    function send(eventName, eventDescription, eventArgs) {
        var viewMode = js_sdk_wrapper_1.WixSdk.Utils.getViewMode();
        if (viewMode === 'editor' || viewMode === 'preview') {
            return;
        }
        var data = {
            type: eventDescription.endpoint,
            info: eventDescription.params(eventArgs),
            details: null,
            contactUpdate: null
        };
        try {
            js_sdk_wrapper_1.WixSdk.Activities.postActivity(data, functions_1.noop, function (reason) {
                logging_1.logError(errors_1.BI_ERRORS.widget.statistic.activity.send, { reason: reason });
            });
        }
        catch (reason) {
            logging_1.logError(errors_1.BI_ERRORS.widget.statistic.activity.send, { reason: reason });
        }
    }
    function getAlbumParams(_a) {
        var album = _a.album;
        return {
            album: { id: album.id, name: album.name },
            artist: { name: album.artistName }
        };
    }
    function getTrackParams(_a) {
        var album = _a.album, track = _a.track;
        return __assign({}, getAlbumParams({ album: album }), { track: { id: track.id, name: track.name } });
    }
}
exports.logToActivities = logToActivities;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable camelcase */
var js_sdk_wrapper_1 = __webpack_require__(0);
var send_request_1 = __webpack_require__(20);
var errors_1 = __webpack_require__(6);
var logging_1 = __webpack_require__(2);
var subscribe_to_emitter_1 = __webpack_require__(11);
function logToCounters(statisticsEvents, _a) {
    var siteOwnerId = _a.siteOwnerId;
    var events = {
        trackPlayStart: {
            type: 'song',
            name: 'play',
            params: baseTrackData
        },
        trackSkipped: {
            type: 'song',
            name: 'skip',
            params: baseTrackData
        },
        trackPlayCompleted: {
            type: 'song',
            name: 'completed',
            params: baseTrackData
        },
        trackShareClicked: {
            type: 'song',
            name: 'share',
            params: function (args) { return (__assign({}, baseTrackData(args), { social: args.network })); }
        },
        albumShareClicked: {
            type: 'album',
            name: 'share',
            params: function (args) { return (__assign({}, baseAlbumData(args), { social: args.network })); }
        }
    };
    subscribe_to_emitter_1.subscribeToEmitter(statisticsEvents, events, send);
    function send(eventName, eventDescription, eventArgs) {
        var viewMode = js_sdk_wrapper_1.WixSdk.Utils.getViewMode();
        if (viewMode === 'editor' || viewMode === 'preview') {
            return;
        }
        var data = {
            messageId: Date.now(),
            metrics: [{
                    type: eventDescription.type,
                    reportMetrics: [{
                            name: eventDescription.name,
                            value: 1
                        }],
                    properties: __assign({ user_id: siteOwnerId }, eventDescription.params(eventArgs))
                }]
        };
        sendReport(data);
    }
    function baseAlbumData(_a) {
        var album = _a.album;
        return {
            album_id: album.id,
            album_type: album.albumType
        };
    }
    function baseTrackData(args) {
        return __assign({}, baseAlbumData(args), { song_id: String(args.track.id) });
    }
}
exports.logToCounters = logToCounters;
function sendReport(data) {
    var ctToken;
    js_sdk_wrapper_1.WixSdk.SuperApps.getCtToken()
        .then(function (_ctToken) {
        ctToken = _ctToken;
        if (!ctToken) {
            logging_1.logError(errors_1.BI_ERRORS.widget.statistic.counters.emptyCtToken);
        }
        return send_request_1.sendRequest({
            method: 'POST',
            url: '//player-counters.wix.com/collector/rest/collect-js',
            params: { ctToken: ctToken },
            data: data
        });
    })
        .catch(function (reason) {
        var userAgent = 'unknown';
        try {
            userAgent = navigator.userAgent;
        }
        finally {
            logging_1.logError(errors_1.BI_ERRORS.widget.statistic.counters.send, { reason: reason, ctToken: ctToken, userAgent: userAgent });
        }
    });
}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function dashToSnakeCase(str) {
    return str
        .split('-')
        .map(function (part, index) {
        return index ? part[0].toUpperCase() + part.slice(1) : part;
    })
        .join('');
}
exports.dashToSnakeCase = dashToSnakeCase;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var js_sdk_wrapper_1 = __webpack_require__(0);
function getInstanceId() {
    /* global WMP */
    try {
        return WMP.wixUtils.getInstanceId();
    }
    catch (ex) {
        return '';
    }
}
exports.getInstanceId = getInstanceId;
function getBiToken() {
    try {
        return WMP.wixUtils.getBiToken();
    }
    catch (ex) {
        return '';
    }
}
exports.getBiToken = getBiToken;
function openPopupOrModal(opener) {
    js_sdk_wrapper_1.WixSdk.getBoundingRectAndOffsets()
        .then(function (rectAndOffsets) {
        var offsets = rectAndOffsets.offsets;
        var rect = rectAndOffsets.rect;
        function restoreScroll() {
            js_sdk_wrapper_1.WixSdk.scrollTo(offsets.x, offsets.y - rect.top);
        }
        opener(restoreScroll);
    });
}
// eslint-disable-next-line max-params
function openPopup(path, width, height, callback, theme) {
    var opener = function (restoreScroll) {
        js_sdk_wrapper_1.WixSdk.openPopup(path, width, height, {
            origin: js_sdk_wrapper_1.WixSdk.WindowOrigin.FIXED,
            placement: js_sdk_wrapper_1.WixSdk.WindowPlacement.CENTER
        }, function () {
            callback.apply(null, arguments);
            restoreScroll();
        }, theme);
    };
    if (js_sdk_wrapper_1.WixSdk.Utils.getDeviceType() === 'mobile') {
        opener = function (restoreScroll) {
            js_sdk_wrapper_1.WixSdk.openModal(path, width, height, function () {
                callback.apply(null, arguments);
                restoreScroll();
            }, theme);
        };
    }
    openPopupOrModal(opener);
}
exports.openPopup = openPopup;
// eslint-disable-next-line max-params
function openModal(path, width, height, callback, theme) {
    var opener = function (restoreScroll) {
        js_sdk_wrapper_1.WixSdk.openModal(path, width, height, theme)
            .then(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            callback.apply(void 0, args);
            restoreScroll();
        });
    };
    openPopupOrModal(opener);
}
exports.openModal = openModal;
function scrollToPlayer() {
    js_sdk_wrapper_1.WixSdk.getBoundingRectAndOffsets().then(function (rectAndOffsets) {
        var offsets = rectAndOffsets.offsets;
        js_sdk_wrapper_1.WixSdk.scrollTo(offsets.x, offsets.y - 20); // 20 to look better
    });
}
exports.scrollToPlayer = scrollToPlayer;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(18);
exports.layoutValues = (_a = {},
    _a[constants_1.LAYOUTS_VERTICAL] = {
        width: constants_1.DEFAULT_VERTICAL_WIDTH
    },
    _a[constants_1.LAYOUTS_HORIZONTAL] = {
        width: 680
    },
    _a[constants_1.LAYOUTS_LIST] = {
        width: 680
    },
    _a);
var _a;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(23),
    getRawTag = __webpack_require__(50),
    objectToString = __webpack_require__(51);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(48);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(32),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function cloneObject(obj) {
    return JSON.parse(JSON.stringify(obj));
}
exports.cloneObject = cloneObject;
function every(array, callback) {
    return Array.prototype.every.call(array, callback);
}
exports.every = every;
function areObjectsEqual() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var objects = arguments;
    return every(objects, function (obj, i) {
        if (i === 0) {
            return true;
        }
        var prevObject = objects[i - 1];
        var currObject = objects[i];
        if (!prevObject || !currObject) {
            return false;
        }
        if (typeof prevObject !== 'object' || typeof currObject !== 'object') {
            return false;
        }
        var doesPrevContainCurr = every(Object.keys(prevObject), function (key) {
            var prevValue = prevObject[key];
            var currValue = currObject[key];
            if (typeof prevValue === 'object' && typeof currValue === 'object') {
                return areObjectsEqual(prevValue, currValue);
            }
            return prevValue === currValue;
        });
        var doesCurrContainPrev = every(Object.keys(currObject), function (key) {
            var prevValue = prevObject[key];
            var currValue = currObject[key];
            if (typeof prevValue === 'object' && typeof currValue === 'object') {
                return areObjectsEqual(prevValue, currValue);
            }
            return prevValue === currValue;
        });
        return doesPrevContainCurr && doesCurrContainPrev;
    });
}
exports.areObjectsEqual = areObjectsEqual;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function writeOops(text) {
    if (text === void 0) { text = 'Ooops. Something went wrong. Please reload the page.'; }
    var span = document.createElement('span');
    span.textContent = text;
    document.body.appendChild(span);
}
exports.writeOops = writeOops;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded chunks
/******/ 	// "0" means "already loaded"
/******/ 	var installedChunks = {
/******/ 		15: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_inner_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_inner_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_inner_require__.e = function requireEnsure(chunkId) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] !== 0) {
/******/ 			return __webpack_require__(87)("./wix-music-widget-" + chunkId + ".js").then(function (chunk) {
/******/ 				var moreModules = chunk.modules, chunkIds = chunk.ids;
/******/ 				for(var moduleId in moreModules) {
/******/ 					modules[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 				for(var i = 0; i < chunkIds.length; i++)
/******/ 					installedChunks[chunkIds[i]] = 0;
/******/ 			});
/******/ 		}
/******/ 		return Promise.resolve();
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_inner_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_inner_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_inner_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_inner_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_inner_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_inner_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_inner_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_inner_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_inner_require__.p = "";
/******/
/******/ 	// uncatched error handler for webpack runtime
/******/ 	__webpack_inner_require__.oe = function(err) {
/******/ 		process.nextTick(function() {
/******/ 			throw err; // catch this error by using System.import().catch()
/******/ 		});
/******/ 	};
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_inner_require__(__webpack_inner_require__.s = 371);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/* no static exports found */
/* all exports used */
/*!**************************!*\
  !*** external "mithril" ***!
  \**************************/
/***/ (function(module, exports) {

module.exports = __webpack_require__(25);

/***/ }),

/***/ 1:
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./scripts/utils/utils.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utils = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _desc, _value, _obj;

exports.camelCase = camelCase;

var _wixSdk = __webpack_require__(/*! ../common/wix-sdk */ 5);

var Wix = _interopRequireDefault(_wixSdk).default;

var _constants = __webpack_require__(/*! ../common/constants */ 2);

var constants = _interopRequireDefault(_constants).default;

var _config = __webpack_require__(/*! ../common/config */ 3);

var config = _interopRequireDefault(_config).default;

var _sendRequest = __webpack_require__(/*! ./send-request */ 39);

var sendRequest = _sendRequest.sendRequest;

var _deprecated = __webpack_require__(/*! ./deprecated */ 7);

var deprecated = _deprecated.deprecated;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function createRegexp(t, options) {
  t = t.replace(/[()\[\]\.^$|?+]/g, '\\$&');
  return new RegExp(t, options);
}

var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  });
}

var utils = exports.utils = (_obj = {
  getObjectType: function getObjectType(obj) {
    return Object.prototype.toString.call(obj).split(' ')[1].slice(0, -1);
  },
  isObjectAndNotNullOrArray: function isObjectAndNotNullOrArray(obj) {
    return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null && !Array.isArray(obj);
  },
  durationToString: function durationToString(duration) {
    var chunks = [];
    var chunk = void 0;
    duration = Math.floor(duration);
    do {
      chunk = duration % 60;
      if (chunk <= 9) {
        chunk = '0' + chunk;
      }
      chunks.unshift(chunk);
      duration = Math.floor(duration / 60);
    } while (duration > 0);

    if (chunks.length < 2) {
      chunks.unshift('00');
    }

    return chunks.join(':');
  },
  stringToDuration: function stringToDuration(durationString) {
    if (!durationString) {
      return 0;
    }
    return durationString.split(':').reverse().reduce(function (duration, chunk, i) {
      return duration + chunk * Math.pow(60, i);
    }, 0);
  },
  forEach: function forEach(object, callback) {
    var objectIterator = function objectIterator(key) {
      var value = object[key];
      var result = callback.call(value, key, value);
      if (typeof result === 'boolean') {
        return result;
      }
      return true;
    };

    var listIterator = function listIterator(value, index) {
      var result = callback.call(value, value, index);
      if (typeof result === 'boolean') {
        return result;
      }
      return true;
    };

    if (utils.getObjectType(object) === 'Object' || object.length === undefined) {
      Object.keys(object).every(objectIterator);
      return;
    }

    if (Array.isArray(object)) {
      object.every(listIterator);
      return;
    }

    [].every.call(object, listIterator);
  },
  find: function find(array, predicate) {
    var foundElement = void 0;
    utils.forEach(array, function (element, index) {
      if (predicate(element, index)) {
        foundElement = element;
        return false;
      }
    });
    return foundElement;
  },
  includes: function includes(array, element) {
    return [].some.call(array, function (value) {
      return value === element;
    });
  },
  filter: function filter(array, predicate) {
    return [].filter.call(array, predicate);
  },


  // extend is not recursive
  extend: function extend(destination) {
    if (!utils.isObjectAndNotNullOrArray(destination)) {
      destination = {};
    }

    for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      sources[_key - 1] = arguments[_key];
    }

    sources.forEach(function (source) {
      if (!utils.isObjectAndNotNullOrArray(source)) {
        return;
      }

      utils.forEach(source, function (prop) {
        destination[prop] = source[prop];
      });
    });

    return destination;
  },


  // merge is recursive
  merge: function merge(destination) {
    if (!utils.isObjectAndNotNullOrArray(destination)) {
      destination = {};
    }

    for (var _len2 = arguments.length, sources = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      sources[_key2 - 1] = arguments[_key2];
    }

    sources.forEach(function (source) {
      if (!utils.isObjectAndNotNullOrArray(source)) {
        return;
      }

      utils.forEach(source, function (prop) {
        if (utils.isObjectAndNotNullOrArray(source[prop])) {
          destination[prop] = utils.merge(destination[prop], source[prop]);
          return;
        }

        destination[prop] = source[prop];
      });
    });

    return destination;
  },


  // defaults is recursive
  defaults: function defaults(destination) {
    if (!utils.isObjectAndNotNullOrArray(destination)) {
      destination = {};
    }

    var hop = {}.hasOwnProperty;

    for (var _len3 = arguments.length, sources = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      sources[_key3 - 1] = arguments[_key3];
    }

    sources.forEach(function (source) {
      utils.forEach(source, function (prop) {
        if (hop.call(destination, prop) && destination[prop] !== undefined && !utils.isObjectAndNotNullOrArray(destination[prop])) {
          return;
        }

        if (utils.isObjectAndNotNullOrArray(source[prop])) {
          destination[prop] = utils.defaults(destination[prop], source[prop]);
          return;
        }

        destination[prop] = source[prop];
      });
    });

    return destination;
  },
  insertDataInTemplate: function insertDataInTemplate(template) {
    for (var _len4 = arguments.length, dataSources = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      dataSources[_key4 - 1] = arguments[_key4];
    }

    dataSources.forEach(function (dataSource) {
      utils.forEach(dataSource, function (key, value) {
        template = template.replace(createRegexp('#' + key + '#', 'g'), value);
      });
    });

    return template;
  },
  getUrlParam: function getUrlParam(name, url) {
    var pairsSep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '&';
    var valuesSep = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '=';

    var matched = new RegExp('(?:^|[?' + pairsSep + '])\\s*?' + name + valuesSep + '([^' + pairsSep + ']*)').exec(url || document.location.href);
    if (!matched) {
      return '';
    }
    return matched[1].trim();
  },
  params: function params(data) {
    var getParams = [];
    utils.forEach(data, function (key, value) {
      if (value !== undefined) {
        getParams.push(key + '=' + encodeURIComponent(value));
      }
    });
    return getParams.join('&');
  },
  getJSON: function getJSON(url) {
    return sendRequest({ method: 'GET', url: url }).then(function (response) {
      return response.data;
    });
  },
  postJSON: function postJSON(url, data) {
    return sendRequest({ method: 'POST', url: url, data: data });
  },
  openPopup: function openPopup(url, width, height) {
    var left = (window.screen.width - width) / 2,
        top = (window.screen.height - height) / 2;

    var win = window.open(url, '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);

    if (win) {
      if (win.moveTo) {
        win.moveTo(left, top);
      }
      win.focus();
    }
  },
  buildScaledImageUrl: function buildScaledImageUrl(originalUrl, mode, width, height) {
    width = Math.round(width);
    height = Math.round(height);
    var file = originalUrl.split('/').pop();

    var _file$split = file.split('.'),
        _file$split2 = _slicedToArray(_file$split, 2),
        fileName = _file$split2[0],
        fileExtension = _file$split2[1];

    var sourceName = config.imageUrls.sourceName;

    var urlStart = originalUrl + '/v1/' + mode + '/w_' + width + ',h_' + height;
    var urlEnd = fileName + '_' + sourceName + '.' + fileExtension;

    if (/jpe?g/i.test(fileExtension)) {
      var jpgParams = config.imageUrls.jpgParams;
      return urlStart + ',q_' + jpgParams.q + ',usm_' + jpgParams.usm + '/' + urlEnd;
    }

    return urlStart + '/' + urlEnd;
  },
  isAbsoluteUrl: function isAbsoluteUrl(url) {
    return (/^(https?:)?\/\//.test(url)
    );
  },
  isMobileView: function isMobileView() {
    return Boolean(Wix && Wix.Utils && Wix.Utils.getDeviceType() === constants.DEVICE_TYPES.MOBILE);
  },
  isString: function isString(value) {
    return typeof value === 'string' || value instanceof String;
  },
  isFunction: function isFunction(value) {
    return typeof value === 'function';
  },
  getHostAndPath: function getHostAndPath(withProtocol) {
    var protocol = withProtocol ? location.protocol : '';
    var host = location.host;
    var pathName = location.pathname.replace(/[^/]+$/, '');
    return protocol + '//' + host + pathName;
  },
  loadImage: function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function () {
        reject(img);
      };
      img.src = src;
    });
  },
  encodeHTML: function encodeHTML(html) {
    var encodeHTMLRules = { '&': '&#38;', '<': '&#60;', '>': '&#62;', '"': '&#34;', '\'': '&#39;', '/': '&#47;' };
    var matchHTML = /&(?!#?\w+;)|<|>|"|'|\//g;

    if (!html) {
      return '';
    }

    return html.toString().replace(matchHTML, function (m) {
      return encodeHTMLRules[m] || m;
    });
  },


  /**
   * Modulo operation returning always a positive remainder.
   * mod(-1, 5) === 4
   * @param a {number} dividend
   * @param b {number} divisor
   * @returns {number} positive remainder
   */
  mod: function mod(a, b) {
    //noinspection Eslint
    return (b + a % b) % b;
  },
  noop: function noop() {}
}, (_applyDecoratedDescriptor(_obj, 'isMobileView', [deprecated], Object.getOwnPropertyDescriptor(_obj, 'isMobileView'), _obj)), _obj);

exports.default = utils;

/***/ }),

/***/ 10:
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./scripts/app-status/app-status.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appStatus = exports.AppStatus = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(/*! events */ 8);

var EventEmitter = _interopRequireDefault(_events).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppStatus = exports.AppStatus = function (_EventEmitter) {
  _inherits(AppStatus, _EventEmitter);

  function AppStatus() {
    _classCallCheck(this, AppStatus);

    return _possibleConstructorReturn(this, (AppStatus.__proto__ || Object.getPrototypeOf(AppStatus)).apply(this, arguments));
  }

  _createClass(AppStatus, [{
    key: 'report',
    value: function report(name, attributes) {
      this.emit('metric', name, attributes);
    }
  }]);

  return AppStatus;
}(EventEmitter);

var appStatus = exports.appStatus = new AppStatus();

/***/ }),

/***/ 12:
/* no static exports found */
/* all exports used */
/*!************************!*\
  !*** ../env/prod.json ***!
  \************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"dgs": "//dgs.wixapps.net/",
	"currenciesUrl": "http://dgs.wixapps.net/pp/paypal_currencies"
};

/***/ }),

/***/ 13:
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./scripts/_bootstrap.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! ./utils/polyfills */ 37);

/* global WIX_MUSIC_WIDGET_PUBLIC_PATH:false */

if (typeof WIX_MUSIC_WIDGET_PUBLIC_PATH !== 'undefined') {
  __webpack_require__.p = WIX_MUSIC_WIDGET_PUBLIC_PATH;
}

/***/ }),

/***/ 145:
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** external "lodash/uniqueId" ***!
  \**********************************/
/***/ (function(module, exports) {

module.exports = __webpack_require__(60);

/***/ }),

/***/ 146:
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** ./scripts/common/get-version.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVersion = getVersion;
function getVersion(widgetSettings) {
  var defaultVersion = 3;
  var styleParamsVersion = widgetSettings.numbers && widgetSettings.numbers['wmp::styleParamsVersion'];
  var isMigrated = widgetSettings.booleans && widgetSettings.booleans['wmp::isMigrated'];

  return styleParamsVersion || (isMigrated ? 1 : defaultVersion);
}

/***/ }),

/***/ 15:
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./scripts/player/v2/shared/errors/error-reporter.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorReporter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _events = __webpack_require__(/*! events */ 8);

var EventEmitter = _interopRequireDefault(_events).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorReporter = function (_EventEmitter) {
  _inherits(ErrorReporter, _EventEmitter);

  function ErrorReporter() {
    _classCallCheck(this, ErrorReporter);

    return _possibleConstructorReturn(this, (ErrorReporter.__proto__ || Object.getPrototypeOf(ErrorReporter)).apply(this, arguments));
  }

  _createClass(ErrorReporter, [{
    key: 'emit',
    value: function emit(errorDescription) {
      try {
        _get(ErrorReporter.prototype.__proto__ || Object.getPrototypeOf(ErrorReporter.prototype), 'emit', this).apply(this, arguments);
      } catch (ex) {
        if (ex.message === 'Uncaught, unspecified "error" event.') {
          var _console;

          (_console = console).error.apply(_console, ['Error: ' + errorDescription.name].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line  no-console
          return;
        }
        throw ex;
      }
    }
  }, {
    key: 'report',
    value: function report(errorDescriptor, errorArgs) {
      this.emit('error', errorDescriptor, errorArgs);
    }
  }, {
    key: 'createPromiseErrorHandler',
    value: function createPromiseErrorHandler(errorDescriptor) {
      var _this2 = this;

      return function (reason) {
        _this2.report(errorDescriptor, { reason: reason });
        return Promise.reject(reason);
      };
    }
  }]);

  return ErrorReporter;
}(EventEmitter);

var errorReporter = new ErrorReporter();

exports.errorReporter = errorReporter;

/***/ }),

/***/ 2:
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./scripts/common/constants.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants$MUSIC_VERS, _constants$TRACK_VERS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var constants = {
  PREVIEW_TYPES: {
    FULL: 'FULL',
    PREVIEW_30: 'PREVIEW_30'
  },
  PREVIEW_LENGTH: {
    PREVIEW_30: 30
  },
  MUSIC_VERSIONS: {
    EMPTY: 'EMPTY',
    REMIXES: 'REMIXES',
    REMASTERED: 'REMASTERED',
    CLEAN: 'CLEAN',
    LIVE: 'LIVE',
    BONUS: 'BONUS',
    DELUXE: 'DELUXE',
    SPECIAL: 'SPECIAL',
    ACOUSTIC: 'ACOUSTIC',
    DEMO: 'DEMO'
  },
  TRACK_VERSIONS: {
    EMPTY: 'EMPTY',
    CLEAN: 'CLEAN',
    EDITED: 'EDITED',
    BONUS: 'BONUS',
    EXPLICIT: 'EXPLICIT',
    DIRTY: 'DIRTY',
    ACOUSTIC: 'ACOUSTIC',
    DEMO: 'DEMODEMO', // for some reason it was saved like this...
    LIVE: 'LIVE',
    RADIO: 'RADIO'
  },
  DEVICE_TYPES: {
    MOBILE: 'mobile'
  },
  VIEW_MODES: {
    EDITOR: 'editor',
    SITE: 'site',
    STANDALONE: 'standalone',
    PREVIEW: 'preview',
    DASHBOARD: 'dashboard' // opens in shout out
  },
  TRACK_PAGE_DIMENSIONS: {
    WIDTH: 775,
    HEIGHT: 630
  },
  ALBUM_TYPES: {
    ALBUM: 'ALBUM',
    SINGLE: 'SINGLE',
    PLAYLIST: 'PLAYLIST'
  }
};

constants.MUSIC_VERSIONS_LABELS = (_constants$MUSIC_VERS = {}, _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.EMPTY, 'player_music_album_versions_empty'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.REMIXES, 'player_music_album_versions_remixes'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.REMASTERED, 'player_music_album_versions_remastered'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.CLEAN, 'player_music_album_versions_clean'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.LIVE, 'player_music_album_versions_live'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.BONUS, 'player_music_album_versions_bonus'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.DELUXE, 'player_music_album_versions_deluxe'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.SPECIAL, 'player_music_album_versions_special'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.ACOUSTIC, 'player_music_album_versions_acoustic'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.DEMO, 'player_music_album_versions_demo'), _constants$MUSIC_VERS);

constants.TRACK_VERSIONS_LABELS = (_constants$TRACK_VERS = {}, _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.EMPTY, 'player_track_versions_empty'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.CLEAN, 'player_track_versions_clean'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.EDITED, 'player_track_versions_edited'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.BONUS, 'player_track_versions_bonus'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.EXPLICIT, 'player_track_versions_explicit'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.DIRTY, 'player_track_versions_dirty'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.ACOUSTIC, 'player_track_versions_acoustic'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.DEMO, 'player_track_versions_demo'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.LIVE, 'player_track_versions_live'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.RADIO, 'player_track_versions_radio'), _constants$TRACK_VERS);

exports.default = constants;

/***/ }),

/***/ 283:
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** external "perfect-scrollbar" ***!
  \************************************/
/***/ (function(module, exports) {

module.exports = __webpack_require__(63);

/***/ }),

/***/ 292:
/* no static exports found */
/* all exports used */
/*!**************************!*\
  !*** ./scripts/index.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appStatus = exports.errorReporter = undefined;

var _errorReporter = __webpack_require__(/*! ./player/v2/shared/errors/error-reporter */ 15);

Object.defineProperty(exports, 'errorReporter', {
  enumerable: true,
  get: function get() {
    return _errorReporter.errorReporter;
  }
});

var _appStatus = __webpack_require__(/*! ./app-status/app-status */ 10);

Object.defineProperty(exports, 'appStatus', {
  enumerable: true,
  get: function get() {
    return _appStatus.appStatus;
  }
});
exports.init = init;

var _getVersion = __webpack_require__(/*! ./common/get-version */ 146);

var getVersion = _getVersion.getVersion;

var _initByCollectionIdFn = __webpack_require__(/*! ./player/init-by-collection-id-fn */ 50);

var initByCollectionIdFn = _interopRequireDefault(_initByCollectionIdFn).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(element, options) {
  var isMobileView = options.isMobileView;
  var version = getVersion(options);
  var initPromise = __webpack_require__(/*! ./player */ 370)("./init-" + (isMobileView ? 'mobile' : 'desktop') + '-v' + version).then(function (module) {
    return module.default;
  });

  return new Promise(function (resolve, reject) {
    initPromise.catch(reject);
    initByCollectionIdFn(initPromise)(element, options, options.albumId, function (result) {
      if (result instanceof Error) {
        reject(result);
      } else {
        resolve(result);
      }
    });
  });
}

/***/ }),

/***/ 3:
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./scripts/common/config.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _require = __webpack_require__(/*! env-config */ 12),
    dgs = _require.dgs;

var config = {
  hosts: {
    collections: '//collections.wixstatic.com/',
    legacyCollections: '//static.wixstatic.com/',
    audios: '//static.wixstatic.com/preview/',
    images: '//static.wixstatic.com/',
    bi: 'https://frog.wix.com/music-ugc',
    currencies: '//dgs.wixapps.net/pp/paypal_currencies',
    dgs: dgs
  },
  files: {
    trackPage: 'widget-track.html',
    featureDisabledPage: 'widget-feature-disabled.html',
    fbRedirectPage: 'fb-redirect.html'
  },
  htmlIds: {
    albumPage: 'WixMusicPlayerWidget',
    trackPage: 'WixMusicTrackPage'
  },
  htmlTags: {
    albumPage: 'wix-pl-app',
    trackPage: 'wix-pl-track'
  },
  imageUrls: {
    sourceName: 'mscwdt',
    jpgParams: {
      q: 85,
      usm: '0.66_1.00_0.01'
    }
  }
};

exports.default = config;

/***/ }),

/***/ 343:
/* no static exports found */
/* all exports used */
/*!***************************!*\
  !*** external "clamp-js" ***!
  \***************************/
/***/ (function(module, exports) {

module.exports = __webpack_require__(42);

/***/ }),

/***/ 37:
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./scripts/utils/polyfills/index.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! ./raf-polyfill */ 38);

/***/ }),

/***/ 370:
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./scripts/player lazy ^\.\/init\-.*$ ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./init-by-collection-id-fn": [
		50
	],
	"./init-by-collection-id-fn.js": [
		50
	],
	"./init-desktop": [
		285,
		0
	],
	"./init-desktop-v1": [
		284,
		6
	],
	"./init-desktop-v1.js": [
		284,
		6
	],
	"./init-desktop-v2": [
		269,
		2
	],
	"./init-desktop-v2.js": [
		269,
		2
	],
	"./init-desktop-v3": [
		270,
		1
	],
	"./init-desktop-v3.js": [
		270,
		1
	],
	"./init-desktop.js": [
		285,
		0
	],
	"./init-mobile": [
		273,
		3
	],
	"./init-mobile-v1": [
		275,
		7
	],
	"./init-mobile-v1.js": [
		275,
		7
	],
	"./init-mobile-v2": [
		276,
		5
	],
	"./init-mobile-v2.js": [
		276,
		5
	],
	"./init-mobile-v3": [
		277,
		4
	],
	"./init-mobile-v3.js": [
		277,
		4
	],
	"./init-mobile.js": [
		273,
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 370;

/***/ }),

/***/ 371:
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** multi ./scripts/_bootstrap.js ./scripts/index.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ./scripts/_bootstrap.js */13);
module.exports = __webpack_require__(/*! ./scripts/index.js */292);


/***/ }),

/***/ 38:
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./scripts/utils/polyfills/raf-polyfill.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function () {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
    var id = window.setTimeout(function () {
      callback(currTime + timeToCall);
    }, timeToCall);
    lastTime = currTime + timeToCall;
    return id;
  };

  if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
    clearTimeout(id);
  };
})();

/***/ }),

/***/ 39:
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** ./scripts/utils/send-request.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.sendRequest = sendRequest;
// if you change anything here, please also update copy in wix-music-dashboards app/modules/widget/utils/send-request.js
function sendRequest(options) {
  options = _extends({
    method: 'GET',
    type: 'json'
  }, options);

  if (!options.url) {
    throw new TypeError('url is not specified');
  }

  if (options.type === 'json') {
    options = withJsonDefaults(options);
  }

  var _options = options,
      method = _options.method,
      url = _options.url,
      data = _options.data,
      params = _options.params,
      headers = _options.headers;

  var parametrizedUrl = createParametrizeUrl(url, params);

  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();

    request.addEventListener('load', function () {
      var response = { status: request.status, text: request.responseText };
      try {
        response.data = parseResponseBody(request);
      } catch (reason) {
        reject(reason);
      }
      if (request.status < 200 || request.status > 299) {
        reject(response);
        return;
      }
      resolve(response);
    });

    function onError(status, text) {
      return function () {
        reject({ status: status, text: text });
      };
    }

    request.addEventListener('error', onError(-100, 'error'));
    request.addEventListener('abort', onError(-200, 'aborted'));

    request.open(method, parametrizedUrl, true);
    Object.keys(headers).forEach(function (header) {
      request.setRequestHeader(header, headers[header]);
    });
    request.send(data);
  });
}

function withJsonDefaults(options) {
  function getHeaders() {
    var headers = {
      Accept: 'application/json'
    };
    if (options.method === 'POST') {
      headers['Content-Type'] = 'application/json; charset=utf-8';
    }
    return _extends({}, headers, options.headers);
  }

  function getData() {
    var data = options.data;
    return data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? JSON.stringify(data) : data;
  }

  return _extends({}, options, {
    headers: getHeaders(),
    data: getData()
  });
}

function createParametrizeUrl(url, params) {
  if (!params || !Object.keys(params).length) {
    return url;
  }

  if (url.indexOf('?') !== -1) {
    throw new TypeError('Adding param to urls with params is not supported');
  }
  var stringifiedParams = WMP.utils.createParam(params);
  return url + '?' + stringifiedParams;
}

function parseResponseBody(request) {
  if (request.getResponseHeader('Content-Type') === 'application/json') {
    try {
      return JSON.parse(request.responseText);
    } catch (ex) {
      throw new Error('Cannot parse response body');
    }
  }
  return request.responseText;
}

/***/ }),

/***/ 49:
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** ./scripts/common/migrator.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (widgetSettings, fallbackSettings) {
  var mergedSettings = utils.merge({}, widgetSettings);

  if (!fallbackSettings) {
    return mergedSettings;
  }

  mergedSettings.booleans = utils.merge(mergedSettings.booleans, fallbackSettings.booleans);
  mergedSettings.numbers = utils.merge(mergedSettings.numbers, fallbackSettings.numbers);
  mergedSettings.fonts = mergedSettings.fonts || {};

  utils.forEach(['siteOwnerId', 'paymentsId'], function (keyName) {
    var wmpKey = 'wmp::' + keyName;
    if (fallbackSettings.fonts[keyName]) {
      mergedSettings.fonts[wmpKey] = fallbackSettings.fonts[keyName];
    }
  });

  return mergedSettings;
};

var _utils = __webpack_require__(/*! ./../utils/utils */ 1);

var utils = _interopRequireDefault(_utils).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 5:
/* no static exports found */
/* all exports used */
/*!***********************************!*\
  !*** ./scripts/common/wix-sdk.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WixSdk = void 0;
if (typeof Wix !== 'undefined' && Wix.PubSub) {
  // Wix.PubSub to check that Wix is wix-sdk's Wix
  WixSdk = {
    Activities: {
      Type: Wix.Activities.Type,
      postActivity: Wix.Activities.postActivity
    },
    Counters: Wix.Counters,
    Styles: Wix.Styles,
    Theme: Wix.Theme,
    Utils: Wix.Utils,
    WindowOrigin: Wix.WindowOrigin,
    WindowPlacement: Wix.WindowPlacement
  };

  module.exports = WixSdk;
}

exports.default = WixSdk;

/***/ }),

/***/ 50:
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./scripts/player/init-by-collection-id-fn.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (init) {
  return function (domElement, widgetSettings, albumCollectionId, callback) {
    if (isPlainObject(domElement)) {
      var _ref = [null, domElement, widgetSettings, albumCollectionId];
      domElement = _ref[0];
      widgetSettings = _ref[1];
      albumCollectionId = _ref[2];
      callback = _ref[3];
    } else if (typeof domElement === 'string') {
      var foundElement = document.querySelector(domElement);
      if (!foundElement) {
        throw new Error('Cannot find element by selector ' + domElement);
      }
      domElement = foundElement;
    } else if (domElement[0] !== undefined) {
      domElement = domElement[0];
    }

    if (!domElement) {
      domElement = document.querySelector('wix-pl-app, .wix-pl-app');

      if (!domElement) {
        throw new Error('Cannot find element wix-pl-app');
      }
    }

    if (!window.getComputedStyle) {
      callback(new Error('Browser Not Supported'));
      return;
    }

    widgetSettings = utils.merge({}, widgetSettings);

    function initPlayer(settingsCollection, albumCollection) {
      Promise.resolve(init).then(function (resolvedInit) {
        resolvedInit(domElement, settingsCollection, albumCollection, callback);
      });
    }

    function getAlbumCollection(settings) {
      if (!albumCollectionId) {
        throw new Error('Please provide valid collection id');
      }

      var settingsCollectionId = settings.settingsCollectionId;


      var settingsPromise = void 0;
      if (!settingsCollectionId) {
        settingsPromise = Promise.resolve(settings);
      } else {
        settingsPromise = utils.getJSON(config.hosts.collections + 'collections/' + settingsCollectionId + '.json').catch(errorReporter.createPromiseErrorHandler(BI_ERRORS.widget.settingsCollection.get)).then(function (_ref2) {
          var collection = _ref2.collection;

          return utils.merge(settings, collection.public_properties);
        });
      }

      var albumPromise = utils.getJSON(config.hosts.collections + 'collections/' + albumCollectionId + '.json').catch(errorReporter.createPromiseErrorHandler(BI_ERRORS.widget.musicAlbum.get)).then(function (_ref3) {
        var collection = _ref3.collection;

        return collection;
      });

      Promise.all([settingsPromise, albumPromise]).then(function (collections) {
        initPlayer.apply(undefined, _toConsumableArray(collections));
      });
    }

    if (widgetSettings && widgetSettings.booleans && !widgetSettings.booleans['wmp::isMigrated'] && widgetSettings.instanceId && widgetSettings.compId) {
      utils.getJSON(config.hosts.legacyCollections + 'legacy-player/' + widgetSettings.instanceId + '-' + widgetSettings.compId + '.json').then(function (fallbackSettings) {
        var mergedSettings = migrator(widgetSettings, fallbackSettings);

        if (fallbackSettings && fallbackSettings.fonts && fallbackSettings.fonts.albumId) {
          albumCollectionId = fallbackSettings.fonts.albumId.value || albumCollectionId;
        }

        getAlbumCollection(mergedSettings);
      }).catch(function () {
        return getAlbumCollection(widgetSettings);
      });
    } else {
      getAlbumCollection(widgetSettings);
    }
  };
};

var _isPlainObject = __webpack_require__(/*! lodash/isPlainObject */ 95);

var isPlainObject = _interopRequireDefault(_isPlainObject).default;

var _config = __webpack_require__(/*! ../common/config */ 3);

var config = _interopRequireDefault(_config).default;

var _migrator = __webpack_require__(/*! ../common/migrator */ 49);

var migrator = _interopRequireDefault(_migrator).default;

var _utils = __webpack_require__(/*! ../utils/utils */ 1);

var utils = _interopRequireDefault(_utils).default;

var _errors = __webpack_require__(/*! ./v2/shared/errors */ 9);

var BI_ERRORS = _errors.BI_ERRORS;
var errorReporter = _errors.errorReporter;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/***/ }),

/***/ 51:
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./scripts/player/v2/shared/errors/errors.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BI_ERRORS = exports.BI_ERRORS = {
  widget: {
    musicAlbum: {
      get: {
        id: 1001,
        name: 'widget.musicAlbum.get',
        error: function error() {
          throw new Error(this.name);
        }
      }
    },
    settingsCollection: {
      get: {
        id: 1002,
        name: 'widget.settingsCollection.get',
        error: function error() {
          throw new Error(this.name);
        }
      }
    },
    content: {
      audio: {
        get: {
          id: 1003,
          name: 'widget.content.audio',
          error: function error() {
            throw new Error(this.name);
          }
        }
      },
      image: {
        get: {
          id: 1004,
          name: 'widget.content.image',
          error: function error() {
            throw new Error(this.name);
          }
        },
        noDimensions: {
          id: 1009,
          name: 'widget.content.image.noDimensions',
          error: function error() {
            throw new Error(this.name);
          }
        }
      },
      scripts: {
        wix: {
          id: 1007,
          name: 'widget.content.scripts.wix',
          error: function error() {
            throw new Error(this.name);
          }
        },
        player: {
          id: 1008,
          name: 'widget.content.scripts.player',
          error: function error() {
            throw new Error(this.name);
          }
        }
      }
    },
    statistic: {
      counters: {
        send: {
          id: 1005,
          name: 'widget.statistic.counters.send',
          error: function error() {
            throw new Error(this.name);
          }
        }
      },
      activity: {
        send: {
          id: 1006,
          name: 'widget.statistic.activity.send',
          error: function error() {
            throw new Error(this.name);
          }
        }
      }
    }
  }
};

/***/ }),

/***/ 59:
/* no static exports found */
/* all exports used */
/*!******************************!*\
  !*** external "deep-freeze" ***!
  \******************************/
/***/ (function(module, exports) {

module.exports = __webpack_require__(43);

/***/ }),

/***/ 60:
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** external "lodash/throttle" ***!
  \**********************************/
/***/ (function(module, exports) {

module.exports = __webpack_require__(57);

/***/ }),

/***/ 7:
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./scripts/utils/deprecated.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.enableDeprecationWarnings = enableDeprecationWarnings;
exports.deprecated = deprecated;

var _envConfig = __webpack_require__(/*! env-config */ 12);

var showDeprecationWarnings = _envConfig.showDeprecationWarnings;


var warningsEnabled = Boolean(showDeprecationWarnings);

function enableDeprecationWarnings() {
  warningsEnabled = true;
}

function deprecatedMethod(target, property, descriptor) {
  var originalMethod = descriptor.value;
  return _extends({}, descriptor, {
    value: function value() {
      if (warningsEnabled) {
        var propertyIn = target.constructor ? ' in \'' + target.constructor.name + '\'' : '';
        console.warn('Called deprecated method \'' + property + '\'' + propertyIn); // eslint-disable-line no-console
      }
      return originalMethod.apply(undefined, arguments);
    }
  });
}

function deprecatedProperty(target, property, descriptor) {
  var originalGet = descriptor.get;
  return _extends({}, descriptor, {
    get: function get() {
      if (warningsEnabled) {
        var propertyIn = target.constructor ? ' in \'' + target.constructor.name + '\'' : '';
        try {
          throw new Error();
        } catch (error) {
          console.warn('Called deprecated get property \'' + property + '\'' + propertyIn + ' ' + error.stack); // eslint-disable-line no-console
        }
      }
      return originalGet.call(this);
    }
  });
}

function deprecateFunction(original) {
  return function () {
    if (warningsEnabled) {
      var functionName = original.toString().match(/function\s*(.*)\(/)[1];
      try {
        throw new Error();
      } catch (error) {
        var message = functionName ? 'Called deprecated function \'' + functionName + '\'' : 'Called deprecated anonymous function';
        console.warn(message + ' ' + error.stack); // eslint-disable-line no-console
      }
    }
    return original.apply(this, arguments);
  };
}

function deprecated(target, property, descriptor) {
  if (!property && !descriptor) {
    return deprecateFunction(target);
  }
  return (descriptor.hasOwnProperty('value') ? deprecatedMethod : deprecatedProperty)(target, property, descriptor);
}

/***/ }),

/***/ 8:
/* no static exports found */
/* all exports used */
/*!*************************!*\
  !*** external "events" ***!
  \*************************/
/***/ (function(module, exports) {

module.exports = __webpack_require__(15);

/***/ }),

/***/ 9:
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./scripts/player/v2/shared/errors/index.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _errorReporter = __webpack_require__(/*! ./error-reporter */ 15);

Object.defineProperty(exports, 'errorReporter', {
  enumerable: true,
  get: function get() {
    return _errorReporter.errorReporter;
  }
});

var _errors = __webpack_require__(/*! ./errors */ 51);

Object.defineProperty(exports, 'BI_ERRORS', {
  enumerable: true,
  get: function get() {
    return _errors.BI_ERRORS;
  }
});

/***/ }),

/***/ 95:
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** external "lodash/isPlainObject" ***!
  \***************************************/
/***/ (function(module, exports) {

module.exports = __webpack_require__(55);

/***/ })

/******/ });
//# sourceMappingURL=index.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)))

/***/ }),
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(44);
var errors_1 = __webpack_require__(6);
var logging_1 = __webpack_require__(2);
var unhandled_1 = __webpack_require__(79);
var oops_1 = __webpack_require__(37);
var widget_player_1 = __webpack_require__(85);
(function () {
    if (typeof Wix === 'undefined') {
        logging_1.logError(errors_1.BI_ERRORS.widget.content.scripts.wix);
        oops_1.writeOops();
        return;
    }
    if (typeof core === 'undefined') {
        logging_1.logError(errors_1.BI_ERRORS.widget.content.scripts.coreJs);
        oops_1.writeOops();
        return;
    }
    unhandled_1.installUnhandled();
    widget_player_1.init();
})();


/***/ }),
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Clamp.js 0.7.0
 *
 * Copyright 2011-2013, Joseph Schmitt http://joe.sh
 * Released under the WTFPL license
 * http://sam.zoy.org/wtfpl/
 */

(function(root, factory) {
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory();
  } else {
    // Browser globals
    root.$clamp = factory();
  }
}(this, function() {
  /**
   * Clamps a text node.
   * @param {HTMLElement} element. Element containing the text node to clamp.
   * @param {Object} options. Options to pass to the clamper.
   */
  function clamp(element, options) {
    options = options || {};

    var self = this,
      win = window,
      opt = {
        clamp: options.clamp || 2,
        useNativeClamp: typeof(options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
        splitOnChars: options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
        animate: options.animate || false,
        truncationChar: options.truncationChar || '…',
        truncationHTML: options.truncationHTML
      },

      sty = element.style,
      originalText = element.innerHTML,

      supportsNativeClamp = typeof(element.style.webkitLineClamp) != 'undefined',
      clampValue = opt.clamp,
      isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
      truncationHTMLContainer;

    if (opt.truncationHTML) {
      truncationHTMLContainer = document.createElement('span');
      truncationHTMLContainer.innerHTML = opt.truncationHTML;
    }


    // UTILITY FUNCTIONS __________________________________________________________

    /**
     * Return the current style for an element.
     * @param {HTMLElement} elem The element to compute.
     * @param {string} prop The style property.
     * @returns {number}
     */
    function computeStyle(elem, prop) {
      if (!win.getComputedStyle) {
        win.getComputedStyle = function(el, pseudo) {
          this.el = el;
          this.getPropertyValue = function(prop) {
            var re = /(\-([a-z]){1})/g;
            if (prop == 'float') prop = 'styleFloat';
            if (re.test(prop)) {
              prop = prop.replace(re, function() {
                return arguments[2].toUpperCase();
              });
            }
            return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
          };
          return this;
        };
      }

      return win.getComputedStyle(elem, null).getPropertyValue(prop);
    }

    /**
     * Returns the maximum number of lines of text that should be rendered based
     * on the current height of the element and the line-height of the text.
     */
    function getMaxLines(height) {
      var availHeight = height || element.clientHeight,
        lineHeight = getLineHeight(element);

      return Math.max(Math.floor(availHeight / lineHeight), 0);
    }

    /**
     * Returns the maximum height a given element should have based on the line-
     * height of the text and the given clamp value.
     */
    function getMaxHeight(clmp) {
      var lineHeight = getLineHeight(element);
      return lineHeight * clmp;
    }

    /**
     * Returns the line-height of an element as an integer.
     */
    function getLineHeight(elem) {
      var lh = computeStyle(elem, 'line-height');
      if (lh == 'normal') {
        // Normal line heights vary from browser to browser. The spec recommends
        // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
        lh = parseInt(computeStyle(elem, 'font-size')) * 1.2;
      }
      return parseInt(lh);
    }


    // MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
    var splitOnChars = opt.splitOnChars.slice(0),
      splitChar = splitOnChars[0],
      chunks,
      lastChunk;

    /**
     * Gets an element's last child. That may be another node or a node's contents.
     */
    function getLastChild(elem) {
      //Current element has children, need to go deeper and get last child as a text node
      if (elem.lastChild.children && elem.lastChild.children.length > 0) {
        return getLastChild(Array.prototype.slice.call(elem.children).pop());
      }
      //This is the absolute last child, a text node, but something's wrong with it. Remove it and keep trying
      else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue === '' || elem.lastChild.nodeValue == opt.truncationChar) {
        elem.lastChild.parentNode.removeChild(elem.lastChild);
        return getLastChild(element);
      }
      //This is the last child we want, return it
      else {
        return elem.lastChild;
      }
    }

    /**
     * Removes one character at a time from the text until its width or
     * height is beneath the passed-in max param.
     */
    function truncate(target, maxHeight) {
      if (!maxHeight) {
        return;
      }

      /**
       * Resets global variables.
       */
      function reset() {
        splitOnChars = opt.splitOnChars.slice(0);
        splitChar = splitOnChars[0];
        chunks = null;
        lastChunk = null;
      }

      var nodeValue = target.nodeValue.replace(opt.truncationChar, '');

      //Grab the next chunks
      if (!chunks) {
        //If there are more characters to try, grab the next one
        if (splitOnChars.length > 0) {
          splitChar = splitOnChars.shift();
        }
        //No characters to chunk by. Go character-by-character
        else {
          splitChar = '';
        }

        chunks = nodeValue.split(splitChar);
      }

      //If there are chunks left to remove, remove the last one and see if
      // the nodeValue fits.
      if (chunks.length > 1) {
        // console.log('chunks', chunks);
        lastChunk = chunks.pop();
        // console.log('lastChunk', lastChunk);
        applyEllipsis(target, chunks.join(splitChar));
      }
      //No more chunks can be removed using this character
      else {
        chunks = null;
      }

      //Insert the custom HTML before the truncation character
      if (truncationHTMLContainer) {
        target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
        element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
      }

      //Search produced valid chunks
      if (chunks) {
        //It fits
        if (element.clientHeight <= maxHeight) {
          //There's still more characters to try splitting on, not quite done yet
          if (splitOnChars.length >= 0 && splitChar !== '') {
            applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
            chunks = null;
          }
          //Finished!
          else {
            return element.innerHTML;
          }
        }
      }
      //No valid chunks produced
      else {
        //No valid chunks even when splitting by letter, time to move
        //on to the next node
        if (splitChar === '') {
          applyEllipsis(target, '');
          target = getLastChild(element);

          reset();
        }
      }

      //If you get here it means still too big, let's keep truncating
      if (opt.animate) {
        setTimeout(function() {
          truncate(target, maxHeight);
        }, opt.animate === true ? 10 : opt.animate);
      } else {
        return truncate(target, maxHeight);
      }
    }

    function applyEllipsis(elem, str) {
      elem.nodeValue = str + opt.truncationChar;
    }


    // CONSTRUCTOR ________________________________________________________________

    if (clampValue == 'auto') {
      clampValue = getMaxLines();
    } else if (isCSSValue) {
      clampValue = getMaxLines(parseInt(clampValue));
    }

    var clampedText;
    if (supportsNativeClamp && opt.useNativeClamp) {
      sty.overflow = 'hidden';
      sty.textOverflow = 'ellipsis';
      sty.webkitBoxOrient = 'vertical';
      sty.display = '-webkit-box';
      sty.webkitLineClamp = clampValue;

      if (isCSSValue) {
        sty.height = opt.clamp + 'px';
      }
    } else {
      var height = getMaxHeight(clampValue);
      if (height <= element.clientHeight) {
        clampedText = truncate(getLastChild(element), height);
      }
    }

    return {
      'original': originalText,
      'clamped': clampedText
    };
  }

  return clamp;
}));


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = function deepFreeze (o) {
  Object.freeze(o);

  Object.getOwnPropertyNames(o).forEach(function (prop) {
    if (o.hasOwnProperty(prop)
    && o[prop] !== null
    && (typeof o[prop] === "object" || typeof o[prop] === "function")
    && !Object.isFrozen(o[prop])) {
      deepFreeze(o[prop]);
    }
  });
  
  return o;
};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */,
/* 46 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(23),
    arrayMap = __webpack_require__(46),
    isArray = __webpack_require__(54),
    isSymbol = __webpack_require__(35);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(52);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(23);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(24),
    now = __webpack_require__(56),
    toNumber = __webpack_require__(58);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(32),
    getPrototype = __webpack_require__(49),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(33);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(53),
    isObject = __webpack_require__(24);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(24),
    isSymbol = __webpack_require__(35);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(47);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(59);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isExperimentEnabled = exports.getExperimentsJsonP = exports.getExperiments = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _sendRequest = __webpack_require__(20);

var _promise = __webpack_require__(19);

var WMP = window.WMP = window.WMP || {};
WMP.callbacks = {
  counter: 0
};
var retrievedExperiments = {};

var getExperiments = exports.getExperiments = memoizeExperiment(function (scope, timeout) {
  return Promise.all([(0, _sendRequest.sendRequest)({
    url: '//www.wix.com/_api/wix-laboratory-server/laboratory/conductAllInScope?scope=' + scope,
    withCredentials: true,
    timeout: timeout
  }), getExperimentQueryOverride()]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        data = _ref2[0].data,
        overrides = _ref2[1];

    return _extends({}, normalize(data), overrides);
  });
});

var getExperimentsJsonP = exports.getExperimentsJsonP = memoizeExperiment(function (scope, timeout) {
  if (!scope) {
    throw new Error('Experiment scope is not provided');
  }
  var url = '//www.wix.com/_api/wix-laboratory-server/laboratory/conductAllInScope?scope=' + scope + '&accept=jsonp';
  return Promise.all([getJsonp(url, timeout), getExperimentQueryOverride()]).then(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        experiments = _ref4[0],
        overrides = _ref4[1];

    return _extends({}, normalize(experiments), overrides);
  });
});

var isExperimentEnabled = exports.isExperimentEnabled = function isExperimentEnabled(scope, name, timeout) {
  if (!name) {
    throw new Error('Experiment name is not specified');
  }
  return getExperiments(scope, timeout).then(function (experiments) {
    return experiments[name] === true;
  });
};

function memoizeExperiment(fn) {
  return function (key) {
    if (!retrievedExperiments[key]) {
      retrievedExperiments[key] = fn.apply(undefined, arguments);
    }
    return retrievedExperiments[key];
  };
}

function getExperimentQueryOverride() {
  return Promise.resolve().then(function () {
    return Promise.all([WMP.wixUtils.getQuery(document.referrer).experiments, WMP.wixUtils.getQuery().experiments, getRefererFromWixSdk(500).catch(function (reason) {
      console.warn('Cannot get experiment override from SDK', reason); //eslint-disable-line no-console
      return '';
    })]);
  }).then(function (experimentOverrides) {
    return experimentOverrides.map(function (override) {
      return override && override.split(',');
    }).filter(Boolean).reduce(function (overrides, arr) {
      return overrides.concat(arr);
    }, []).filter(Boolean).reduce(function (acc, experiment) {
      var _experiment$split = experiment.split(':'),
          _experiment$split2 = _slicedToArray(_experiment$split, 2),
          name = _experiment$split2[0],
          value = _experiment$split2[1];

      acc[name] = value === undefined ? true : value;
      return acc;
    }, {});
  }).catch(function (reason) {
    console.error(reason); //eslint-disable-line no-console
    return {};
  });
}

function getRefererFromWixSdk(timeout) {
  var promise = new Promise(function (resolve) {
    if (!window.Wix || !window.Wix.getSiteInfo || window.Wix.Utils.getViewMode() !== 'editor') {
      resolve('');
    }
    window.Wix.getSiteInfo(function (siteInfo) {
      resolve(WMP.wixUtils.getQuery(siteInfo.referer).experiments);
    });
  });

  return (0, _promise.addTimeout)(promise, { time: timeout, reason: 'WIx Sdk Timeout (getSiteInfo)' });
}

function getJsonp(path, timeout) {
  return new Promise(function (resolve, reject) {
    var timerId = void 0;
    var callBackName = '_' + WMP.callbacks.counter++;
    var url = path + '&callback=WMP.callbacks.' + callBackName;
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    if (timeout) {
      timerId = setTimeout(function () {
        reject(new Error('Experiments load timeout'));
        cleanup({});
      }, timeout);
    }

    function cleanup() {
      document.body.removeChild(script);
      WMP.callbacks[callBackName] = function () {};
      if (timeout) {
        clearTimeout(timerId);
      }
    }

    WMP.callbacks[callBackName] = function () {
      var result = arguments.length > 1 ? arguments[arguments.length - 1] : undefined;
      resolve(result);
      cleanup();
    };
    script.onerror = function () {
      reject(new Error('Error during experiments retrieve'));
      cleanup();
    };

    script.src = url;
    document.body.appendChild(script);
  });
}

function normalize(rawExperiments) {
  return Object.keys(rawExperiments).reduce(function (experiments, experimentName) {
    var experimentValue = rawExperiments[experimentName];
    try {
      experimentValue = JSON.parse(experimentValue);
    } catch (ex) {
      // value is not serialized, use as is
    }
    var experimentValueMapper = {
      new: true,
      old: false
    };
    experimentValue = experimentValueMapper[experimentValue] || experimentValue;
    var normalizedName = experimentName.replace('specs.', '');
    experiments[normalizedName] = experimentValue;
    experiments[experimentName] = experimentValue;
    return experiments;
  }, {});
}
//# sourceMappingURL=experiment-manager.js.map


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteStorage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _wixSdk = __webpack_require__(14);

var _wixSdk2 = _interopRequireDefault(_wixSdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function delay(time) {
  return new Promise(function (resolve) {
    setTimeout(resolve, time);
  });
}

function getStyleParams() {
  return new Promise(function (resolve) {
    _wixSdk2.default.Styles.getStyleParams(resolve);
  });
}

function _getDataPublic(key) {
  var dataPublic = new Promise(function (resolve) {
    return _wixSdk2.default.Data.Public.get(key, { scope: _wixSdk2.default.Data.SCOPE.COMPONENT }, function (data) {
      resolve(data && data[key]);
    }, function () {
      resolve(undefined);
    });
  });
  return Promise.race([dataPublic, delay(1500)]);
}

var SiteStorage = exports.SiteStorage = function () {
  function SiteStorage(prefix, separator) {
    _classCallCheck(this, SiteStorage);

    this.prefix = prefix;
    this.separator = separator === undefined ? '::' : separator;
    this.cache = {};
    this.cacheBool = {};
    this.cacheNumbers = {};
  }

  _createClass(SiteStorage, [{
    key: '_joinWithSeparator',
    value: function _joinWithSeparator() {
      return Array.prototype.join.call(arguments, this.separator);
    }
  }, {
    key: '_getPrefixedKey',
    value: function _getPrefixedKey(key) {
      return this._joinWithSeparator(this.prefix, key);
    }
  }, {
    key: 'getBool',
    value: function getBool(key) {
      var prefix = this._getPrefixedKey(key);
      if (prefix in this.cacheBool) {
        // setEditorParam does not change params after they were retrieved
        return Promise.resolve(this.cacheBool[prefix]);
      }
      return getStyleParams().then(function (params) {
        return params.booleans[prefix];
      });
    }
  }, {
    key: 'setBool',
    value: function setBool(key, value) {
      var prefix = this._getPrefixedKey(key);
      this.cacheBool[prefix] = value;

      return getStyleParams().then(function () {
        return new Promise(function (resolve) {
          _wixSdk2.default.Styles.setBooleanParam(prefix, { value: value }, resolve);
        });
      });
    }
  }, {
    key: 'getNumber',
    value: function getNumber(key) {
      var prefix = this._getPrefixedKey(key);

      if (prefix in this.cacheNumbers) {
        // setEditorParam does not change params after they were retrieved
        return Promise.resolve(this.cacheNumbers[prefix]);
      }

      return getStyleParams().then(function (params) {
        return params.numbers[prefix];
      });
    }
  }, {
    key: 'setNumber',
    value: function setNumber(key, value) {
      var prefix = this._getPrefixedKey(key);
      this.cacheNumbers[prefix] = value;
      return getStyleParams().then(function () {
        return new Promise(function (resolve) {
          _wixSdk2.default.Styles.setNumberParam(prefix, { value: value }, resolve);
        });
      });
    }

    /* *
     * @name WMP.SiteStorage#get
     * @description Get value by key from wix site
     *
     * @param {string} key Name of the property
     * @returns {Promise} Value of the property (string|null)
     * @param {Object} [options] Options of settings.
     * @param {Boolean} [options.skipData=false] Whether to skip getting from Wix.Data.
     */

  }, {
    key: 'get',
    value: function get(key, options) {
      if (!options) {
        options = {};
      }
      var prefixedKey = this._getPrefixedKey(key);
      if (prefixedKey in this.cache) {
        // setEditorParam does not change params after they were retrieved
        return Promise.resolve(this.cache[prefixedKey]);
      }

      return Promise.all([getStyleParams(), options.skipData ? Promise.resolve() : this.getDataPublic(key)]).then(function (args) {
        var styleParams = args[0];
        var dataParam = args[1];
        return dataParam || styleParams.fonts[prefixedKey] && styleParams.fonts[prefixedKey].value;
      });
    }

    /* *
     * @name WMP.SiteStorage#remove
     * @description Removes value by key from wix site
     *
     * @param {string} key Name of the property
     * @returns {Promise}
     */

  }, {
    key: 'remove',
    value: function remove(key) {
      var prefixedKey = this._getPrefixedKey(key);
      var cache = this.cache;

      return getStyleParams().then(function () {
        var resetFontParams = new Promise(function (resolve, reject) {
          _wixSdk2.default.Styles.setFontParam(prefixedKey, {
            value: { value: undefined }
          }, resolve, reject);
        });
        var removeDataParam = new Promise(function (resolve) {
          _wixSdk2.default.Data.Public.remove(prefixedKey, { scope: _wixSdk2.default.Data.SCOPE.COMPONENT }, function () {
            delete cache[prefixedKey];
            resolve();
          });
        });
        var removeDataParamTimeout = Promise.race([removeDataParam, delay(3500)]);
        return Promise.all([resetFontParams, removeDataParamTimeout]);
      });
    }

    /* *
     * @ngdoc method
     * @name wix.siteStorage#set
     * @description Set property by key
     *
     * @param {string} key Name of the property
     * @param {string} value Value of the property.
     * @param {Object} [options] Options of settings.
     * @param {Boolean} [options.skipData = false] Whether to skip saving to Wix.Data.
     */

  }, {
    key: 'set',
    value: function set(key, value, options) {
      var _this = this;

      if (value === undefined) {
        return Promise.resolve();
      }
      if (!options) {
        options = {};
      }

      var prefixedKey = this._getPrefixedKey(key);
      this.cache[prefixedKey] = value;

      return getStyleParams().then(function () {
        var setFontParams = new Promise(function (resolve, reject) {
          _wixSdk2.default.Styles.setFontParam(prefixedKey, { value: { value: value } }, resolve, reject);
        });
        var setDataPublic = options.skipData ? Promise.resolve() : _this.setDataPublic(key, value);
        return Promise.all([setFontParams, Promise.race([setDataPublic, delay(1500)])]);
      });
    }
  }, {
    key: 'setDataPublic',
    value: function setDataPublic(key, value) {
      var prefixedKey = this._getPrefixedKey(key);
      return new Promise(function (resolve, reject) {
        _wixSdk2.default.Data.Public.set(prefixedKey, value, { scope: _wixSdk2.default.Data.SCOPE.COMPONENT }, function (data) {
          _wixSdk2.default.Settings.triggerSettingsUpdatedEvent('data:update', data);
          resolve(data);
        }, reject);
      });
    }
  }, {
    key: 'getDataPublic',
    value: function getDataPublic(key) {
      var prefixedKey = this._getPrefixedKey(key);
      return _getDataPublic(prefixedKey);
    }
  }]);

  return SiteStorage;
}();
//# sourceMappingURL=site-storage.js.map


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(66);


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var EventElement = function (element) {
  this.element = element;
  this.events = {};
};

EventElement.prototype.bind = function (eventName, handler) {
  if (typeof this.events[eventName] === 'undefined') {
    this.events[eventName] = [];
  }
  this.events[eventName].push(handler);
  this.element.addEventListener(eventName, handler, false);
};

EventElement.prototype.unbind = function (eventName, handler) {
  var isHandlerProvided = (typeof handler !== 'undefined');
  this.events[eventName] = this.events[eventName].filter(function (hdlr) {
    if (isHandlerProvided && hdlr !== handler) {
      return true;
    }
    this.element.removeEventListener(eventName, hdlr, false);
    return false;
  }, this);
};

EventElement.prototype.unbindAll = function () {
  for (var name in this.events) {
    this.unbind(name);
  }
};

var EventManager = function () {
  this.eventElements = [];
};

EventManager.prototype.eventElement = function (element) {
  var ee = this.eventElements.filter(function (eventElement) {
    return eventElement.element === element;
  })[0];
  if (typeof ee === 'undefined') {
    ee = new EventElement(element);
    this.eventElements.push(ee);
  }
  return ee;
};

EventManager.prototype.bind = function (element, eventName, handler) {
  this.eventElement(element).bind(eventName, handler);
};

EventManager.prototype.unbind = function (element, eventName, handler) {
  this.eventElement(element).unbind(eventName, handler);
};

EventManager.prototype.unbindAll = function () {
  for (var i = 0; i < this.eventElements.length; i++) {
    this.eventElements[i].unbindAll();
  }
};

EventManager.prototype.once = function (element, eventName, handler) {
  var ee = this.eventElement(element);
  var onceHandler = function (e) {
    ee.unbind(eventName, onceHandler);
    handler(e);
  };
  ee.bind(eventName, onceHandler);
};

module.exports = EventManager;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = (function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  }
  return function () {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
  };
})();


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var destroy = __webpack_require__(68);
var initialize = __webpack_require__(76);
var update = __webpack_require__(77);

module.exports = {
  initialize: initialize,
  update: update,
  destroy: destroy
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  handlers: ['click-rail', 'drag-scrollbar', 'keyboard', 'wheel', 'touch'],
  maxScrollbarLength: null,
  minScrollbarLength: null,
  scrollXMarginOffset: 0,
  scrollYMarginOffset: 0,
  suppressScrollX: false,
  suppressScrollY: false,
  swipePropagation: true,
  useBothWheelAxes: false,
  wheelPropagation: false,
  wheelSpeed: 1,
  theme: 'default'
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(4);
var dom = __webpack_require__(9);
var instances = __webpack_require__(1);

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  i.event.unbindAll();
  dom.remove(i.scrollbarX);
  dom.remove(i.scrollbarY);
  dom.remove(i.scrollbarXRail);
  dom.remove(i.scrollbarYRail);
  _.removePsClasses(element);

  instances.remove(element);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(5);
var updateScroll = __webpack_require__(7);

function bindClickRailHandler(element, i) {
  function pageOffset(el) {
    return el.getBoundingClientRect();
  }
  var stopPropagation = function (e) { e.stopPropagation(); };

  i.event.bind(i.scrollbarY, 'click', stopPropagation);
  i.event.bind(i.scrollbarYRail, 'click', function (e) {
    var positionTop = e.pageY - window.pageYOffset - pageOffset(i.scrollbarYRail).top;
    var direction = positionTop > i.scrollbarYTop ? 1 : -1;

    updateScroll(element, 'top', element.scrollTop + direction * i.containerHeight);
    updateGeometry(element);

    e.stopPropagation();
  });

  i.event.bind(i.scrollbarX, 'click', stopPropagation);
  i.event.bind(i.scrollbarXRail, 'click', function (e) {
    var positionLeft = e.pageX - window.pageXOffset - pageOffset(i.scrollbarXRail).left;
    var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;

    updateScroll(element, 'left', element.scrollLeft + direction * i.containerWidth);
    updateGeometry(element);

    e.stopPropagation();
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindClickRailHandler(element, i);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(4);
var dom = __webpack_require__(9);
var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(5);
var updateScroll = __webpack_require__(7);

function bindMouseScrollXHandler(element, i) {
  var currentLeft = null;
  var currentPageX = null;

  function updateScrollLeft(deltaX) {
    var newLeft = currentLeft + (deltaX * i.railXRatio);
    var maxLeft = Math.max(0, i.scrollbarXRail.getBoundingClientRect().left) + (i.railXRatio * (i.railXWidth - i.scrollbarXWidth));

    if (newLeft < 0) {
      i.scrollbarXLeft = 0;
    } else if (newLeft > maxLeft) {
      i.scrollbarXLeft = maxLeft;
    } else {
      i.scrollbarXLeft = newLeft;
    }

    var scrollLeft = _.toInt(i.scrollbarXLeft * (i.contentWidth - i.containerWidth) / (i.containerWidth - (i.railXRatio * i.scrollbarXWidth))) - i.negativeScrollAdjustment;
    updateScroll(element, 'left', scrollLeft);
  }

  var mouseMoveHandler = function (e) {
    updateScrollLeft(e.pageX - currentPageX);
    updateGeometry(element);
    e.stopPropagation();
    e.preventDefault();
  };

  var mouseUpHandler = function () {
    _.stopScrolling(element, 'x');
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  };

  i.event.bind(i.scrollbarX, 'mousedown', function (e) {
    currentPageX = e.pageX;
    currentLeft = _.toInt(dom.css(i.scrollbarX, 'left')) * i.railXRatio;
    _.startScrolling(element, 'x');

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

function bindMouseScrollYHandler(element, i) {
  var currentTop = null;
  var currentPageY = null;

  function updateScrollTop(deltaY) {
    var newTop = currentTop + (deltaY * i.railYRatio);
    var maxTop = Math.max(0, i.scrollbarYRail.getBoundingClientRect().top) + (i.railYRatio * (i.railYHeight - i.scrollbarYHeight));

    if (newTop < 0) {
      i.scrollbarYTop = 0;
    } else if (newTop > maxTop) {
      i.scrollbarYTop = maxTop;
    } else {
      i.scrollbarYTop = newTop;
    }

    var scrollTop = _.toInt(i.scrollbarYTop * (i.contentHeight - i.containerHeight) / (i.containerHeight - (i.railYRatio * i.scrollbarYHeight)));
    updateScroll(element, 'top', scrollTop);
  }

  var mouseMoveHandler = function (e) {
    updateScrollTop(e.pageY - currentPageY);
    updateGeometry(element);
    e.stopPropagation();
    e.preventDefault();
  };

  var mouseUpHandler = function () {
    _.stopScrolling(element, 'y');
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  };

  i.event.bind(i.scrollbarY, 'mousedown', function (e) {
    currentPageY = e.pageY;
    currentTop = _.toInt(dom.css(i.scrollbarY, 'top')) * i.railYRatio;
    _.startScrolling(element, 'y');

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindMouseScrollXHandler(element, i);
  bindMouseScrollYHandler(element, i);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(4);
var dom = __webpack_require__(9);
var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(5);
var updateScroll = __webpack_require__(7);

function bindKeyboardHandler(element, i) {
  var hovered = false;
  i.event.bind(element, 'mouseenter', function () {
    hovered = true;
  });
  i.event.bind(element, 'mouseleave', function () {
    hovered = false;
  });

  var shouldPrevent = false;
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  i.event.bind(i.ownerDocument, 'keydown', function (e) {
    if ((e.isDefaultPrevented && e.isDefaultPrevented()) || e.defaultPrevented) {
      return;
    }

    var focused = dom.matches(i.scrollbarX, ':focus') ||
                  dom.matches(i.scrollbarY, ':focus');

    if (!hovered && !focused) {
      return;
    }

    var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
    if (activeElement) {
      if (activeElement.tagName === 'IFRAME') {
        activeElement = activeElement.contentDocument.activeElement;
      } else {
        // go deeper if element is a webcomponent
        while (activeElement.shadowRoot) {
          activeElement = activeElement.shadowRoot.activeElement;
        }
      }
      if (_.isEditable(activeElement)) {
        return;
      }
    }

    var deltaX = 0;
    var deltaY = 0;

    switch (e.which) {
    case 37: // left
      if (e.metaKey) {
        deltaX = -i.contentWidth;
      } else if (e.altKey) {
        deltaX = -i.containerWidth;
      } else {
        deltaX = -30;
      }
      break;
    case 38: // up
      if (e.metaKey) {
        deltaY = i.contentHeight;
      } else if (e.altKey) {
        deltaY = i.containerHeight;
      } else {
        deltaY = 30;
      }
      break;
    case 39: // right
      if (e.metaKey) {
        deltaX = i.contentWidth;
      } else if (e.altKey) {
        deltaX = i.containerWidth;
      } else {
        deltaX = 30;
      }
      break;
    case 40: // down
      if (e.metaKey) {
        deltaY = -i.contentHeight;
      } else if (e.altKey) {
        deltaY = -i.containerHeight;
      } else {
        deltaY = -30;
      }
      break;
    case 33: // page up
      deltaY = 90;
      break;
    case 32: // space bar
      if (e.shiftKey) {
        deltaY = 90;
      } else {
        deltaY = -90;
      }
      break;
    case 34: // page down
      deltaY = -90;
      break;
    case 35: // end
      if (e.ctrlKey) {
        deltaY = -i.contentHeight;
      } else {
        deltaY = -i.containerHeight;
      }
      break;
    case 36: // home
      if (e.ctrlKey) {
        deltaY = element.scrollTop;
      } else {
        deltaY = i.containerHeight;
      }
      break;
    default:
      return;
    }

    updateScroll(element, 'top', element.scrollTop - deltaY);
    updateScroll(element, 'left', element.scrollLeft + deltaX);
    updateGeometry(element);

    shouldPrevent = shouldPreventDefault(deltaX, deltaY);
    if (shouldPrevent) {
      e.preventDefault();
    }
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindKeyboardHandler(element, i);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(5);
var updateScroll = __webpack_require__(7);

function bindMouseWheelHandler(element, i) {
  var shouldPrevent = false;

  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = -1 * e.deltaY;

    if (typeof deltaX === "undefined" || typeof deltaY === "undefined") {
      // OS X Safari
      deltaX = -1 * e.wheelDeltaX / 6;
      deltaY = e.wheelDeltaY / 6;
    }

    if (e.deltaMode && e.deltaMode === 1) {
      // Firefox in deltaMode 1: Line scrolling
      deltaX *= 10;
      deltaY *= 10;
    }

    if (deltaX !== deltaX && deltaY !== deltaY/* NaN checks */) {
      // IE in some mouse drivers
      deltaX = 0;
      deltaY = e.wheelDelta;
    }

    if (e.shiftKey) {
      // reverse axis with shift key
      return [-deltaY, -deltaX];
    }
    return [deltaX, deltaY];
  }

  function shouldBeConsumedByChild(deltaX, deltaY) {
    var child = element.querySelector('textarea:hover, select[multiple]:hover, .ps-child:hover');
    if (child) {
      if (!window.getComputedStyle(child).overflow.match(/(scroll|auto)/)) {
        // if not scrollable
        return false;
      }

      var maxScrollTop = child.scrollHeight - child.clientHeight;
      if (maxScrollTop > 0) {
        if (!(child.scrollTop === 0 && deltaY > 0) && !(child.scrollTop === maxScrollTop && deltaY < 0)) {
          return true;
        }
      }
      var maxScrollLeft = child.scrollLeft - child.clientWidth;
      if (maxScrollLeft > 0) {
        if (!(child.scrollLeft === 0 && deltaX < 0) && !(child.scrollLeft === maxScrollLeft && deltaX > 0)) {
          return true;
        }
      }
    }
    return false;
  }

  function mousewheelHandler(e) {
    var delta = getDeltaFromEvent(e);

    var deltaX = delta[0];
    var deltaY = delta[1];

    if (shouldBeConsumedByChild(deltaX, deltaY)) {
      return;
    }

    shouldPrevent = false;
    if (!i.settings.useBothWheelAxes) {
      // deltaX will only be used for horizontal scrolling and deltaY will
      // only be used for vertical scrolling - this is the default
      updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
      updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
      // only vertical scrollbar is active and useBothWheelAxes option is
      // active, so let's scroll vertical bar using both mouse wheel axes
      if (deltaY) {
        updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
      } else {
        updateScroll(element, 'top', element.scrollTop + (deltaX * i.settings.wheelSpeed));
      }
      shouldPrevent = true;
    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
      // useBothWheelAxes and only horizontal bar is active, so use both
      // wheel axes for horizontal bar
      if (deltaX) {
        updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
      } else {
        updateScroll(element, 'left', element.scrollLeft - (deltaY * i.settings.wheelSpeed));
      }
      shouldPrevent = true;
    }

    updateGeometry(element);

    shouldPrevent = (shouldPrevent || shouldPreventDefault(deltaX, deltaY));
    if (shouldPrevent) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  if (typeof window.onwheel !== "undefined") {
    i.event.bind(element, 'wheel', mousewheelHandler);
  } else if (typeof window.onmousewheel !== "undefined") {
    i.event.bind(element, 'mousewheel', mousewheelHandler);
  }
}

module.exports = function (element) {
  var i = instances.get(element);
  bindMouseWheelHandler(element, i);
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(5);

function bindNativeScrollHandler(element, i) {
  i.event.bind(element, 'scroll', function () {
    updateGeometry(element);
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindNativeScrollHandler(element, i);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(4);
var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(5);
var updateScroll = __webpack_require__(7);

function bindSelectionHandler(element, i) {
  function getRangeNode() {
    var selection = window.getSelection ? window.getSelection() :
                    document.getSelection ? document.getSelection() : '';
    if (selection.toString().length === 0) {
      return null;
    } else {
      return selection.getRangeAt(0).commonAncestorContainer;
    }
  }

  var scrollingLoop = null;
  var scrollDiff = {top: 0, left: 0};
  function startScrolling() {
    if (!scrollingLoop) {
      scrollingLoop = setInterval(function () {
        if (!instances.get(element)) {
          clearInterval(scrollingLoop);
          return;
        }

        updateScroll(element, 'top', element.scrollTop + scrollDiff.top);
        updateScroll(element, 'left', element.scrollLeft + scrollDiff.left);
        updateGeometry(element);
      }, 50); // every .1 sec
    }
  }
  function stopScrolling() {
    if (scrollingLoop) {
      clearInterval(scrollingLoop);
      scrollingLoop = null;
    }
    _.stopScrolling(element);
  }

  var isSelected = false;
  i.event.bind(i.ownerDocument, 'selectionchange', function () {
    if (element.contains(getRangeNode())) {
      isSelected = true;
    } else {
      isSelected = false;
      stopScrolling();
    }
  });
  i.event.bind(window, 'mouseup', function () {
    if (isSelected) {
      isSelected = false;
      stopScrolling();
    }
  });
  i.event.bind(window, 'keyup', function () {
    if (isSelected) {
      isSelected = false;
      stopScrolling();
    }
  });

  i.event.bind(window, 'mousemove', function (e) {
    if (isSelected) {
      var mousePosition = {x: e.pageX, y: e.pageY};
      var containerGeometry = {
        left: element.offsetLeft,
        right: element.offsetLeft + element.offsetWidth,
        top: element.offsetTop,
        bottom: element.offsetTop + element.offsetHeight
      };

      if (mousePosition.x < containerGeometry.left + 3) {
        scrollDiff.left = -5;
        _.startScrolling(element, 'x');
      } else if (mousePosition.x > containerGeometry.right - 3) {
        scrollDiff.left = 5;
        _.startScrolling(element, 'x');
      } else {
        scrollDiff.left = 0;
      }

      if (mousePosition.y < containerGeometry.top + 3) {
        if (containerGeometry.top + 3 - mousePosition.y < 5) {
          scrollDiff.top = -5;
        } else {
          scrollDiff.top = -20;
        }
        _.startScrolling(element, 'y');
      } else if (mousePosition.y > containerGeometry.bottom - 3) {
        if (mousePosition.y - containerGeometry.bottom + 3 < 5) {
          scrollDiff.top = 5;
        } else {
          scrollDiff.top = 20;
        }
        _.startScrolling(element, 'y');
      } else {
        scrollDiff.top = 0;
      }

      if (scrollDiff.top === 0 && scrollDiff.left === 0) {
        stopScrolling();
      } else {
        startScrolling();
      }
    }
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindSelectionHandler(element, i);
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(4);
var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(5);
var updateScroll = __webpack_require__(7);

function bindTouchHandler(element, i, supportsTouch, supportsIePointer) {
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    var scrollLeft = element.scrollLeft;
    var magnitudeX = Math.abs(deltaX);
    var magnitudeY = Math.abs(deltaY);

    if (magnitudeY > magnitudeX) {
      // user is perhaps trying to swipe up/down the page

      if (((deltaY < 0) && (scrollTop === i.contentHeight - i.containerHeight)) ||
          ((deltaY > 0) && (scrollTop === 0))) {
        return !i.settings.swipePropagation;
      }
    } else if (magnitudeX > magnitudeY) {
      // user is perhaps trying to swipe left/right across the page

      if (((deltaX < 0) && (scrollLeft === i.contentWidth - i.containerWidth)) ||
          ((deltaX > 0) && (scrollLeft === 0))) {
        return !i.settings.swipePropagation;
      }
    }

    return true;
  }

  function applyTouchMove(differenceX, differenceY) {
    updateScroll(element, 'top', element.scrollTop - differenceY);
    updateScroll(element, 'left', element.scrollLeft - differenceX);

    updateGeometry(element);
  }

  var startOffset = {};
  var startTime = 0;
  var speed = {};
  var easingLoop = null;
  var inGlobalTouch = false;
  var inLocalTouch = false;

  function globalTouchStart() {
    inGlobalTouch = true;
  }
  function globalTouchEnd() {
    inGlobalTouch = false;
  }

  function getTouch(e) {
    if (e.targetTouches) {
      return e.targetTouches[0];
    } else {
      // Maybe IE pointer
      return e;
    }
  }
  function shouldHandle(e) {
    if (e.targetTouches && e.targetTouches.length === 1) {
      return true;
    }
    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
      return true;
    }
    return false;
  }
  function touchStart(e) {
    if (shouldHandle(e)) {
      inLocalTouch = true;

      var touch = getTouch(e);

      startOffset.pageX = touch.pageX;
      startOffset.pageY = touch.pageY;

      startTime = (new Date()).getTime();

      if (easingLoop !== null) {
        clearInterval(easingLoop);
      }

      e.stopPropagation();
    }
  }
  function touchMove(e) {
    if (!inLocalTouch && i.settings.swipePropagation) {
      touchStart(e);
    }
    if (!inGlobalTouch && inLocalTouch && shouldHandle(e)) {
      var touch = getTouch(e);

      var currentOffset = {pageX: touch.pageX, pageY: touch.pageY};

      var differenceX = currentOffset.pageX - startOffset.pageX;
      var differenceY = currentOffset.pageY - startOffset.pageY;

      applyTouchMove(differenceX, differenceY);
      startOffset = currentOffset;

      var currentTime = (new Date()).getTime();

      var timeGap = currentTime - startTime;
      if (timeGap > 0) {
        speed.x = differenceX / timeGap;
        speed.y = differenceY / timeGap;
        startTime = currentTime;
      }

      if (shouldPreventDefault(differenceX, differenceY)) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  }
  function touchEnd() {
    if (!inGlobalTouch && inLocalTouch) {
      inLocalTouch = false;

      clearInterval(easingLoop);
      easingLoop = setInterval(function () {
        if (!instances.get(element)) {
          clearInterval(easingLoop);
          return;
        }

        if (!speed.x && !speed.y) {
          clearInterval(easingLoop);
          return;
        }

        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
          clearInterval(easingLoop);
          return;
        }

        applyTouchMove(speed.x * 30, speed.y * 30);

        speed.x *= 0.8;
        speed.y *= 0.8;
      }, 10);
    }
  }

  if (supportsTouch) {
    i.event.bind(window, 'touchstart', globalTouchStart);
    i.event.bind(window, 'touchend', globalTouchEnd);
    i.event.bind(element, 'touchstart', touchStart);
    i.event.bind(element, 'touchmove', touchMove);
    i.event.bind(element, 'touchend', touchEnd);
  } else if (supportsIePointer) {
    if (window.PointerEvent) {
      i.event.bind(window, 'pointerdown', globalTouchStart);
      i.event.bind(window, 'pointerup', globalTouchEnd);
      i.event.bind(element, 'pointerdown', touchStart);
      i.event.bind(element, 'pointermove', touchMove);
      i.event.bind(element, 'pointerup', touchEnd);
    } else if (window.MSPointerEvent) {
      i.event.bind(window, 'MSPointerDown', globalTouchStart);
      i.event.bind(window, 'MSPointerUp', globalTouchEnd);
      i.event.bind(element, 'MSPointerDown', touchStart);
      i.event.bind(element, 'MSPointerMove', touchMove);
      i.event.bind(element, 'MSPointerUp', touchEnd);
    }
  }
}

module.exports = function (element) {
  if (!_.env.supportsTouch && !_.env.supportsIePointer) {
    return;
  }

  var i = instances.get(element);
  bindTouchHandler(element, i, _.env.supportsTouch, _.env.supportsIePointer);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(4);
var cls = __webpack_require__(21);
var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(5);

// Handlers
var handlers = {
  'click-rail': __webpack_require__(69),
  'drag-scrollbar': __webpack_require__(70),
  'keyboard': __webpack_require__(71),
  'wheel': __webpack_require__(72),
  'touch': __webpack_require__(75),
  'selection': __webpack_require__(74)
};
var nativeScrollHandler = __webpack_require__(73);

module.exports = function (element, userSettings) {
  userSettings = typeof userSettings === 'object' ? userSettings : {};

  cls.add(element, 'ps-container');

  // Create a plugin instance.
  var i = instances.add(element);

  i.settings = _.extend(i.settings, userSettings);
  cls.add(element, 'ps-theme-' + i.settings.theme);

  i.settings.handlers.forEach(function (handlerName) {
    handlers[handlerName](element);
  });

  nativeScrollHandler(element);

  updateGeometry(element);
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(4);
var dom = __webpack_require__(9);
var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(5);
var updateScroll = __webpack_require__(7);

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  // Recalcuate negative scrollLeft adjustment
  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;

  // Recalculate rail margins
  dom.css(i.scrollbarXRail, 'display', 'block');
  dom.css(i.scrollbarYRail, 'display', 'block');
  i.railXMarginWidth = _.toInt(dom.css(i.scrollbarXRail, 'marginLeft')) + _.toInt(dom.css(i.scrollbarXRail, 'marginRight'));
  i.railYMarginHeight = _.toInt(dom.css(i.scrollbarYRail, 'marginTop')) + _.toInt(dom.css(i.scrollbarYRail, 'marginBottom'));

  // Hide scrollbars not to affect scrollWidth and scrollHeight
  dom.css(i.scrollbarXRail, 'display', 'none');
  dom.css(i.scrollbarYRail, 'display', 'none');

  updateGeometry(element);

  // Update top/left scroll to trigger events
  updateScroll(element, 'top', element.scrollTop);
  updateScroll(element, 'left', element.scrollLeft);

  dom.css(i.scrollbarXRail, 'display', '');
  dom.css(i.scrollbarYRail, 'display', '');
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var errors_1 = __webpack_require__(6);
var logging_1 = __webpack_require__(2);
function installUnhandled() {
    var original = window['onunhandledrejection'];
    window['onunhandledrejection'] = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (original) {
            try {
                original.apply(void 0, args);
            }
            catch (ex) {
                console.error(ex);
            }
        }
        var event = args[0];
        logging_1.logError(errors_1.BI_ERRORS.widget.unhandled.rejection, { reason: event && event.reason ? event.reason : 'reason unknown' });
    };
}
exports.installUnhandled = installUnhandled;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-mixed-operators */
var js_sdk_wrapper_1 = __webpack_require__(0);
var objects_1 = __webpack_require__(36);
/**
 * @deprecated
 * @param settings
 * @param player
 * @param forceUpdate
 * @param widgetRectHeight
 * @param prevSettings
 */
function setWidgetHeightOld(_a) {
    var settings = _a.settings, prevSettings = _a.prevSettings, player = _a.player, forceUpdate = _a.forceUpdate, widgetRectHeight = _a.widgetRectHeight;
    // The old resize
    var playerHeight = player.offsetHeight;
    var topPart = player.querySelector('#top-part');
    var topPartHeight = topPart.offsetHeight;
    var tracklist = player.querySelector('#tracklist');
    var tracklistHeight = tracklist ? tracklist.offsetHeight : 0;
    // TODO: This really needs to be removed, it knows too much about internal dom structure
    var tracklistWrapper = player.querySelector('#tracklist-wrapper');
    var tracklistWrapperHeight = tracklistWrapper ? tracklistWrapper.offsetHeight : 0;
    var bordersHeight = playerHeight - topPartHeight - tracklistWrapperHeight;
    var firstTrack = player.querySelector('.track, .no-tracks');
    var firstTrackHeight = firstTrack && firstTrack.offsetHeight || 0;
    var bottomPadding = player.getBottomPadding ? player.getBottomPadding() : 0;
    var playerMinHeight = topPartHeight + firstTrackHeight + bordersHeight - bottomPadding;
    var playerMaxHeight = topPartHeight + tracklistHeight + bordersHeight - bottomPadding;
    // forceUpdate === true - force new widget height
    // forceUpdate === false - check that at least one track is visible and widgetRectHeight <= playerHeight
    if (forceUpdate) {
        if (tracklistHeight !== tracklistWrapperHeight || widgetRectHeight > playerMaxHeight) {
            js_sdk_wrapper_1.WixSdk.setHeight(playerMaxHeight);
        }
        return;
    }
    if (objects_1.areObjectsEqual(prevSettings, {})) {
        return;
    }
    if (widgetRectHeight > playerHeight) {
        js_sdk_wrapper_1.WixSdk.setHeight(playerHeight);
        return;
    }
    if (objects_1.areObjectsEqual(prevSettings.rect, settings.rect) &&
        objects_1.areObjectsEqual(prevSettings.booleans, settings.booleans) &&
        objects_1.areObjectsEqual(prevSettings.numbers, settings.numbers)) {
        // no need to calculate height again
        return;
    }
    if (widgetRectHeight < playerMinHeight) {
        js_sdk_wrapper_1.WixSdk.setHeight(playerMinHeight);
    }
}
exports.setWidgetHeightOld = setWidgetHeightOld;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_sdk_wrapper_1 = __webpack_require__(0);
var site_storage_1 = __webpack_require__(62);
var PL = __webpack_require__(38);
var errors_1 = __webpack_require__(6);
var logging_1 = __webpack_require__(2);
var send_event_1 = __webpack_require__(10);
var objects_1 = __webpack_require__(36);
var oops_1 = __webpack_require__(37);
var url_1 = __webpack_require__(17);
var wix_sdk_1 = __webpack_require__(29);
var constants_1 = __webpack_require__(18);
var deprecated_1 = __webpack_require__(80);
var layout_values_1 = __webpack_require__(30);
var locale_1 = __webpack_require__(82);
var subscribe_to_player_events_1 = __webpack_require__(84);
var widget_resizer_1 = __webpack_require__(86);
var settings;
var prevSettings = {};
var player;
var siteStorage = new site_storage_1.SiteStorage('wmp');
function initPlayer(newSettings, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.forceUpdate, forceUpdate = _c === void 0 ? false : _c, experimentsPromise = _b.experimentsPromise, isAppOnPage = _b.isAppOnPage;
    var userId = js_sdk_wrapper_1.WixSdk.Utils.getUid();
    var instanceId = wix_sdk_1.getInstanceId();
    var biToken = wix_sdk_1.getBiToken();
    var compId = js_sdk_wrapper_1.WixSdk.Utils.getCompId();
    var locale = locale_1.getLocale();
    if (newSettings) {
        settings = newSettings;
    }
    if (!settings) {
        return;
    }
    settings.booleans = settings.booleans || {};
    return Promise.all([
        getAlbumId(),
        getPaymentsId(),
        getIsGetWindowEnabled(),
        js_sdk_wrapper_1.WixSdk.getSiteInfo(),
        js_sdk_wrapper_1.WixSdk.Activities.getUserSessionToken()
            .catch(function (reason) {
            logging_1.logError(errors_1.BI_ERRORS.tpa.wix.activities.getUserSessionToken, { reason: reason });
            var uid = js_sdk_wrapper_1.WixSdk.Utils.getUid() || js_sdk_wrapper_1.WixSdk.Utils.getInstanceValue('aid');
            return uid ? uid.replace(/-/g, '') : 'asaasasasasasasasasasasasasasasasa';
        }),
        js_sdk_wrapper_1.WixSdk.getBoundingRectAndOffsets(),
        experimentsPromise
    ])
        .then(function (_a) {
        var albumId = _a[0], paymentsId = _a[1], isGetWindowEnabled = _a[2], siteInfo = _a[3], sToken = _a[4], _b = _a[5], _c = _b.scale, scale = _c === void 0 ? 1 : _c, rect = _b.rect, experiments = _a[6];
        settings.experiments = experiments;
        settings.siteUrl = siteInfo.url;
        settings.trackPage = 'widget-track.html';
        settings.featureDisabledPage = 'widget-feature-disabled.html';
        settings.fbRedirectPage = 'fb-redirect.html';
        settings.instanceId = instanceId;
        settings.compId = compId;
        settings.userId = userId;
        settings.biToken = biToken;
        settings.sToken = sToken;
        settings.siteOwnerId = js_sdk_wrapper_1.WixSdk.Utils.getSiteOwnerId();
        settings.paymentsId = paymentsId;
        settings.isGetWindowEnabled = isGetWindowEnabled;
        settings.viewMode = js_sdk_wrapper_1.WixSdk.Utils.getViewMode();
        settings.isMobileView = js_sdk_wrapper_1.WixSdk.Utils.getDeviceType() === 'mobile';
        settings.locale = locale;
        settings.rect = rect;
        settings.scale = scale;
        settings.urlPrefixes = url_1.getUrlPrefixes();
        settings.width = widget_resizer_1.getNormalizedWidth(player, settings);
        var autoplay = settings.booleans.autoplay;
        settings.autoplay = autoplay && js_sdk_wrapper_1.WixSdk.Utils.getViewMode() !== 'editor' && isAppOnPage;
        ['colors', 'fonts'].forEach(function (prop) {
            settings[prop] = settings[prop] || {};
            try {
                var text = document.getElementById("default-" + prop).innerHTML.replace('/*', '').replace('*/', '');
                text = text.replace(/'.*?'/g, function (o) {
                    return o.replace(/"/g, '\\"');
                }).replace(/'/g, '"');
                var obj_1 = JSON.parse(text);
                Object.keys(obj_1).forEach(function (key) {
                    settings[prop][key] = obj_1[key];
                });
            }
            catch (ex) {
                // expected
            }
        });
        settings.albumId = albumId;
        var hasPreviousSettings = !objects_1.areObjectsEqual(prevSettings, {});
        if (hasPreviousSettings && prevSettings.booleans.showTrackList !== settings.booleans.showTrackList) {
            forceUpdate = true;
        }
        settings.shouldInitTracklistScroll = !forceUpdate;
        if (!objects_1.areObjectsEqual(prevSettings, settings) || forceUpdate) {
            return reInitPlayer(settings, albumId);
        }
    })
        .then(function (player) {
        if (!player || js_sdk_wrapper_1.WixSdk.Utils.getViewMode() !== 'editor') {
            return;
        }
        var widgetRectHeight = settings.rect.height;
        if (!widgetRectHeight) {
            // prevent resizing if widget is hidden and its height is zero
            return;
        }
        if (player.getDimensions) {
            return siteStorage.get('numberTracksShown')
                .then(function (numberTracksShown) {
                if (prevSettings.numbers &&
                    prevSettings.numbers.layout !== settings.numbers.layout) {
                    widget_resizer_1.resizeOnLayoutChange(settings, player);
                }
                else if (prevSettings.numbers &&
                    prevSettings.numbers.listLayoutTrackStyle !== settings.numbers.listLayoutTrackStyle) {
                    widget_resizer_1.resizeOnTrackStyleChange(settings, player);
                }
                else {
                    widget_resizer_1.resizeOnReInit(settings, player, forceUpdate, numberTracksShown);
                }
                layout_values_1.layoutValues[settings.numbers.layout || 0].width = settings.rect.width;
            });
        }
        return deprecated_1.setWidgetHeightOld({ settings: settings, prevSettings: prevSettings, player: player, forceUpdate: forceUpdate, widgetRectHeight: widgetRectHeight });
    })
        .then(function () {
        prevSettings = objects_1.cloneObject(settings);
    })
        .then(function () { return player; })
        .catch(function (reason) {
        if (reason && reason.message === 'Browser Not Supported') {
            oops_1.writeOops('Your browser is not supported');
            return Promise.reject(reason);
        }
        logging_1.logError(errors_1.BI_ERRORS.widget.init.reinit, { reason: reason });
        return Promise.reject(reason);
    });
}
exports.initPlayer = initPlayer;
function reInitPlayer(settings, collectionId) {
    var element = document.querySelector('wix-pl-app, .wix-pl-app, #WixMusicPlayerWidget');
    return PL.init(element, __assign({}, settings, { albumId: collectionId }))
        .then(function (_player) {
        logging_1.logPlayerStarted();
        exposePlayer(_player);
        subscribe_to_player_events_1.subscribeToPlayerEvents(_player);
        if (_player.statisticEvents) {
            send_event_1.logPlayerEvents(_player.statisticEvents, { sToken: settings.sToken });
        }
        if (_player.initCurrentTrack) {
            _player.initCurrentTrack();
        }
        return new Promise(function (resolve) {
            requestAnimationFrame(function () {
                resolve(_player);
            });
        });
    });
}
function getPaymentsId() {
    return siteStorage.get('paymentsId');
}
function getIsGetWindowEnabled() {
    return siteStorage.getDataPublic('isGetWindowEnabled');
}
function exposePlayer(_player) {
    player = _player;
    return player;
}
function getAlbumId() {
    return Promise.all([js_sdk_wrapper_1.WixSdk.getExternalId(), siteStorage.get('albumId'), getDemoAlbumId()])
        .then(function (_a) {
        var externalId = _a[0], dataAlbumId = _a[1], demoAlbumId = _a[2];
        var albumId = dataAlbumId || externalId;
        if (!albumId || albumId === constants_1.NO_ALBUM_ID) {
            return demoAlbumId;
        }
        return albumId;
    });
}
function getDemoAlbumId() {
    return siteStorage.get('demoAlbumId')
        .then(function (demoAlbumId) { return demoAlbumId || constants_1.DEMO_ALBUM_ID; });
}


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var js_sdk_wrapper_1 = __webpack_require__(0);
function getLocale() {
    var locale = js_sdk_wrapper_1.WixSdk.Utils.getLocale();
    if (!/^\w{2}$/.test(locale)) {
        return 'en';
    }
    return locale;
}
exports.getLocale = getLocale;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var js_sdk_wrapper_1 = __webpack_require__(0);
var functions_1 = __webpack_require__(3);
var constants_1 = __webpack_require__(18);
var layout_values_1 = __webpack_require__(30);
function subscribeToExternalEvents(_a) {
    var player = _a.player, initPlayer = _a.initPlayer, isAppOnPageChanged = _a.isAppOnPageChanged, preventUpdatesChanged = _a.preventUpdatesChanged;
    var wasPlaying;
    var compId = js_sdk_wrapper_1.WixSdk.Utils.getCompId();
    js_sdk_wrapper_1.WixSdk.PubSub.subscribe('modal.opened', function (event) {
        if (event.data.openerCompId === compId) {
            js_sdk_wrapper_1.WixSdk.PubSub.publish('widget.model-data', player.getModelData());
        }
    });
    js_sdk_wrapper_1.WixSdk.addEventListener(js_sdk_wrapper_1.WixSdk.Events.EDIT_MODE_CHANGE, function () {
        pausePlayer();
        initPlayer();
    });
    js_sdk_wrapper_1.WixSdk.addEventListener(js_sdk_wrapper_1.WixSdk.Events.DEVICE_TYPE_CHANGED, function () {
        initPlayer();
        layout_values_1.layoutValues[0].width = js_sdk_wrapper_1.WixSdk.Utils.getDeviceType() === 'mobile' ? 280 : constants_1.DEFAULT_VERTICAL_WIDTH;
    });
    js_sdk_wrapper_1.WixSdk.addEventListener(js_sdk_wrapper_1.WixSdk.Events.PAGE_NAVIGATION, function (event) {
        var isAppOnPage = event.isAppOnPage;
        isAppOnPageChanged(isAppOnPage);
        if (event.wasAppOnPage) {
            wasPlaying = player && player.isPlaying;
            pausePlayer();
        }
        if (event.isAppOnPage && wasPlaying && player && player.play) {
            player.play();
        }
    });
    js_sdk_wrapper_1.WixSdk.addEventListener(js_sdk_wrapper_1.WixSdk.Events.SETTINGS_UPDATED, function (data) {
        if (data === 'album:update' || data === 'control-panel:closed') {
            initPlayer(null, {
                forceUpdate: data === 'album:update'
            });
            return;
        }
        if (data === 'migrationStart') {
            preventUpdatesChanged(true);
            return;
        }
        if (data === 'migrationEnd') {
            location.reload();
            return;
        }
        if (data[0] === 'preview') {
            if (player) {
                player.emit('preview', data[1]);
            }
            return;
        }
        initPlayer();
    });
    js_sdk_wrapper_1.WixSdk.addEventListener(js_sdk_wrapper_1.WixSdk.Events.STYLE_PARAMS_CHANGE, functions_1.debounce(function (data) {
        initPlayer(data);
    }, 100));
    subscribe('playing', pausePlayer, false);
    ['playing', 'pause', 'playbacktoggle', 'prev', 'next', 'shuffle', 'loop'].forEach(function (eventName) {
        subscribe(eventName + ".track", function (data) {
            player.emit(eventName + ".track", data[0]);
        });
    });
    subscribe('timeupdate.track', function (data) {
        player.emit('timeupdate.track', data[0], data[1]);
    });
    function pausePlayer() {
        if (!player) {
            return;
        }
        if (player.pause) {
            player.pause(); // v2
        }
        else {
            if (player.playback) {
                player.playback.pause(); //v1
            }
        }
    }
    function subscribe(event, callback, onlyFromCurrentOrigin, receivePastEvents) {
        if (onlyFromCurrentOrigin === void 0) { onlyFromCurrentOrigin = true; }
        if (receivePastEvents === void 0) { receivePastEvents = false; }
        // onlyFromCurrentOrigin:true - subscribe only to this origin
        // onlyFromCurrentOrigin:false - subscribe only to other origins
        js_sdk_wrapper_1.WixSdk.PubSub.subscribe(event, function (e) {
            var origin = e.origin;
            var data = e.data;
            if (/\.track$/.test(event)) {
                origin = data[0];
                data = data.slice(1);
            }
            var isEventFromCurrentOrigin = origin === compId;
            if (player && isEventFromCurrentOrigin === onlyFromCurrentOrigin) {
                callback(data);
            }
        }, receivePastEvents);
    }
}
exports.subscribeToExternalEvents = subscribeToExternalEvents;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var js_sdk_wrapper_1 = __webpack_require__(0);
var url_1 = __webpack_require__(8);
var functions_1 = __webpack_require__(3);
var url_2 = __webpack_require__(17);
var wix_sdk_1 = __webpack_require__(29);
var constants_1 = __webpack_require__(18);
function subscribeToPlayerEvents(player) {
    player.on('modal', Wix.openModal); // eslint-disable-line no-undef
    player.on('popup', Wix.openPopup); // eslint-disable-line no-undef
    player.on('closePopup', js_sdk_wrapper_1.WixSdk.closeWindow);
    player.on('mobile.setHeight', function () {
        js_sdk_wrapper_1.WixSdk.setHeight(player.getDimensions().maxHeight);
    });
    player.on('widget:share', showModal('share'));
    player.on('widget:track-info', showModal('track-info', true));
    player.on('feature-disabled', showFeatureDisabledPopup);
    var events = [
        'playing',
        'pause',
        'playbacktoggle',
        'timeupdate',
        'progress',
        'prev',
        'next',
        'shuffle',
        'loop'
    ];
    events.forEach(function (event) {
        player.on(event, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            js_sdk_wrapper_1.WixSdk.PubSub.publish(event, args);
        });
    });
}
exports.subscribeToPlayerEvents = subscribeToPlayerEvents;
function showFeatureDisabledPopup() {
    var modalPath = url_2.getHostAndPath(true) + "widget-feature-disabled.html";
    wix_sdk_1.openPopup(modalPath, '100%', '100%', functions_1.noop, js_sdk_wrapper_1.WixSdk.Theme.BARE);
}
function showModal(type, displayInEditor) {
    if (displayInEditor === void 0) { displayInEditor = false; }
    return function (data) {
        var viewMode = js_sdk_wrapper_1.WixSdk.Utils.getViewMode();
        if (!displayInEditor && (viewMode === 'preview' || viewMode === 'editor')) {
            showFeatureDisabledPopup();
            return;
        }
        var modalPath = url_2.getHostAndPath(true) + "modals.html#/" + type;
        if (data) {
            modalPath += "?" + url_1.createParam(data);
        }
        wix_sdk_1.openModal(modalPath, constants_1.TRACK_PAGE_DIMENSIONS.WIDTH, constants_1.TRACK_PAGE_DIMENSIONS.HEIGHT, functions_1.noop, js_sdk_wrapper_1.WixSdk.Theme.BARE);
    };
}


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable no-mixed-operators */
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_sdk_wrapper_1 = __webpack_require__(0);
var experiment_manager_1 = __webpack_require__(61);
var PL = __webpack_require__(38);
var errors_1 = __webpack_require__(6);
var logging_1 = __webpack_require__(2);
var bi_1 = __webpack_require__(12);
var functions_1 = __webpack_require__(3);
var url_1 = __webpack_require__(17);
var wix_sdk_1 = __webpack_require__(29);
var init_player_1 = __webpack_require__(81);
var subscribe_to_external_events_1 = __webpack_require__(83);
function init() {
    js_sdk_wrapper_1.WixSdk.Performance.applicationLoadingStep(1, 'page-loaded');
    try {
        PL.errorReporter.on('error', logging_1.logError);
        PL.appStatus.on('metric', logging_1.logMetricToNewRelic);
        logging_1.addNewRelicAttributes();
    }
    catch (reason) {
        logging_1.logError(errors_1.BI_ERRORS.widget.init.statisticSubscribe, { reason: reason });
    }
    var EXPERIMENTS_DISABLED = false;
    var isAppOnPage = true;
    var preventUpdates = false;
    var promise = Promise.resolve();
    var getViewMode = js_sdk_wrapper_1.WixSdk.Utils.getViewMode;
    var experimentsPromise = EXPERIMENTS_DISABLED ? Promise.resolve() :
        experiment_manager_1.getExperiments('wix-music', 500)
            .catch(function (err) {
            console.warn(err); // eslint-disable-line no-console
            logging_1.logMetricToNewRelic('experiment-load-timeout');
            return {};
        });
    function initPlayer(newSettings, _a) {
        var _b = (_a === void 0 ? {} : _a).forceUpdate, forceUpdate = _b === void 0 ? false : _b;
        if (preventUpdates) {
            return promise;
        }
        promise = promise
            .catch(function (reason) {
            console.error(reason);
        })
            .then(function () {
            return init_player_1.initPlayer(newSettings, { forceUpdate: forceUpdate, experimentsPromise: experimentsPromise, isAppOnPage: isAppOnPage });
        });
        return promise;
    }
    if (getViewMode() === 'editor' || getViewMode() === 'preview') {
        window.addEventListener('resize', functions_1.debounce(function () {
            initPlayer();
        }, 1000));
    }
    Promise.all([
        js_sdk_wrapper_1.WixSdk.Styles.getStyleParams(),
        js_sdk_wrapper_1.WixSdk.getSiteInfo()
            .catch(function (reason) {
            logging_1.logError(errors_1.BI_ERRORS.tpa.wix.siteInfo.get, { reason: reason });
            return null;
        })
    ])
        .then(function (_a) {
        var styleParams = _a[0], siteInfo = _a[1];
        styleParams = __assign({}, styleParams);
        js_sdk_wrapper_1.WixSdk.Performance.applicationLoadingStep(2, 'style-params-loaded');
        var sharedTrackId = url_1.getSharedTrackId(siteInfo);
        if (sharedTrackId) {
            styleParams.sharedTrackId = sharedTrackId;
            wix_sdk_1.scrollToPlayer();
        }
        return initPlayer(styleParams)
            .then(function (player) {
            subscribe_to_external_events_1.subscribeToExternalEvents({
                player: player,
                initPlayer: initPlayer,
                isAppOnPageChanged: function (_isAppOnPage) {
                    isAppOnPage = _isAppOnPage;
                },
                preventUpdatesChanged: function (_preventUpdates) {
                    preventUpdates = _preventUpdates;
                }
            });
            js_sdk_wrapper_1.WixSdk.Performance.applicationLoaded();
        });
    })
        .catch(function (reason) {
        if (reason && reason.message === 'Browser Not Supported') {
            bi_1.sendPlayerStartedEvent();
            js_sdk_wrapper_1.WixSdk.Performance.applicationLoaded();
            return;
        }
        logging_1.logError(errors_1.BI_ERRORS.widget.init.initial, { reason: reason });
    });
}
exports.init = init;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var js_sdk_wrapper_1 = __webpack_require__(0);
var constants_1 = __webpack_require__(18);
var layout_values_1 = __webpack_require__(30);
function _isFullWidth(settings) {
    return settings.booleans.isFullWidth && settings.numbers.layout === constants_1.LAYOUTS_LIST;
}
function resizeWidget(settings, newDimensions) {
    var width = newDimensions.width, height = newDimensions.height;
    if (width) {
        settings.rect.width = width;
    }
    if (height) {
        settings.rect.height = height;
    }
    var isResizeAllowed = !_isFullWidth(settings) && js_sdk_wrapper_1.WixSdk.Utils.getViewMode() === 'editor';
    if (height && !isResizeAllowed) {
        js_sdk_wrapper_1.WixSdk.setHeight(height);
    }
    else if (width || height) {
        js_sdk_wrapper_1.WixSdk.resizeComponent(newDimensions);
    }
}
function resizeWidgetWidth(settings, width) {
    settings.rect.width = width;
    js_sdk_wrapper_1.WixSdk.resizeComponent({ width: width });
}
function resizeOnTrackStyleChange(settings, player) {
    var newDimensions = player.getDimensionsForFullTracks();
    resizeWidget(settings, newDimensions);
}
exports.resizeOnTrackStyleChange = resizeOnTrackStyleChange;
var isNextResizeEnabled = true;
function resizeOnLayoutChange(settings, player, retry) {
    if (retry === void 0) { retry = true; }
    var currentLayout = settings.numbers.layout || constants_1.LAYOUTS_VERTICAL;
    var numberTracksShown = (constants_1.LAYOUT_DEFAULTS[currentLayout] || {}).defaultNumberTracksShown;
    var currentWidth = (constants_1.LAYOUT_DEFAULTS[currentLayout] || {}).defaultWidth || layout_values_1.layoutValues[currentLayout].width;
    if (currentLayout === constants_1.LAYOUTS_VERTICAL && retry) {
        // for vertical layout we first want to resize a width, so the album cover
        // would get its proportion and therefore set its height
        // after that it can calculate the needed height accordingly
        resizeWidgetWidth(settings, currentWidth);
        player.onNextFrame(function () {
            resizeOnLayoutChange(settings, player, false);
            // We need to disable next-time resize, otherwise it will
            // resize with the general rules (expand to full height).
            isNextResizeEnabled = false;
        });
        return;
    }
    var minMaxDimensions = player.getDimensions({ minimalTrackCount: numberTracksShown });
    var newDimensions = {
        width: getWidth(settings, minMaxDimensions, currentWidth),
        height: getHeight(settings, minMaxDimensions, numberTracksShown)
    };
    resizeWidget(settings, newDimensions);
}
exports.resizeOnLayoutChange = resizeOnLayoutChange;
function resizeOnReInit(settings, player, forceUpdate, numberTracksShown) {
    if (!isNextResizeEnabled) {
        isNextResizeEnabled = true;
        return;
    }
    var newDimensions;
    if (forceUpdate) {
        var minMaxDimensions = player.getDimensions({ minimalTrackCount: numberTracksShown });
        newDimensions = {
            width: getWidth(settings, minMaxDimensions),
            height: forceUpdate ? minMaxDimensions.maxHeight : getHeight(settings, minMaxDimensions, numberTracksShown)
        };
    }
    else {
        newDimensions = player.getDimensionsForFullTracks();
    }
    resizeWidget(settings, newDimensions);
}
exports.resizeOnReInit = resizeOnReInit;
function getNormalizedWidth(player, settings) {
    var width;
    if (player && player.getDimensions) {
        var minMaxDimensions = player.getDimensions();
        width = getWidth(settings, minMaxDimensions);
    }
    return width || settings.rect.width;
}
exports.getNormalizedWidth = getNormalizedWidth;
function getWidth(settings, dimensions, currentWidth) {
    var width = currentWidth;
    currentWidth = currentWidth || Math.round(settings.rect.width / settings.scale);
    if (dimensions.minWidth && currentWidth < dimensions.minWidth) {
        width = dimensions.minWidth;
    }
    else if (dimensions.maxWidth && currentWidth > dimensions.maxWidth) {
        width = dimensions.maxWidth;
    }
    return width;
}
function getHeight(settings, dimensions, numberTracksShown) {
    var height;
    var rectHeight = Math.round(settings.rect.height / settings.scale);
    if (rectHeight < dimensions.minHeight || numberTracksShown) {
        height = dimensions.minHeight;
    }
    else if (rectHeight > dimensions.maxHeight) {
        height = dimensions.maxHeight;
    }
    return height;
}


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./wix-music-widget-0.js": [
		93,
		8
	],
	"./wix-music-widget-1.js": [
		94,
		7
	],
	"./wix-music-widget-2.js": [
		95,
		6
	],
	"./wix-music-widget-3.js": [
		96,
		5
	],
	"./wix-music-widget-4.js": [
		97,
		4
	],
	"./wix-music-widget-5.js": [
		98,
		3
	],
	"./wix-music-widget-6.js": [
		99,
		2
	],
	"./wix-music-widget-7.js": [
		100,
		1
	],
	"./wix-music-widget-8.js": [
		101,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 87;

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(40);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// widget-player.bundle.min.js